"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenManageableItemsByDictionary = exports.flattenManageableItemsByCheckItem = exports.flattenManageableItemsBySliderItem = exports.flattenManageableItemsByConstantItem = exports.flattenManageableItemsBySingleSelectItem = exports.flattenManageableItemsByItem = exports.flattenManageableItemsBySection = exports.flattenVisibilityManageableItemsByItem = exports.flattenManageableItems = exports.retrieveManageableItemSpec = exports.flattenExportableItems = exports.flattenCapturableItems = exports.flattenAllItems = exports.retrieveCapturableItemSpec = exports.retrieveVisitsByDomainId = exports.retrieveVisitByCode = exports.retrieveVisitByPath = exports.retrieveCrfPageByPath = exports.retrieveCrfPageIdByDomainId = exports.retrieveEnrollCrfPage = exports.getVisitSearchItems = exports.getConditionalItemReferenceByMixed = exports.edcDateFormat = exports.isCrfDateItemFormat = exports.isAvailableForUnblindReleaseConditions = exports.isAvailableFor = exports.isDisableFor = exports.isReadonlyFor = exports.getRelatedItemIdsForAvailability = exports.isAvailableCondFor = exports.getBreakRowsCols = exports.getBreaksRows = exports.getGridRowFromBreaks = exports.getUiVal = exports.getCalcVal = exports.getCrfVisitLabel = exports.validateDoubleTextFormat = exports.validateTextFormat = exports.handleValidateTextItemInputByNumberType = exports.convertToTextFormat = exports.removeDbPrefixAndSuffix = exports.getDecimalInputRange = exports.getNaturalNumberMaxLen = exports.getConditionalDescription = exports.getConditionalLabel = exports.getCrfVisitCode = exports.getCrfLabel = exports.getLabel = exports.nullishNumber = exports.hasOwnProperty = void 0;
exports.isMatchedPostCaptureConditional = exports.getFormattedTimeUiVal = exports.getMedicalCodingColumnSpec = exports.getAuthorizedStudySites = exports.getCalculateRelatedIds = exports.getCaptureItemReplaceConfirmMessage = exports.getItemVal = exports.getItemCalcVal = exports.getItemDbVal = exports.auditTrailAuditMapper = exports.auditTrailReasonConverter = exports.crfValueMapper = exports.getCrfValueByCrfCapturableItemSpec = exports.CRF_VALUE_MAPPER_DATA_NULL = exports.CRF_VALUE_MAPPER_DATA_UNDEFINED = exports.checkUnblindReqPreAvailability = exports.checkCrfWritability = exports.checkVisibility = exports.arrayify = exports.retrieveParentItemLabel = exports.getItemDataDbTypeByFlattenItem = exports.getItemVariableTypeByFlattenItem = exports.crfTextItemPrefixReplacement = exports.getItemLayoutByFlattenItem = exports.isRequiredByFlattenItem = exports.getItemCodesByFlattenItem = exports.retrieveParentItemLabelByPath = exports.retrieveItemLabelByPath = exports.flattenManageableItemsByAttachment = void 0;
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
const decimal_js_1 = require("decimal.js");
const uuid_1 = require("uuid");
const common_1 = require("./common");
const crf_1 = require("./crf");
const __1 = require("..");
const entity_1 = require("../../dto/entity");
const utils_1 = require("../../utils");
const _1 = require(".");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const dayjs_1 = __importDefault(require("dayjs"));
const lodash_1 = require("lodash");
dayjs_1.default.extend(utc_1.default);
class CapturedItemNotFoundError {
}
class InvalidCalcOperand {
}
const NotEnglishRegex = /[^A-Za-z]/g;
const NotEnglishAndNumberRegex = /[^A-Za-z0-9]/g;
/** @deprecated 속성 존재 여부를 확인하려면 'in'을 사용하세요. */
function hasOwnProperty(obj, prop) {
    return obj && Object.prototype.hasOwnProperty.call(obj, prop);
}
exports.hasOwnProperty = hasOwnProperty;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function nullishNumber(v, defaultVal = null) {
    return typeof v === "number" ? v : defaultVal;
}
exports.nullishNumber = nullishNumber;
function getLabel(label, lang) {
    return typeof label === "object" ? (label ? label[lang || "en"] : null) : label;
}
exports.getLabel = getLabel;
function getCrfLabel(label, lang) {
    return typeof label === "object" ? (label ? label[lang || "en"] : null) : label;
}
exports.getCrfLabel = getCrfLabel;
function getCrfVisitCode(folderId, visitId, visitSeq, specOr) {
    var _a;
    let spec;
    if (hasOwnProperty(specOr, "folders")) {
        spec = (_a = retrieveVisitByPath(specOr, { folderId, visitId })) === null || _a === void 0 ? void 0 : _a.code;
    }
    else {
        spec = specOr;
    }
    if (!spec && typeof spec !== "number")
        return null;
    return typeof spec === "number" ? spec : spec.minval + (spec.step || 1) * (visitSeq - 1);
}
exports.getCrfVisitCode = getCrfVisitCode;
function getConditionalLabel(spec, on) {
    if (!spec || !on)
        return null;
    if (Array.isArray(spec)) {
        for (let i = 0; i < spec.length; i += 1) {
            const cond = spec[i];
            if (hasOwnProperty(cond, "text") && (!cond.availability || checkVisibility(cond.availability, { visit: on }))) {
                return getCrfLabel(cond.text);
            }
        }
    }
    else {
        if (hasOwnProperty(spec, "text")) {
            if (spec.availability)
                return checkVisibility(spec.availability, { visit: on }) ? getCrfLabel(spec.text) : null;
            else
                return getCrfLabel(spec.text);
        }
        return getCrfLabel(spec);
    }
    return null;
}
exports.getConditionalLabel = getConditionalLabel;
function getConditionalDescription(spec, on) {
    if (!spec || !on)
        return null;
    const candidates = arrayify(spec);
    const matches = candidates.reduce((p, e) => {
        if (typeof e === "string" || hasOwnProperty(e, "color") || !e.availability)
            p.push(e);
        else if (checkVisibility(e.availability, { visit: on }))
            p.push(e.text);
        return p;
    }, []);
    return (matches === null || matches === void 0 ? void 0 : matches.length) > 0 ? matches : null;
}
exports.getConditionalDescription = getConditionalDescription;
function getNaturalNumberMaxLen(format) {
    if ((format === null || format === void 0 ? void 0 : format.type) === "NATURAL_NUMBER") {
        if (format.interface === "NUMBER") {
            const maxlen = (() => {
                if (format.maxlen) {
                    return format.maxlen;
                }
                else if (typeof format.minval === "number" && typeof format.maxval === "number") {
                    if (format.minval >= 0) {
                        return Math.max(String(format.minval).length, String(format.maxval).length);
                    }
                    else {
                        if (format.maxval >= 0) {
                            return Math.max(String(format.minval).length - 1, String(format.maxval).length);
                        }
                        else {
                            return Math.max(String(format.minval).length - 1, String(format.maxval).length - 1);
                        }
                    }
                }
                else if (typeof format.maxval === "number") {
                    if (format.maxval >= 0) {
                        return String(format.maxval).length;
                    }
                    else {
                        return String(format.maxval).length - 1;
                    }
                }
                return common_1.IntegerMaxLen;
            })();
            return maxlen;
        }
    }
    return common_1.IntegerMaxLen;
}
exports.getNaturalNumberMaxLen = getNaturalNumberMaxLen;
function getDecimalInputRange(format) {
    if (format.type === "DECIMAL") {
        const integerPartLen = (() => {
            if (!format.precision) {
                if (format.scale)
                    return common_1.DecimalMaxLen - format.scale;
                else
                    return common_1.DecimalMaxLen;
            }
            else if (!format.scale) {
                return format.precision;
            }
            return format.precision - format.scale;
        })();
        const fractionPartLen = (() => {
            if (!format.scale)
                return 0;
            return format.scale;
        })();
        return [integerPartLen, fractionPartLen];
    }
    return null;
}
exports.getDecimalInputRange = getDecimalInputRange;
function removeDbPrefixAndSuffix(dbVal, item) {
    let converted = dbVal;
    if (converted && typeof converted === "string") {
        if (hasOwnProperty(item, "dbPrefix") && converted.startsWith(item.dbPrefix)) {
            converted = converted.slice(item.dbPrefix.length);
        }
        if (hasOwnProperty(item, "dbSuffix") && converted.endsWith(item.dbSuffix)) {
            converted = converted.slice(0, item.dbSuffix.length * -1);
        }
    }
    return converted;
}
exports.removeDbPrefixAndSuffix = removeDbPrefixAndSuffix;
function convertToTextFormat(v, format) {
    var _a, _b, _c, _d, _e, _f, _g;
    let nv = v || "";
    if ((format === null || format === void 0 ? void 0 : format.type) === "CHAR") {
        if (format.interface === "NUMBER") {
            nv = nv.replace(/[^\d]/g, "");
            if (typeof format.maxlen === "number") {
                nv = nv.slice(0, format.maxlen);
            }
        }
    }
    else if ((format === null || format === void 0 ? void 0 : format.type) === "NATURAL_NUMBER") {
        if (format.interface === "NUMBER") {
            const maxlen = getNaturalNumberMaxLen(format);
            const negative = nv && nv.length > 0 && nv[0] === "-";
            nv = nv.replace(/[^\d]/g, "");
            if (maxlen >= 0) {
                nv = nv.slice(0, maxlen);
            }
            nv = negative ? `-${nv}` : nv;
        }
    }
    else if ((format === null || format === void 0 ? void 0 : format.type) === "DECIMAL") {
        if (format.interface === "NUMBER") {
            const negative = nv && nv.length > 0 && nv[0] === "-";
            if (nv.includes(".")) {
                nv = nv.replace(/[^\d.]/g, "");
                const pos = nv.indexOf(".");
                nv = nv.replace(/[^\d]/g, "").slice(0, pos) + "." + nv.replace(/[^\d]/g, "").slice(pos);
            }
            else {
                nv = nv.replace(/[^\d]/g, "");
            }
            while (nv && nv.length > 0 && nv[0] === ".") {
                nv = nv.slice(1);
            }
            const [integerPartLen, fractionPartLen] = getDecimalInputRange(format);
            if (nv.includes(".")) {
                let front = nv.split(".")[0] || "";
                let back = nv.split(".")[1] || "";
                if (front.length <= integerPartLen) {
                    // 소숫점 추가됐을 때 정수 부분 보존하기 위해 front.length <= integerPartLen 조건 필요
                    front = front.slice(0, integerPartLen);
                }
                if (back.length <= fractionPartLen) {
                    // 소숫점 추가됐을 때 소숫점 이하 자리 보존하기 위해 back.length <= fractionPartLen 조건 필요
                    back = back.slice(0, fractionPartLen);
                }
                nv = front + "." + back;
            }
            else {
                if (nv.length <= integerPartLen) {
                    // 소숫점 삭제됐을 때 소숫점 이하 자리 보존하기 위해 nv.length <= integerPartLen 조건 필요
                    nv = nv.slice(0, integerPartLen);
                }
            }
            nv = negative ? `-${nv}` : nv;
        }
    }
    else if ((format === null || format === void 0 ? void 0 : format.type) === "TEXT") {
        nv = nv.slice(0, format.maxlen);
        if (format.transform === "UPPERCASE") {
            nv = nv.toUpperCase();
        }
        else if (((_a = format.transform) === null || _a === void 0 ? void 0 : _a.regex.pattern) === "[^A-Za-z]" ||
            ((_b = format.transform) === null || _b === void 0 ? void 0 : _b.regex.pattern) === crf_1.CrfTextItemTransformPattern.OnlyEnglish) {
            const cleaned = nv.replace(NotEnglishRegex, "");
            const caseConversion = ((_c = format.transform.transformOpts) === null || _c === void 0 ? void 0 : _c.caseConversion) === "UPPER"
                ? cleaned.toUpperCase()
                : ((_d = format.transform.transformOpts) === null || _d === void 0 ? void 0 : _d.caseConversion) === "LOWER"
                    ? cleaned.toLowerCase()
                    : cleaned;
            nv = caseConversion;
        }
        else if (((_e = format.transform) === null || _e === void 0 ? void 0 : _e.regex.pattern) === crf_1.CrfTextItemTransformPattern.OnlyEnglishAndNumber) {
            const cleaned = nv.replace(NotEnglishAndNumberRegex, "");
            const caseConversion = ((_f = format.transform.transformOpts) === null || _f === void 0 ? void 0 : _f.caseConversion) === "UPPER"
                ? cleaned.toUpperCase()
                : ((_g = format.transform.transformOpts) === null || _g === void 0 ? void 0 : _g.caseConversion) === "LOWER"
                    ? cleaned.toLowerCase()
                    : cleaned;
            nv = caseConversion;
        }
    }
    return nv;
}
exports.convertToTextFormat = convertToTextFormat;
function handleValidateTextItemInputByNumberType(type, value, isPositive) {
    const NATURAL_NUMBER_POSITIVE_REGEX = /^(0|[1-9]\d*)$/;
    const NATURAL_NUMBER_NEGATIVE_REGEX = /^((-|0|-0)|-?(?!0\d)[1-9]\d*)$/;
    const DECIMAL_POSITIVE_REGEX = /^(0|[1-9]\d*)(\.\d*)?$/;
    const DECIMAL_NEGATIVE_REGEX = /^((-|0|-0)|-?(?!0\d)[1-9]\d*)(\.\d*)?$/;
    const positiveNumberRegex = type === "NATURAL_NUMBER" ? NATURAL_NUMBER_POSITIVE_REGEX : DECIMAL_POSITIVE_REGEX;
    const negativeNumberRegex = type === "NATURAL_NUMBER" ? NATURAL_NUMBER_NEGATIVE_REGEX : DECIMAL_NEGATIVE_REGEX;
    const numberRegex = isPositive ? positiveNumberRegex : negativeNumberRegex;
    return numberRegex.test(value);
}
exports.handleValidateTextItemInputByNumberType = handleValidateTextItemInputByNumberType;
function validateTextFormat(val, format) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const defaultErrMessage = "";
    let errMessage = null;
    let isCorrected = true;
    const resMessage = (msg) => {
        if (format === null || format === void 0 ? void 0 : format.disableQuery) {
            return null;
        }
        return (msg || defaultErrMessage).split("$$").join(String(val));
    };
    if (val && format) {
        errMessage = ((_a = format.message) === null || _a === void 0 ? void 0 : _a.invalid) || errMessage;
        if (format.type === "TEXT") {
            const chkMaxlen = !format.maxlen || format.maxlen >= String(val).length;
            const chkMinlen = !format.minlen || format.minlen <= String(val).length;
            isCorrected = chkMaxlen && chkMinlen;
            if (isCorrected) {
                if (format.transform === "UPPERCASE") {
                    isCorrected = String(val).toUpperCase() === String(val);
                }
                else if (((_b = format.transform) === null || _b === void 0 ? void 0 : _b.regex.pattern) === "[^A-Za-z]" ||
                    ((_c = format.transform) === null || _c === void 0 ? void 0 : _c.regex.pattern) === crf_1.CrfTextItemTransformPattern.OnlyEnglish) {
                    isCorrected = !NotEnglishRegex.test(String(val));
                    if (isCorrected && ((_d = format.transform.transformOpts) === null || _d === void 0 ? void 0 : _d.caseConversion) === "UPPER") {
                        isCorrected = String(val).toUpperCase() === String(val);
                    }
                    if (isCorrected && ((_e = format.transform.transformOpts) === null || _e === void 0 ? void 0 : _e.caseConversion) === "LOWER") {
                        isCorrected = String(val).toLowerCase() === String(val);
                    }
                }
                else if (((_f = format.transform) === null || _f === void 0 ? void 0 : _f.regex.pattern) === crf_1.CrfTextItemTransformPattern.OnlyEnglishAndNumber) {
                    isCorrected = !NotEnglishAndNumberRegex.test(String(val));
                    if (isCorrected && ((_g = format.transform.transformOpts) === null || _g === void 0 ? void 0 : _g.caseConversion) === "UPPER") {
                        isCorrected = String(val).toUpperCase() === String(val);
                    }
                    if (isCorrected && ((_h = format.transform.transformOpts) === null || _h === void 0 ? void 0 : _h.caseConversion) === "LOWER") {
                        isCorrected = String(val).toLowerCase() === String(val);
                    }
                }
            }
        }
        else if (format.type === "CHAR") {
            const chkMaxlen = !format.maxlen || format.maxlen >= String(val).length;
            const chkMinlen = !format.minlen || format.minlen <= String(val).length;
            isCorrected = chkMaxlen && chkMinlen;
        }
        else if (format.type === "DECIMAL") {
            const origin = Number(val);
            const [parsed, parsedStr] = ((v) => {
                if (String(v).includes("."))
                    return [v, String(v)];
                else if (String(val).includes("."))
                    return [v, `${v}.${parseInt(String(val).split(".")[1], 10) || 0}`];
                else
                    return [v, String(v)];
            })(parseFloat(val));
            const [integerPartLen, fractionPartLen, restLen] = String(`${val}${!String(val).includes(".") ? "." : ""}`)
                .split(".")
                .map(x => x.length);
            let isIntegerPartCorrected = true;
            let isFractionPartCorrected = true;
            if (!isNaN(parsed) && format.integerPart) {
                const [minIntegerPartLen, maxIntegerPartLen] = format.integerPart;
                isIntegerPartCorrected = (integerPartLen || 0) >= minIntegerPartLen && (integerPartLen || 0) <= maxIntegerPartLen;
            }
            if (!isNaN(parsed) && format.fractionPart) {
                const minFractionPartLen = format.fractionPart[0];
                const maxFractionPartLen = format.fractionPart[1];
                isFractionPartCorrected = (fractionPartLen || 0) >= minFractionPartLen && (fractionPartLen || 0) <= maxFractionPartLen;
            }
            isCorrected =
                !isNaN(origin) &&
                    !isNaN(parsed) &&
                    (String(parsedStr) === String(val) || String(val) === String(parsedStr).padEnd(String(val).length, "0")) &&
                    isIntegerPartCorrected &&
                    isFractionPartCorrected &&
                    typeof restLen !== "number" &&
                    (typeof format.minval !== "number" || parsed >= format.minval) &&
                    (typeof format.maxval !== "number" || parsed <= format.maxval);
        }
        else if (format.type === "NATURAL_NUMBER") {
            const chkMaxlen = !format.maxlen || format.maxlen >= String(val).length;
            const chkMinlen = !format.minlen || format.minlen <= String(val).length;
            const origin = Number(val);
            const parsed = parseInt(val, 10);
            isCorrected =
                chkMaxlen &&
                    chkMinlen &&
                    !isNaN(origin) &&
                    !isNaN(parsed) &&
                    String(parsed) === String(val) &&
                    (typeof format.minval !== "number" || parsed >= format.minval) &&
                    (typeof format.maxval !== "number" || parsed <= format.maxval);
        }
        else {
            return [false, resMessage(errMessage)];
        }
    }
    else {
        return [true, resMessage(errMessage)];
    }
    return [isCorrected, isCorrected ? null : resMessage(errMessage)];
}
exports.validateTextFormat = validateTextFormat;
/** @deprecated */
function validateDoubleTextFormat(val, delimiter, format) {
    var _a;
    const defaultErrMessage = "";
    const firstText = val.split(delimiter)[0];
    const secondText = val.split(delimiter)[1];
    const resMessage = (msg) => {
        if (format === null || format === void 0 ? void 0 : format.disableQuery) {
            return null;
        }
        return (msg || defaultErrMessage).split("$$").join(String(val));
    };
    if (!format || !val) {
        return [true, null];
    }
    let isCorrected = true;
    const errMessage = (_a = format.message) === null || _a === void 0 ? void 0 : _a.invalid;
    for (const v of [firstText, secondText]) {
        if (!v) {
            return [false, resMessage(errMessage)];
        }
        if (format.type === "DECIMAL") {
            const origin = Number(v);
            const parsed = parseFloat(v);
            const [integerPartLen, fractionPartLen, restLen] = String(`${val}${!String(val).includes(".") ? "." : ""}`)
                .split(".")
                .map(x => x.length);
            let isIntegerPartCorrected = true;
            let isFractionPartCorrected = true;
            if (!isNaN(parsed) && format.integerPart) {
                const [minIntegerPartLen, maxIntegerPartLen] = format.integerPart;
                isIntegerPartCorrected = integerPartLen >= minIntegerPartLen && integerPartLen <= maxIntegerPartLen;
            }
            if (!isNaN(parsed) && format.fractionPart) {
                const minFractionPartLen = format.fractionPart[0];
                const maxFractionPartLen = format.fractionPart[1];
                isFractionPartCorrected = fractionPartLen >= minFractionPartLen && fractionPartLen <= maxFractionPartLen;
            }
            isCorrected =
                !isNaN(origin) &&
                    !isNaN(parsed) &&
                    isIntegerPartCorrected &&
                    isFractionPartCorrected &&
                    typeof restLen !== "number" &&
                    (typeof format.minval !== "number" || parsed >= format.minval) &&
                    (typeof format.maxval !== "number" || parsed <= format.maxval);
        }
        else if (format.type === "NATURAL_NUMBER") {
            const origin = Number(v);
            const parsed = parseInt(v, 10);
            isCorrected =
                !isNaN(origin) &&
                    !isNaN(parsed) &&
                    String(parsed) === String(v) &&
                    (typeof format.minval !== "number" || parsed >= format.minval) &&
                    (typeof format.maxval !== "number" || parsed <= format.maxval);
        }
        else {
            return [false, resMessage(errMessage)];
        }
        if (!isCorrected)
            break;
    }
    return [isCorrected, isCorrected ? null : resMessage(errMessage)];
}
exports.validateDoubleTextFormat = validateDoubleTextFormat;
function getCrfVisitLabel(folderId, visitId, visitSeq, specOr) {
    var _a;
    let spec;
    if (hasOwnProperty(specOr, "folders")) {
        spec = (_a = retrieveVisitByPath(specOr, { folderId, visitId })) === null || _a === void 0 ? void 0 : _a.label;
    }
    else {
        spec = specOr;
    }
    if (!spec && typeof spec !== "number")
        return `${visitId}${visitSeq}`;
    return typeof spec === "number" || typeof spec === "string"
        ? String(spec)
        : `${spec.prefix || ""}${String(spec.minval + visitSeq - 1).padStart(spec.minlen, "0")}${spec.suffix || ""}`;
}
exports.getCrfVisitLabel = getCrfVisitLabel;
function getOpVal(on, operand, captures, pendingCaptures) {
    if (operand.operator) {
        const op = operand;
        return calcVal(op.operator, on, op.left, op.right, op.round, op.scale, captures, pendingCaptures);
    }
    else {
        const op = operand;
        if (op.conditional) {
            const matched = isMatchedOpValConditional(on, op.conditional, captures, pendingCaptures);
            if (!matched) {
                return null;
            }
        }
        const getValOf = (val) => {
            if (op.valOf === "YEARS") {
                return parseInt(val.slice(0, 4), 10);
            }
            else if (op.valOf === "MONTHS") {
                return parseInt(val.slice(4, 6), 10);
            }
            else if (op.valOf === "DAYS") {
                return parseInt(val.slice(6, 8), 10);
            }
            else if (op.valOf === "MMDD") {
                return val.slice(4, 8);
            }
            else if (hasOwnProperty(op.valOf, "delimiter")) {
                let converted = val;
                if (hasOwnProperty(op.valOf, "dbSuffix")) {
                    converted = removeDbPrefixAndSuffix(val, { dbSuffix: op.valOf.dbSuffix });
                }
                const vs = String(converted || typeof converted === "number" ? String(converted) : "").split(op.valOf.delimiter);
                return vs[op.valOf.index - 1];
            }
            else if (hasOwnProperty(op.valOf, "dbSuffix")) {
                return removeDbPrefixAndSuffix(val, { dbSuffix: op.valOf.dbSuffix });
            }
            else {
                return val;
            }
        };
        if (op.operand === null)
            return null;
        if (op.operand === "CURRENT_DATE") {
            if (op.valOf === "YEARS") {
                return (0, dayjs_1.default)().year();
            }
            else if (op.valOf === "MONTHS") {
                return (0, dayjs_1.default)().month() + 1;
            }
            else if (op.valOf === "DAYS") {
                return (0, dayjs_1.default)().date();
            }
            else if (op.valOf === "MMDD") {
                return (0, dayjs_1.default)().format("MMDD");
            }
            else {
                return (0, dayjs_1.default)().format("YYYYMMDD");
            }
        }
        else if (typeof op.operand === "object" && op.operand) {
            if (hasOwnProperty(op.operand, "function") || hasOwnProperty(op.operand, "operator")) {
                return getCalcVal(op.operand, on, captures, pendingCaptures);
            }
            if (hasOwnProperty(op.operand, "folderId")) {
                const id = {
                    folderId: (() => {
                        if (typeof op.operand.folderId === "string")
                            return op.operand.folderId;
                        else if (op.operand.folderId.reserved === "CURRENT")
                            return on.folderId;
                        throw new Error(`Not Supprted op.operand.folderId(${op.operand.folderId}), "getOpVal"`);
                    })(),
                    visitId: (() => {
                        if (typeof op.operand.visitId === "string")
                            return op.operand.visitId;
                        else if (op.operand.visitId.reserved === "CURRENT")
                            return on.visitId;
                        throw new Error(`Not Supprted op.operand.visitId(${op.operand.visitId}), "getOpVal"`);
                    })(),
                    visitSeq: (() => {
                        if (typeof op.operand.visitSeq === "number")
                            return op.operand.visitSeq;
                        else if (op.operand.visitSeq.reserved === "CURRENT")
                            return on.visitSeq;
                        throw new Error(`Not Supprted op.operand.visitSeq(${op.operand.visitSeq}), "getOpVal"`);
                    })(),
                    crfPageId: (() => {
                        if (typeof op.operand.crfPageId === "string")
                            return op.operand.crfPageId;
                        throw new Error(`Not Supprted op.operand.crfPageId(${op.operand.crfPageId}), "getOpVal"`);
                    })(),
                    crfPageSeq: (() => {
                        if (!op.operand.crfPageSeq)
                            return common_1.InitialCrfPageSequence;
                        else if (typeof op.operand.crfPageSeq === "number")
                            return op.operand.crfPageSeq;
                        else if (op.operand.crfPageSeq.reserved === "CURRENT")
                            return on.crfPageSeq;
                        throw new Error(`Not Supprted op.operand.crfPageSeq(${op.operand.crfPageSeq}), "getOpVal"`);
                    })(),
                    sectionId: op.operand.sectionId,
                    itemId: op.operand.itemId,
                    itemSeq: (() => {
                        if (typeof op.operand.itemSeq === "number")
                            return op.operand.itemSeq;
                        else if (op.operand.itemSeq.reserved === "CURRENT")
                            return on.itemSeq;
                        throw new Error(`Not Supprted op.operand.itemSeq(${op.operand.itemSeq}), "getOpVal"`);
                    })(),
                };
                const val = (() => {
                    const capture = (pendingCaptures === null || pendingCaptures === void 0 ? void 0 : pendingCaptures.find(e => id.folderId === e.folderId &&
                        id.visitId === e.visitId &&
                        id.visitSeq === e.visitSeq &&
                        id.crfPageId === e.crfPageId &&
                        ("crfPageSeq" in id && id.crfPageSeq ? id.crfPageSeq === e.crfPageSeq : true) &&
                        id.sectionId === e.sectionId &&
                        id.itemId === e.itemId &&
                        id.itemSeq === e.itemSeq)) ||
                        captures.find(e => id.folderId === e.folderId &&
                            id.visitId === e.visitId &&
                            id.visitSeq === e.visitSeq &&
                            id.crfPageId === e.crfPageId &&
                            ("crfPageSeq" in id && id.crfPageSeq ? id.crfPageSeq === e.crfPageSeq : true) &&
                            id.sectionId === e.sectionId &&
                            id.itemId === e.itemId &&
                            id.itemSeq === e.itemSeq);
                    if (!capture) {
                        return undefined;
                    }
                    else if (capture.calcVal || typeof capture.calcVal === "number") {
                        return capture.calcVal;
                    }
                    return capture.dbVal;
                })();
                // NOTE: 프론트에서 특정 값을 삭제하고 저장하지 않았거나, 저장된 값이 없는경우 null을 리턴하여 상위에서 operator별 항등원 사용(나누기의 경우 항등원이 없기 때문에 사용불가.)
                if ((op === null || op === void 0 ? void 0 : op.ignoreNotFoundError) && (val === null || val === undefined)) {
                    return null;
                }
                if (!val && typeof val !== "number") {
                    throw new CapturedItemNotFoundError();
                }
                return getValOf(val);
            }
            else {
                const operand = op.operand;
                const val = (() => {
                    const capture = (pendingCaptures === null || pendingCaptures === void 0 ? void 0 : pendingCaptures.find(e => e.itemId === operand.id && (operand.sameSeq ? e.itemSeq === on.itemSeq : e.itemSeq === common_1.InitialItemSequence))) ||
                        captures.find(e => e.itemId === operand.id && (operand.sameSeq ? e.itemSeq === on.itemSeq : e.itemSeq === common_1.InitialItemSequence));
                    if (!capture) {
                        return undefined;
                    }
                    else if (capture.calcVal || typeof capture.calcVal === "number") {
                        return capture.calcVal;
                    }
                    return capture.dbVal;
                })();
                // NOTE: 프론트에서 특정 값을 삭제하고 저장하지 않았거나, 저장된 값이 없는경우 null을 리턴하여 상위에서 operator별 항등원 사용(나누기의 경우 항등원이 없기 때문에 사용불가.)
                if ((op === null || op === void 0 ? void 0 : op.ignoreNotFoundError) && (val === null || val === undefined)) {
                    return null;
                }
                if (!val && typeof val !== "number") {
                    throw new CapturedItemNotFoundError();
                }
                return getValOf(val);
            }
        }
        else if (typeof op.operand === "number") {
            return op.operand;
        }
        else if (typeof op.operand === "string") {
            return op.operand;
        }
        throw new InvalidCalcOperand();
    }
}
function isMatchedOpValConditional(on, conditional, captures, pendingCaptures) {
    if (hasOwnProperty(conditional, "condition")) {
        const coLv = getOpVal(on, conditional.left, captures, pendingCaptures);
        const coRv = getOpVal(on, conditional.right, captures, pendingCaptures);
        let matched = false;
        if (conditional.condition === "!=") {
            const l = coLv || typeof coLv === "number" ? String(coLv) : coLv;
            const r = coRv || typeof coRv === "number" ? String(coRv) : coRv;
            matched = l !== r;
        }
        if (conditional.condition === "=") {
            const l = coLv || typeof coLv === "number" ? String(coLv) : coLv;
            const r = coRv || typeof coRv === "number" ? String(coRv) : coRv;
            matched = l === r;
        }
        if (conditional.condition === ">")
            matched = new bignumber_js_1.default(coLv).isGreaterThan(coRv);
        if (conditional.condition === ">=")
            matched = new bignumber_js_1.default(coLv).isGreaterThanOrEqualTo(coRv);
        if (conditional.condition === "<")
            matched = new bignumber_js_1.default(coLv).isLessThan(coRv);
        if (conditional.condition === "<=")
            matched = new bignumber_js_1.default(coLv).isLessThanOrEqualTo(coRv);
        if (!matched) {
            return false;
        }
    }
    else if (hasOwnProperty(conditional, "operator")) {
        let matched = undefined;
        if (conditional.operator === "AND") {
            matched = true;
            for (const expr of conditional.expr) {
                if (!isMatchedOpValConditional(on, expr, captures, pendingCaptures)) {
                    matched = false;
                }
            }
        }
        else if (conditional.operator === "OR") {
            matched = false;
            for (const expr of conditional.expr) {
                if (isMatchedOpValConditional(on, expr, captures, pendingCaptures)) {
                    matched = true;
                }
            }
        }
        else {
            throw new Error(`NOT SUPPORTED, isMatchedOpValConditional conditional.operator(${conditional.operator})`);
        }
        if (!matched) {
            return false;
        }
    }
    return true;
}
function getRounding(round) {
    // Rounds away from zero
    if (round === "UP")
        return 0;
    // Rounds towards zero
    else if (round === "DOWN")
        return 1;
    // Rounds towards Infinity
    else if (round === "CEIL")
        return 2;
    // Rounds towards -Infinity
    else if (round === "FLOOR")
        return 3;
    // Rounds towards nearest neighbour. If equidistant, rounds away from zero
    else if (round === "HALF_UP")
        return 4;
    // Rounds towards nearest neighbour. If equidistant, rounds towards zero
    else if (round === "HALF_DOWN")
        return 5;
    else
        return 4;
}
function calcVal(op, on, left, right, round, scale, captures, pendingCaptures) {
    try {
        const lv = (() => {
            if (Array.isArray(left)) {
                const l = left.find(e => getOpVal(on, e, captures, pendingCaptures) !== null);
                if (l) {
                    return getOpVal(on, l, captures, pendingCaptures);
                }
                return null;
            }
            else if (hasOwnProperty(left, "function")) {
                return calcValByFunc(left, on, captures, pendingCaptures);
            }
            else {
                return getOpVal(on, left, captures, pendingCaptures);
            }
        })();
        const rv = (() => {
            if (Array.isArray(right)) {
                const r = right.find(e => getOpVal(on, e, captures, pendingCaptures) !== null);
                if (r) {
                    return getOpVal(on, r, captures, pendingCaptures);
                }
                return null;
            }
            else if (hasOwnProperty(right, "function")) {
                return calcValByFunc(right, on, captures, pendingCaptures);
            }
            else {
                return getOpVal(on, right, captures, pendingCaptures);
            }
        })();
        const rounding = getRounding(round);
        const calcVal = ((lvv, rvv) => {
            lvv = lvv === null ? (op === "+" || op === "-" || op === "%" ? 0 : 1) : lvv;
            rvv = rvv === null ? (op === "+" || op === "-" || op === "%" ? 0 : 1) : rvv;
            const li = new bignumber_js_1.default(lvv);
            const ri = new bignumber_js_1.default(rvv);
            if (op === "+")
                return li.plus(ri);
            else if (op === "-")
                return li.minus(ri);
            else if (op === "*")
                return li.times(ri);
            else if (op === "/")
                return li.div(ri);
            else if (op === "^")
                return new bignumber_js_1.default(decimal_js_1.Decimal.pow(li.toFixed(), ri.toFixed()).toFixed());
            else
                throw new Error(`NOT SUPPORTED, calcVal(${op})`);
        })(lv, rv);
        if (calcVal.isNaN() || !calcVal.isFinite()) {
            throw new InvalidCalcOperand();
        }
        return calcVal.dp(typeof scale === "number" ? scale : 100, rounding).toFixed();
    }
    catch (e) {
        if (e instanceof Error) {
            // if needed ...
        }
        throw e;
    }
}
function calcValByFunc(calculate, on, captures, pendingCaptures) {
    try {
        if (calculate.function === "ABS") {
            const val = getOpVal(on, calculate.operand, captures, pendingCaptures);
            if (val !== null && val !== undefined && !Number.isNaN(val) && !Number.isNaN(parseFloat(String(val)))) {
                return new bignumber_js_1.default(val).abs().toFixed();
            }
            return null;
        }
        else if (calculate.function === "MAX") {
            const operands = calculate.operands.map(op => getOpVal(on, op, captures, pendingCaptures)).filter(e => e !== null);
            return (operands === null || operands === void 0 ? void 0 : operands.length) > 0 ? bignumber_js_1.default.max.apply(null, operands).toFixed() : null;
        }
        else if (calculate.function === "MIN") {
            const operands = calculate.operands.map(op => getOpVal(on, op, captures, pendingCaptures)).filter(e => e !== null);
            return (operands === null || operands === void 0 ? void 0 : operands.length) > 0 ? bignumber_js_1.default.min.apply(null, operands).toFixed() : null;
        }
        else if (calculate.function === "AVERAGE") {
            let cnt = 0;
            const sum = calculate.operands.reduce((sum, op) => {
                const val = getOpVal(on, op, captures, pendingCaptures);
                if (val !== null && val !== undefined && !Number.isNaN(val) && !Number.isNaN(parseFloat(String(val)))) {
                    cnt += 1;
                    return sum.plus(val);
                }
                return sum;
            }, new bignumber_js_1.default(0));
            if (cnt === 0)
                return null;
            const rounding = getRounding(calculate.round);
            return sum
                .div(cnt)
                .dp(typeof calculate.scale === "number" ? calculate.scale : 100, rounding)
                .toFixed();
        }
        else if (calculate.function === "SUM") {
            let cnt = 0;
            const sum = calculate.operands.reduce((sum, op) => {
                const val = getOpVal(on, op, captures, pendingCaptures);
                if (val !== null && val !== undefined && !Number.isNaN(val) && !Number.isNaN(parseFloat(String(val)))) {
                    cnt += 1;
                    return sum.plus(val);
                }
                return sum;
            }, new bignumber_js_1.default(0));
            if (cnt === 0)
                return null;
            return sum.toFixed();
        }
        else if (calculate.function === "SELECT") {
            for (const op of calculate.operands) {
                const val = getOpVal(on, op, captures, pendingCaptures);
                if (val !== null && val !== undefined && !Number.isNaN(val) && !Number.isNaN(parseFloat(String(val)))) {
                    return new bignumber_js_1.default(val).toFixed();
                }
            }
            return null;
        }
        else if (calculate.function === "CHOICE") {
            const key = getOpVal(on, calculate.operand, captures, pendingCaptures);
            if (key !== null && key !== undefined) {
                const val = calculate.values[key];
                return val === null || val === undefined ? null : String(calculate.values[key]);
            }
            return null;
        }
        else if (calculate.function === "CONCAT") {
            const str = calculate.operands.reduce((s, op) => {
                const val = getOpVal(on, op, captures, pendingCaptures);
                if (val !== null && val !== undefined) {
                    return s + String(val);
                }
                return s;
            }, "");
            return str;
        }
        throw new Error(`NOT SUPPORTED, calcValByFunc(${calculate.function})`);
    }
    catch (e) {
        if (e instanceof Error) {
            // if needeed
        }
        throw e;
    }
}
function getCalcVal(calculate, on, captures, pendingCaptures) {
    try {
        if (hasOwnProperty(calculate, "function")) {
            return calcValByFunc(calculate, on, captures, pendingCaptures);
        }
        else {
            return calcVal(calculate.operator, on, calculate.left, calculate.right, calculate.round, calculate.scale, captures, pendingCaptures);
        }
    }
    catch (e) {
        return null;
    }
}
exports.getCalcVal = getCalcVal;
function getUiVal(crfPage, id, dbVal) {
    var _a;
    if (dbVal === null || dbVal === undefined)
        return dbVal;
    const section = crfPage.sections.find(e => e.id === id.sectionId);
    const item = flattenManageableItemsBySection(section).find(e => e.id === id.itemId);
    // NOTE. 저장 가능한 새로운 유형의 CrfItem이 추가될 경우 아래 코드에 정의해야 함
    if (item.original.type === "TEXT" && item.original.id === id.itemId) {
        return `${item.original.uiPrefix || ""}${dbVal}${item.original.uiSuffix || ""}`;
    }
    // DOUBLE_TEXT type is deprecated
    else if (item.original.type === "DOUBLE_TEXT" && item.original.id === id.itemId) {
        return dbVal;
    }
    else if (item.original.type === "DATE" && item.original.id === id.itemId) {
        return dbVal ? edcDateFormat(String(dbVal), item.original.format || "YYYY/MM/DD") : "";
    }
    else if (item.original.type === "TIME" && item.original.id === id.itemId) {
        return `${item.original.uiPrefix || ""}${dbVal}${item.original.uiSuffix || ""}`;
    }
    else if (item.original.type === "FORMATTED_TIME" && item.original.id === id.itemId) {
        return getFormattedTimeUiVal(item.original, String(dbVal || ""));
    }
    else if (item.original.type === "SINGLE_SELECT" && item.original.id === id.itemId) {
        if (item.original.itemCode.null && String(item.original.itemCode.null.dbVal) === String(dbVal)) {
            return item.original.itemCode.null.uiVal;
        }
        return (_a = item.original.itemCode.codes.find(e => String(e.dbVal) === String(dbVal))) === null || _a === void 0 ? void 0 : _a.uiVal;
    }
    else if (item.original.type === "ATTACHMENT" && item.original.id === id.itemId) {
        return typeof dbVal === "string" && dbVal.includes(common_1.EdcAttachmentAttributeDelimiter)
            ? (vals => vals.slice(0, -2).join(common_1.EdcAttachmentAttributeDelimiter))(dbVal.split(common_1.EdcAttachmentAttributeDelimiter))
            : "";
    }
    else if (item.original.type === "SYS_VAL" && item.original.id === id.itemId) {
        return dbVal;
    }
    else if (item.original.type === "CHECK") {
        const code = item.original.itemCode.codes.find(e => e.id === id.itemId && String(e.dbVal) === String(dbVal));
        if (code) {
            return code.uiVal;
        }
    }
    else if (item.original.type === "AUTO_TEXT" && item.original.id === id.itemId) {
        return `${item.original.uiPrefix || ""}${dbVal}${item.original.uiSuffix || ""}`;
    }
    else if (item.original.type === "SEQUENCE") {
        return dbVal;
    }
    else if (item.original.type === "DICTIONARY") {
        return dbVal;
    }
    else if (item.original.type === "SLIDER") {
        return dbVal;
    }
    return dbVal;
}
exports.getUiVal = getUiVal;
function getGridRowFromBreaks(items, breaksAttr) {
    const CHAR_CODE_A = 65;
    const breaks = (() => {
        if (!(breaksAttr === null || breaksAttr === void 0 ? void 0 : breaksAttr.length)) {
            return items.map(() => 1);
        }
        else {
            return breaksAttr.map(e => e);
        }
    })();
    const maxWeights = breaks.map(() => 1);
    const maxRowCount = (0, utils_1.getLeastCommonMultiple)(breaks);
    const gridItems = [];
    const tempGridTemplateAreas = Array.from({ length: breaks.length }, () => []);
    let position = -1;
    const transposeMatrix = (matrix) => matrix.reduce((result, row) => row.map((_, i) => [...(result[i] || []), row[i]]), [[]]);
    for (let i = 0; i < items.length; i++) {
        const item = items[i];
        const weight = (() => {
            if (typeof (item === null || item === void 0 ? void 0 : item.weight) === "number") {
                return item.weight;
            }
            if ((item === null || item === void 0 ? void 0 : item.weight) && "val" in item.weight) {
                return item.weight.val;
            }
            return 1;
        })();
        for (let j = 0; j < breaks.length; j++) {
            if (position++ === breaks.length - 1) {
                position = 0;
            }
            const gridRow = maxRowCount / breaks[position];
            if (tempGridTemplateAreas[position].length < maxRowCount) {
                const gridAreaAlphabet = String.fromCharCode(CHAR_CODE_A + i);
                for (let j = 0; j < gridRow; j++) {
                    tempGridTemplateAreas[position].push(gridAreaAlphabet);
                }
                gridItems.push({ ...item, gridArea: gridAreaAlphabet });
                if (weight > maxWeights[position]) {
                    maxWeights[position] = weight;
                }
                break;
            }
        }
    }
    const transposedTempGridTemplateAreas = transposeMatrix(tempGridTemplateAreas);
    const transposedGridTemplateAreas = transposedTempGridTemplateAreas.map(arr => `${arr.length ? `"${arr.join(" ")}"` : ""}`).join(" ");
    return { cols: gridItems, weights: maxWeights, gridTemplateAreas: transposedGridTemplateAreas };
}
exports.getGridRowFromBreaks = getGridRowFromBreaks;
// TODO: DW에서는 Grid CSS가 동작하지 않아 Table 구조로 개선된 함수입니다. prince에서 grid 지원하게 된다면 div로 바꾸고 getGridRowFromBreaks함수를 사용하는 방향으로 통합이 필요합니다.
function getBreaksRows(items, breaksAttr) {
    const breaks = (() => {
        if (!(breaksAttr === null || breaksAttr === void 0 ? void 0 : breaksAttr.length)) {
            return items.map(() => 1);
        }
        return breaksAttr;
    })();
    const maxWeights = breaks.map(() => 1);
    const maxRowCount = items.length ? (0, utils_1.getLeastCommonMultiple)(breaks) : 0;
    const calcRowSpans = Array(breaks.length).fill(0);
    const tableRows = Array.from({ length: maxRowCount }, () => []);
    let currentBreakIndex = 0;
    items.forEach(item => {
        for (let i = 0; i < breaks.length; i++) {
            const rowSpan = maxRowCount / breaks[currentBreakIndex];
            const calcMaxBreak = calcRowSpans[currentBreakIndex];
            if (calcMaxBreak + rowSpan <= maxRowCount) {
                const weight = (() => {
                    if (typeof (item === null || item === void 0 ? void 0 : item.weight) === "number") {
                        return item.weight;
                    }
                    if ((item === null || item === void 0 ? void 0 : item.weight) && "val" in item.weight) {
                        return item.weight.val;
                    }
                    return 1;
                })();
                tableRows[calcMaxBreak].push({ ...item, rowSpan, breakIndex: currentBreakIndex });
                calcRowSpans[currentBreakIndex] += rowSpan;
                if (weight > maxWeights[currentBreakIndex]) {
                    maxWeights[currentBreakIndex] = weight;
                }
                if (currentBreakIndex++ === breaks.length - 1) {
                    currentBreakIndex = 0;
                }
                break;
            }
            if (currentBreakIndex++ === breaks.length - 1) {
                currentBreakIndex = 0;
            }
        }
    });
    const sortedTableRows = tableRows.map(tableRow => {
        tableRow.sort((a, b) => a["breakIndex"] - b["breakIndex"]);
        return tableRow.map(row => (0, lodash_1.omit)(row, ["breakIndex"]));
    });
    return { tableRows: sortedTableRows, weights: maxWeights };
}
exports.getBreaksRows = getBreaksRows;
/** @deprecated
 * breaks 속성이 있는 Table Item(Table, Appendable Table)은 getBreakRowsColsOfTableItem 메서드로 변경
 * 해당 메서드는 아직 CDMS의 Dictionary Item 쪽에서 사용되고 있음
 */
function getBreakRowsCols(items, breaksAttr) {
    const breaks = (() => {
        if (!breaksAttr) {
            return items.map(() => 1);
        }
        else {
            return breaksAttr.map(e => e);
        }
    })();
    const rowsCols = (() => {
        var _a;
        const values = [];
        let rows = 1;
        if (!breaks) {
            const value = [];
            for (let i = 0; i < breaks.length; i++) {
                value.push({
                    idx: i,
                    rowspan: 1,
                    weight: typeof items[i].weight === "object" ? `${items[i].weight.val}px` : items[i].weight,
                });
            }
            values.push(value);
        }
        else {
            for (let i = 0; i < breaks.length; i++) {
                rows = Math.max(rows, breaks[i]);
            }
            let idx = -1;
            for (let j = 0; j < rows; j++) {
                const value = [];
                for (let i = 0; i < breaks.length; i++) {
                    if (breaks[i] > 0) {
                        breaks[i]--;
                        const rowspan = rows - breaks[i] - j;
                        const index = ++idx;
                        const weight = ((_a = items[index]) === null || _a === void 0 ? void 0 : _a.weight) || 0;
                        value.push({ idx: index, rowspan, weight: typeof weight === "object" ? `${weight.val}px` : weight });
                    }
                    else {
                        value.push({ idx: null, rowspan: 0, weight: 0 });
                    }
                }
                values.push(value);
            }
        }
        return values;
    })();
    const weights = "*"
        .repeat(rowsCols[0].length)
        .split("")
        .map((_, i) => rowsCols.map(e => (typeof e[i].weight === "string" ? e[i].weight : null)).filter(e => e)[0] ||
        Math.max(...rowsCols.map(e => (typeof e[i].weight === "number" ? e[i].weight : 0))));
    const weightSum = weights.reduce((p, e) => p + (typeof e === "number" ? e : 0), 0);
    return { rowsCols, weights, weightSum };
}
exports.getBreakRowsCols = getBreakRowsCols;
function isAvailableCondFor(studySpec, items, availability, on) {
    if (availability.operator === "AND") {
        for (const exp of availability.expr) {
            const isOk = isAvailableCondFor(studySpec, items, exp, on);
            if (!isOk) {
                return false;
            }
        }
        return true;
    }
    else if (availability.operator === "OR") {
        for (const exp of availability.expr) {
            if (isAvailableCondFor(studySpec, items, exp, on)) {
                return true;
            }
        }
    }
    else if (availability.operator === "!=" ||
        availability.operator === "<" ||
        availability.operator === "<=" ||
        availability.operator === ">" ||
        availability.operator === ">=" ||
        availability.operator === "=") {
        const leftRefIdOrVal = (() => {
            if (hasOwnProperty(availability.left, "reserved")) {
                if (availability.left.reserved === "CURRENT_VISIT") {
                    return getCrfVisitCode(on.folderId, on.visitId, on.visitSeq, studySpec);
                }
                else {
                    throw new Error(`NOT SUPPORTED, isAvailableCondFor(${availability.left.reserved})`);
                }
            }
            return getConditionalItemReferenceByMixed(availability.left, on);
        })();
        const rightRefIdOrVal = getConditionalItemReferenceByMixed(availability.right, on);
        const leftOp = ((idOrVal, v) => {
            if (!idOrVal)
                return v;
            else {
                if (typeof idOrVal === "number") {
                    return idOrVal;
                }
                else {
                    const found = items.find(e => e.folderId === idOrVal.folderId &&
                        e.visitId === idOrVal.visitId &&
                        e.visitSeq === idOrVal.visitSeq &&
                        e.crfPageId === idOrVal.crfPageId &&
                        ("crfPageSeq" in idOrVal && idOrVal.crfPageSeq ? e.crfPageSeq === idOrVal.crfPageSeq : true) &&
                        e.sectionId === idOrVal.sectionId &&
                        e.itemId === idOrVal.itemId &&
                        ((idOrVal.itemSeq === null && e.itemSeq === on.itemSeq) || e.itemSeq === idOrVal.itemSeq));
                    return found ? found.dbVal : null;
                }
            }
        })(leftRefIdOrVal, availability.left);
        const rightOps = ((idOrVal, v) => {
            if (!idOrVal)
                return v;
            else {
                if (typeof idOrVal === "number") {
                    return idOrVal;
                }
                else {
                    const found = items.find(e => e.folderId === idOrVal.folderId &&
                        e.visitId === idOrVal.visitId &&
                        e.visitSeq === idOrVal.visitSeq &&
                        e.crfPageId === idOrVal.crfPageId &&
                        ("crfPageSeq" in idOrVal && idOrVal.crfPageSeq ? e.crfPageSeq === idOrVal.crfPageSeq : true) &&
                        e.sectionId === idOrVal.sectionId &&
                        e.itemId === idOrVal.itemId &&
                        ((idOrVal.itemSeq === null && e.itemSeq === on.itemSeq) || e.itemSeq === idOrVal.itemSeq));
                    return found ? found.dbVal : null;
                }
            }
        })(rightRefIdOrVal, availability.right);
        const comp = (() => {
            for (const op of arrayify(rightOps)) {
                if (availability.operator === "=" && leftOp === null && op === null) {
                    return true;
                }
                else if (availability.operator === "!=") {
                    if (String(leftOp) === String(op))
                        return false;
                }
                else if (availability.operator === "<") {
                    if (new bignumber_js_1.default(leftOp).lt(op))
                        return true;
                }
                else if (availability.operator === "<=") {
                    if (new bignumber_js_1.default(leftOp).lte(op))
                        return true;
                }
                else if (availability.operator === ">") {
                    if (new bignumber_js_1.default(leftOp).gt(op))
                        return true;
                }
                else if (availability.operator === ">=") {
                    if (new bignumber_js_1.default(leftOp).gte(op))
                        return true;
                }
                else if (availability.operator === "=") {
                    if (new bignumber_js_1.default(leftOp).eq(op) || (typeof leftOp === "string" && typeof op === "string" && leftOp === op))
                        return true;
                }
                else
                    throw new Error(`Not Supported isAvailableFor(${availability.operator})`);
            }
            return availability.operator === "!=" ? true : false;
        })();
        return comp;
    }
    return false;
}
exports.isAvailableCondFor = isAvailableCondFor;
function getRelatedItemIdsForAvailability(availability, on) {
    if (!availability)
        return [];
    const res = [];
    for (const ava of arrayify(availability)) {
        if (hasOwnProperty(ava, "ref")) {
            if (ava.ref === "ITEM") {
                res.push({
                    ...on,
                    sectionId: on.sectionId || null,
                    itemId: ava.id,
                    itemSeq: ava.seq || on.itemSeq || common_1.InitialItemSequence,
                });
            }
            else {
                throw new Error(`NOT SUPPORTED, getRelatedItemIdsForAvailability(${JSON.stringify(ava)})`);
            }
        }
        else if (hasOwnProperty(ava, "operator")) {
            if (ava.operator === "AND" || ava.operator === "OR") {
                for (const subAva of ava.expr) {
                    res.push(...getRelatedItemIdsForAvailability(subAva, on));
                }
            }
            else if (ava.operator === "!=" ||
                ava.operator === "<" ||
                ava.operator === "<=" ||
                ava.operator === ">" ||
                ava.operator === ">=" ||
                ava.operator === "=") {
                const leftRefId = getConditionalItemReferenceByMixed(ava.left, on);
                const rightRefId = getConditionalItemReferenceByMixed(ava.right, on);
                if (leftRefId)
                    res.push({ ...leftRefId, itemSeq: leftRefId.itemSeq === null ? on.itemSeq : leftRefId.itemSeq });
                if (rightRefId)
                    res.push({ ...rightRefId, itemSeq: rightRefId.itemSeq === null ? on.itemSeq : rightRefId.itemSeq });
            }
        }
    }
    return res;
}
exports.getRelatedItemIdsForAvailability = getRelatedItemIdsForAvailability;
function isReadonlyFor(studySpec, capturedItems, pendingItems, availability, on) {
    return isAvailableFor(studySpec, capturedItems, pendingItems, availability, on);
}
exports.isReadonlyFor = isReadonlyFor;
function isDisableFor(studySpec, capturedItems, pendingItems, disability, on) {
    if (!disability || (Array.isArray(disability) && disability.length === 0))
        return false;
    return isAvailableFor(studySpec, capturedItems, pendingItems, disability, on);
}
exports.isDisableFor = isDisableFor;
function isAvailableFor(studySpec, capturedItems, pendingItems, availability, on) {
    if (!availability)
        return true;
    const items = (0, lodash_1.uniqWith)(pendingItems.concat(capturedItems), (a, b) => a.folderId === b.folderId &&
        a.visitId === b.visitId &&
        a.visitSeq === b.visitSeq &&
        a.crfPageId === b.crfPageId &&
        a.crfPageSeq === b.crfPageSeq &&
        a.itemId === b.itemId &&
        a.itemSeq === b.itemSeq);
    for (const ava of arrayify(availability)) {
        const conditionMatched = (() => {
            if (hasOwnProperty(ava, "operator")) {
                return isAvailableCondFor(studySpec, items, ava, on);
            }
            else {
                const dbVal = (() => {
                    if (ava.ref === "ITEM") {
                        const found = items.find(x => x.itemId === ava.id && !x.deleted && ((!ava.seq && x.itemSeq === on.itemSeq) || x.itemSeq === ava.seq));
                        return found ? found.dbVal : null;
                    }
                    else {
                        throw new Error(`Not Supported {availability.ref}(${ava.ref})`);
                    }
                })();
                return ((cond, opss) => {
                    const ops = arrayify(opss);
                    // operand로 Null 포함하는 경우
                    if (cond === null && !!ops.map(x => ({ val: x })).find(x => x.val === null)) {
                        return true;
                    }
                    for (const op of ops) {
                        if (cond === "!=") {
                            if (String(dbVal) !== String(op))
                                return true;
                        }
                        else if (cond === "<") {
                            if (new bignumber_js_1.default(dbVal).lt(op))
                                return true;
                        }
                        else if (cond === "<=") {
                            if (new bignumber_js_1.default(dbVal).lte(op))
                                return true;
                        }
                        else if (cond === ">") {
                            if (new bignumber_js_1.default(dbVal).gt(op))
                                return true;
                        }
                        else if (cond === ">=") {
                            if (new bignumber_js_1.default(dbVal).gte(op))
                                return true;
                        }
                        else if (cond === "=") {
                            if (new bignumber_js_1.default(dbVal).eq(op) || (typeof dbVal === "string" && typeof op === "string" && dbVal === op))
                                return true;
                        }
                        else
                            throw new Error(`Not Supported isAvailableFor(${cond})`);
                    }
                    return false;
                })(ava.condition, ava.operand);
            }
        })();
        if (conditionMatched === false) {
            return false;
        }
    }
    return true;
}
exports.isAvailableFor = isAvailableFor;
function isAvailableForUnblindReleaseConditions(items, availability, on) {
    if (!availability)
        return true;
    for (const ava of arrayify(availability)) {
        const conditionMatched = (() => {
            const dbVal = (() => {
                if (ava.ref === "ITEM") {
                    const found = items.find(x => x.itemId === ava.id && ((!ava.seq && x.itemSeq === on.itemSeq) || x.itemSeq === ava.seq));
                    return found ? found.dbVal : null;
                }
                else {
                    throw new Error(`Not Supported {availability.ref}(${ava.ref})`);
                }
            })();
            return ((cond, opss) => {
                const ops = arrayify(opss);
                // operand로 Null 포함하는 경우
                if (cond === null && !!ops.map(x => ({ val: x })).find(x => x.val === null)) {
                    return true;
                }
                for (const op of ops) {
                    if (cond === "!=") {
                        if (String(dbVal) !== String(op))
                            return true;
                    }
                    else if (cond === "<") {
                        if (new bignumber_js_1.default(dbVal).lt(op))
                            return true;
                    }
                    else if (cond === "<=") {
                        if (new bignumber_js_1.default(dbVal).lte(op))
                            return true;
                    }
                    else if (cond === ">") {
                        if (new bignumber_js_1.default(dbVal).gt(op))
                            return true;
                    }
                    else if (cond === ">=") {
                        if (new bignumber_js_1.default(dbVal).gte(op))
                            return true;
                    }
                    else if (cond === "=") {
                        if (new bignumber_js_1.default(dbVal).eq(op) || (typeof dbVal === "string" && typeof op === "string" && dbVal === op))
                            return true;
                    }
                    else
                        throw new Error(`Not Supported isAvailableForUnblindReleaseConditions(${cond})`);
                }
                return false;
            })(ava.condition, ava.operand);
        })();
        if (conditionMatched === false) {
            return false;
        }
    }
    return true;
}
exports.isAvailableForUnblindReleaseConditions = isAvailableForUnblindReleaseConditions;
// TODO: CrfDateItemFormat 타입을 체크하는 곳에 적용 필요. 타입도 enum으로 빼서 동적으로 체크할 수 있도록 수정 필요.
function isCrfDateItemFormat(format) {
    return (typeof format === "string" &&
        (format === "YYYY/MM/DD" ||
            format === "YYYY/MM" ||
            format === "YYYY-MM-DD" ||
            format === "YYYY-MM" ||
            format === "DD-MMM-YYYY" ||
            format === "DD/MMM/YYYY" ||
            format === "YYYY" ||
            format === "MMM/YYYY"));
}
exports.isCrfDateItemFormat = isCrfDateItemFormat;
function edcDateFormat(date, format = "YYYY/MM/DD") {
    if (!date)
        return null;
    if (format === "YYYY/MM/DD") {
        if (date.length <= 4) {
            return `${date.slice(0, 4)}/UK/UK`;
        }
        else if (date.length <= 6) {
            return `${date.slice(0, 4)}/${date.slice(4, 6)}/UK`;
        }
        else {
            return `${date.slice(0, 4)}/${date.slice(4, 6)}/${date.slice(6, 8)}`;
        }
    }
    else if (format === "YYYY/MM") {
        if (date.length <= 4) {
            return `${date.slice(0, 4)}/UK`;
        }
        else if (date.length <= 6) {
            return `${date.slice(0, 4)}/${date.slice(4, 6)}`;
        }
    }
    else if (format === "YYYY-MM-DD") {
        if (date.length <= 4) {
            return `${date.slice(0, 4)}-UK-UK`;
        }
        else if (date.length <= 6) {
            return `${date.slice(0, 4)}-${date.slice(4, 6)}-UK`;
        }
        else {
            return `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`;
        }
    }
    else if (format === "YYYY-MM-DD HH:mm") {
        if (date.length <= 4) {
            return `${date.slice(0, 4)}-UK-UK`;
        }
        else if (date.length <= 6) {
            return `${date.slice(0, 4)}-${date.slice(4, 6)}-UK`;
        }
        else if (date.length <= 8) {
            return `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`;
        }
        else {
            return `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)} ${date.slice(8, 10)}:${date.slice(10, 12)}`;
        }
    }
    else if (format === "YYYY-MM") {
        if (date.length <= 4) {
            return `${date.slice(0, 4)}-UK`;
        }
        else if (date.length <= 6) {
            return `${date.slice(0, 4)}-${date.slice(4, 6)}`;
        }
    }
    else if (format === "DD-MMM-YYYY") {
        if (date.length <= 4) {
            return `UK-UK-${date.slice(0, 4)}`;
        }
        else if (date.length <= 6) {
            return `UK-${date.slice(4, 6) === "UK"
                ? "UNK"
                : (0, dayjs_1.default)()
                    .month(Number(date.slice(4, 6)) - 1)
                    .format("MMM")}-${date.slice(0, 4)}`;
        }
        else if (date.length <= 8) {
            return `${date.slice(6, 8)}-${date.slice(4, 6) === "UK"
                ? "UNK"
                : (0, dayjs_1.default)()
                    .month(Number(date.slice(4, 6)) - 1)
                    .format("MMM")}-${date.slice(0, 4)}`;
        }
        else {
            return `${date.slice(7, 9)}-${date.slice(4, 7)}-${date.slice(0, 4)}`;
        }
    }
    else if (format === "DD/MMM/YYYY") {
        if (date.length <= 4) {
            return `UK/UK/${date.slice(0, 4)}`;
        }
        else if (date.length <= 6) {
            return `UK/${date.slice(4, 6) === "UK"
                ? "UNK"
                : (0, dayjs_1.default)()
                    .month(Number(date.slice(4, 6)) - 1)
                    .format("MMM")}/${date.slice(0, 4)}`;
        }
        else {
            return `${date.slice(6, 8)}/${date.slice(4, 6) === "UK"
                ? "UNK"
                : (0, dayjs_1.default)()
                    .month(Number(date.slice(4, 6)) - 1)
                    .format("MMM")}/${date.slice(0, 4)}`;
        }
    }
    else if (format === "YYYY") {
        return date.slice(0, 4);
    }
    else if (format === "MMM/YYYY") {
        if (date.includes("UK") && date.slice(3, 8).includes("UK")) {
            return `UNK/${date.slice(0, 4)}`;
        }
        return `${(0, dayjs_1.default)()
            .month(Number(date.slice(4, 8)) - 1)
            .format("MMM")}/${date.slice(0, 4)}`;
    }
    return date;
}
exports.edcDateFormat = edcDateFormat;
function getConditionalItemReferenceByMixed(mixed, on) {
    const crfPageSeq = on.crfPageSeq || common_1.InitialCrfPageSequence;
    if (typeof mixed === "string" || typeof mixed === "number")
        return null;
    else if (hasOwnProperty(mixed, "folderId")) {
        return {
            groupId: on === null || on === void 0 ? void 0 : on.groupId,
            folderId: hasOwnProperty(mixed.folderId, "reserved") && mixed.folderId.reserved === "CURRENT" ? on === null || on === void 0 ? void 0 : on.folderId : mixed.folderId,
            visitId: hasOwnProperty(mixed.visitId, "reserved") && mixed.visitId.reserved === "CURRENT" ? on === null || on === void 0 ? void 0 : on.visitId : mixed.visitId,
            visitSeq: hasOwnProperty(mixed.visitSeq, "reserved") && mixed.visitSeq.reserved === "CURRENT" ? on === null || on === void 0 ? void 0 : on.visitSeq : mixed.visitSeq,
            crfPageId: mixed.crfPageId,
            crfPageSeq: "crfPageSeq" in mixed && mixed.crfPageSeq
                ? hasOwnProperty(mixed.crfPageSeq, "reserved") && mixed.crfPageSeq.reserved === "CURRENT"
                    ? crfPageSeq
                    : mixed.crfPageSeq
                : common_1.InitialCrfPageSequence,
            sectionId: mixed.sectionId,
            itemId: mixed.itemId,
            itemSeq: hasOwnProperty(mixed.itemSeq, "reserved") && mixed.itemSeq.reserved === "SIBLING" ? null : mixed.itemSeq,
            sibItemId: hasOwnProperty(mixed.itemSeq, "itemId") ? mixed.itemSeq.itemId : null,
        };
    }
    else if (hasOwnProperty(mixed, "id")) {
        return {
            groupId: on === null || on === void 0 ? void 0 : on.groupId,
            folderId: hasOwnProperty(mixed.id[0], "reserved") && mixed.id[0].reserved === "CURRENT" ? on === null || on === void 0 ? void 0 : on.folderId : mixed.id[0],
            visitId: hasOwnProperty(mixed.id[1], "reserved") && mixed.id[1].reserved === "CURRENT" ? on === null || on === void 0 ? void 0 : on.visitId : mixed.id[1],
            visitSeq: hasOwnProperty(mixed.id[2], "reserved") && mixed.id[2].reserved === "CURRENT" ? on === null || on === void 0 ? void 0 : on.visitSeq : mixed.id[2],
            crfPageId: mixed.id[3],
            crfPageSeq: common_1.InitialCrfPageSequence,
            sectionId: mixed.id[4],
            itemId: mixed.id[5],
            itemSeq: hasOwnProperty(mixed.id[6], "reserved") && mixed.id[6].reserved === "SIBLING" ? null : mixed.id[6],
            sibItemId: hasOwnProperty(mixed.id[6], "itemId") ? mixed.id[6].itemId : null,
        };
    }
    else {
        return null;
    }
}
exports.getConditionalItemReferenceByMixed = getConditionalItemReferenceByMixed;
// studySpec으로 부터 Crf Page items 추출
// export function getCrfDomainSearchItems(studySpec: StudySpec): Array<{ key: string | number; label: string }> {
//   const items: Array<{ key: string | number; label: string }> = [];
//   Object.keys(studySpec.domains).forEach(domainKey => {
//     const crf = Object.keys(studySpec.pages).find(pageId => studySpec.pages[pageId].domain === domainKey);
//     const domain = studySpec.domains[domainKey];
//     if (crf && domain.export?.type === EdcGroupId) {
//       items.push({
//         key: domainKey,
//         label: `${domainKey} (${domain.label})`,
//       });
//     }
//   });
//   return items;
// }
// availableVisits으로 부터 VisitId 추출
function getVisitSearchItems(availableVisits) {
    const items = [];
    availableVisits.forEach(visit => {
        items.push({ key: visit.visitId, label: `${visit.visitId}` });
    });
    return items;
}
exports.getVisitSearchItems = getVisitSearchItems;
// Enroll CrfPage 조회
function retrieveEnrollCrfPage(studySpec) {
    var _a;
    let folderIdx = studySpec.folders.findIndex(f => f.visits.find(v => v.reservedFor === "ENROLL"));
    if (folderIdx === -1) {
        folderIdx = 0;
    }
    const folder = studySpec.folders[folderIdx];
    let visitIdx = folder === null || folder === void 0 ? void 0 : folder.visits.findIndex(v => v.reservedFor === "ENROLL");
    if (visitIdx === -1) {
        visitIdx = 0;
    }
    const visit = folder === null || folder === void 0 ? void 0 : folder.visits[visitIdx];
    const crf = ((_a = visit === null || visit === void 0 ? void 0 : visit.crfs) === null || _a === void 0 ? void 0 : _a.find(crf => (crf === null || crf === void 0 ? void 0 : crf.reservedFor) === "ENROLL")) || (visit === null || visit === void 0 ? void 0 : visit.crfs[0]);
    const crfPageId = String(crf === null || crf === void 0 ? void 0 : crf.page);
    const crfPage = crf ? studySpec.pages[crf.page] : null;
    const crfPageIdx = 0;
    return { ...crfPage, crfPageIdx, crfPageId, folderIdx, folderId: folder === null || folder === void 0 ? void 0 : folder.id, visitIdx, visitId: visit === null || visit === void 0 ? void 0 : visit.id };
}
exports.retrieveEnrollCrfPage = retrieveEnrollCrfPage;
// Domain으로부터 CrfPageId 조회
function retrieveCrfPageIdByDomainId(studySpec, domainId) {
    if (!domainId)
        return null;
    const pages = Object.keys(studySpec.pages);
    for (const page of pages) {
        const found = flattenAllItems(studySpec, studySpec.pages[page]).find(item => hasOwnProperty(item, "domain") && item.domain === domainId);
        if (found) {
            return page;
        }
    }
    return null;
}
exports.retrieveCrfPageIdByDomainId = retrieveCrfPageIdByDomainId;
// CrfPage 경로로 부터 CrfPage 조회
function retrieveCrfPageByPath(studySpec, path) {
    const folder = studySpec.folders.find(f => f.id === path.folderId);
    const folderIdx = folder ? studySpec.folders.indexOf(folder) : null;
    const visit = folder ? folder.visits.find(v => v.id === path.visitId) : null;
    const visitIdx = visit ? folder.visits.indexOf(visit) : null;
    const crf = visit ? visit.crfs.find(c => c.page === path.crfPageId) : null;
    const crfPageId = crf ? String(crf.page) : null;
    const crfPage = crf ? studySpec.pages[crf.page] : null;
    const crfPageIdx = 0;
    return { ...crfPage, crfPageIdx, crfPageId, folderIdx, folderId: folder === null || folder === void 0 ? void 0 : folder.id, visitIdx, visitId: visit === null || visit === void 0 ? void 0 : visit.id };
}
exports.retrieveCrfPageByPath = retrieveCrfPageByPath;
// export function getCrfPageLabelByPath(studySpec: StudySpec, path: { folderId: string; visitId: string; crfPageId: string }): string {
//   const crfPage = retrieveCrfPageByPath(studySpec, path);
//   return studySpec?.domains[crfPage.domain]?.label || path.crfPageId;
// }
// CrfVisit 경로로 부터 CrfVisit 조회
function retrieveVisitByPath(studySpec, path) {
    const folder = studySpec.folders.find(f => f.id === path.folderId);
    const folderIdx = studySpec.folders.indexOf(folder);
    if (!folder)
        return null;
    const visit = folder.visits.find(v => v.id === path.visitId);
    const visitIdx = folder.visits.indexOf(visit);
    if (!visit)
        return null;
    return { ...visit, folderIdx, folderId: folder === null || folder === void 0 ? void 0 : folder.id, visitIdx, visitId: visit === null || visit === void 0 ? void 0 : visit.id };
}
exports.retrieveVisitByPath = retrieveVisitByPath;
function retrieveVisitByCode(studySpec, visitCode) {
    let folderId = undefined;
    let visit = undefined;
    let visitSeq = Number.MAX_VALUE;
    let loop = true;
    for (const folder of studySpec.folders) {
        for (const v of folder.visits) {
            if (typeof v.code === "number") {
                if (v.code === visitCode) {
                    folderId = folder.id;
                    visit = v;
                    visitSeq = 1;
                    loop = false;
                    break;
                }
            }
            else if (typeof v.code === "object" && Number(v.code.minval) <= visitCode) {
                const minVal = Number(v.code.minval);
                const step = v.code.step || 1;
                const diff = new bignumber_js_1.default(visitCode - minVal).div(step).plus(1);
                const calculatedVisitSeq = diff.toNumber();
                if (diff.isInteger() && calculatedVisitSeq < visitSeq) {
                    folderId = folder.id;
                    visit = v;
                    visitSeq = calculatedVisitSeq;
                }
            }
        }
        if (!loop)
            break;
    }
    if (!visit)
        return null;
    return { ...visit, folderId: folderId, visitSeq, visitId: visit.id };
}
exports.retrieveVisitByCode = retrieveVisitByCode;
function retrieveVisitsByDomainId(studySpec, domainId) {
    var _a;
    const crfPageId = retrieveCrfPageIdByDomainId(studySpec, domainId);
    const visits = (_a = studySpec.folders) === null || _a === void 0 ? void 0 : _a.map(folder => {
        const includeVisits = folder.visits
            .filter(visit => visit.crfs.find(crf => crf.page === crfPageId))
            .map(visit => ({ ...visit, folderId: folder.id, folderType: folder.type }));
        return includeVisits;
    });
    return (0, lodash_1.flatten)(visits);
}
exports.retrieveVisitsByDomainId = retrieveVisitsByDomainId;
// CrfPage에서 itemId로부터 CapturableItem 조회
function retrieveCapturableItemSpec(studySpec, crfPage, itemId) {
    return flattenCapturableItems(studySpec, crfPage).find(e => e.id === itemId);
}
exports.retrieveCapturableItemSpec = retrieveCapturableItemSpec;
// Data Capture 가능한 아이템 조회 (= 자동 입력되는 항목을 제외한 항목)
function flattenAllItems(studySpec, crfPage, on) {
    return flattenManageableItems(studySpec, crfPage).filter(x => checkVisibility(x.visibility, on));
}
exports.flattenAllItems = flattenAllItems;
// Data Capture 가능한 아이템 조회 (= 자동 입력되는 항목을 제외한 항목)
function flattenCapturableItems(studySpec, crfPage, on) {
    return flattenManageableItems(studySpec, crfPage)
        .filter(x => x.capturable)
        .filter(x => checkVisibility(x.visibility, on));
}
exports.flattenCapturableItems = flattenCapturableItems;
// Data Export (다운로드) 가능한 아이템 조회 (= Domain 지정된 항목)
function flattenExportableItems(studySpec, crfPage, on) {
    return flattenManageableItems(studySpec, crfPage)
        .filter(e => e.domain && e.exportable)
        .filter(x => checkVisibility(x.visibility, on));
}
exports.flattenExportableItems = flattenExportableItems;
// CrfPage에서 itemId로부터 CapturableItem 조회
function retrieveManageableItemSpec(studySpec, crfPage, itemId) {
    return flattenManageableItems(studySpec, crfPage).find(e => e.id === itemId);
}
exports.retrieveManageableItemSpec = retrieveManageableItemSpec;
// Data Capture 가능한 + Data Export 가능한 아이템 조회
function flattenManageableItems(studySpec, crfPage) {
    return Array.prototype.concat.apply([], (crfPage &&
        crfPage.sections &&
        crfPage.sections.map(section => flattenManageableItemsBySection({
            ...section,
            folderId: hasOwnProperty(crfPage, "folderId") ? crfPage.folderId : null,
            visitId: hasOwnProperty(crfPage, "visitId") ? crfPage.visitId : null,
            crfPageId: hasOwnProperty(crfPage, "crfPageId") ? crfPage.crfPageId : null,
            version: getVersion(section.version, crfPage.version, studySpec.version),
        }))) ||
        []);
}
exports.flattenManageableItems = flattenManageableItems;
function flattenVisibilityManageableItemsByItem(section, item, on) {
    return flattenManageableItemsByItem(section, item, []).filter(x => checkVisibility(x.visibility, on));
}
exports.flattenVisibilityManageableItemsByItem = flattenVisibilityManageableItemsByItem;
function flattenManageableItemsBySection(section) {
    const items = [];
    // NOTE. 저장 가능한 새로운 유형의 CrfItem이 추가될 경우 아래 코드에 정의해야 함
    section.items.forEach(item => {
        items.push(...flattenManageableItemsByItem(section, item, []));
    });
    return items;
}
exports.flattenManageableItemsBySection = flattenManageableItemsBySection;
function flattenManageableItemsByItem(section, item, relItems, containerItem, groupUuid) {
    var _a, _b;
    const items = [];
    const itemGroupUuid = groupUuid || (0, uuid_1.v4)();
    const inheritItemSeq = (containerItem === null || containerItem === void 0 ? void 0 : containerItem.type) === "APPENDABLE_TABLE" || (containerItem === null || containerItem === void 0 ? void 0 : containerItem.type) === "FOLDABLE_TABLE";
    const isAppendable = (containerItem === null || containerItem === void 0 ? void 0 : containerItem.type) === "APPENDABLE_TABLE" || (containerItem === null || containerItem === void 0 ? void 0 : containerItem.type) === "FOLDABLE_TABLE" ? true : false;
    if (item.type === "TEXT" ||
        item.type === "DOUBLE_TEXT" || // @deprecated
        item.type === "AUTO_TEXT" ||
        item.type === "DATE" ||
        item.type === "TIME" ||
        item.type === "FORMATTED_TIME" ||
        item.type === "SIGNATURE" ||
        item.type === "SYS_VAL" ||
        item.type === "HIDDEN_VAL" ||
        item.type === "SYS_HIDDEN_VAL") {
        items.push({
            original: item,
            type: item.type,
            folderId: hasOwnProperty(section, "folderId") ? section.folderId : null,
            visitId: hasOwnProperty(section, "visitId") ? section.visitId : null,
            crfPageId: hasOwnProperty(section, "crfPageId") ? section.crfPageId : null,
            sectionId: section.id,
            id: item.id,
            domain: item.domain,
            label: hasOwnProperty(item, "label") ? item.label : null,
            required: item.required,
            dataType: item.dataType || "CHARACTER",
            capturable: item.type !== "SYS_VAL" && item.type !== "SYS_HIDDEN_VAL" && item.type !== "HIDDEN_VAL",
            querable: item.type !== "SYS_HIDDEN_VAL" && item.type !== "HIDDEN_VAL",
            exportable: true,
            allowEmpty: item.type !== "SYS_HIDDEN_VAL" ? item.allowEmpty : null,
            visibility: getVisibility(section.visibility, ...(relItems || []).map(e => e.visibility).filter(e => !!e), item.visibility),
            writability: getWritability(section.writability, ...(relItems || []).map(e => e.writability).filter(e => !!e), item.writability),
            availability: getAvailability(section, [item, ...(relItems || [])], inheritItemSeq),
            disability: getDisability(section, [item, ...(relItems || [])], inheritItemSeq),
            version: getVersion(section.version, item.version),
            unmodifiable: item.unmodifiable,
            inclusiveCapture: item.inclusiveCapture,
            onDemand: item.onDemand,
            appendable: isAppendable,
            confirmMessage: item.confirmMessage,
            throwExceptionIfEmpty: false,
            containerItem: containerItem,
            groupUuid: itemGroupUuid,
        });
        if (((_b = (_a = item.children) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            items.push(...Array.prototype.concat(...item.children.items.map(childrenItem => flattenManageableItemsByItem(section, childrenItem, relItems, containerItem, itemGroupUuid))));
        }
    }
    else if (item.type === "DICTIONARY") {
        items.push(...flattenManageableItemsByDictionary(section, item, relItems, inheritItemSeq, containerItem, itemGroupUuid));
    }
    else if (item.type === "ATTACHMENT") {
        items.push(...flattenManageableItemsByAttachment(section, item, relItems, inheritItemSeq, containerItem, itemGroupUuid));
    }
    else if (item.type === "CHECK") {
        items.push(...flattenManageableItemsByCheckItem(section, item, relItems, inheritItemSeq, containerItem, itemGroupUuid));
    }
    else if (item.type === "SINGLE_SELECT") {
        items.push(...flattenManageableItemsBySingleSelectItem(section, item, relItems, inheritItemSeq, containerItem, itemGroupUuid));
    }
    else if (item.type === "CONSTANT") {
        items.push(...flattenManageableItemsByConstantItem(section, item, relItems, inheritItemSeq, containerItem, itemGroupUuid));
    }
    else if (item.type === "SLIDER") {
        items.push(...flattenManageableItemsBySliderItem(section, item, relItems, inheritItemSeq, containerItem, itemGroupUuid));
    }
    else if (item.type === "APPENDABLE_TABLE" || item.type === "FOLDABLE_TABLE") {
        const containerTableItem = item; // Note. Table 종류의 아이템은 다른 아이템의 하위가 될 수 없음
        const itemTableGroupUuid = (0, uuid_1.v4)(); // Note. Table 종류의 아이템일 때 groupUuid를 새로 만듬
        // Appendable Table, Row 개수를 저장하기 위한 Item
        items.push({
            original: item,
            type: "SYS_VAL",
            folderId: hasOwnProperty(section, "folderId") ? section.folderId : null,
            visitId: hasOwnProperty(section, "visitId") ? section.visitId : null,
            crfPageId: hasOwnProperty(section, "crfPageId") ? section.crfPageId : null,
            sectionId: section.id,
            id: `${item.id}${_1.EdcAttrKeySuffixDelimiter}${item.type === "APPENDABLE_TABLE" ? _1.EdcAppendableTableRowCount : _1.EdcFoldableTableRowCount}`,
            domain: null,
            label: hasOwnProperty(item, "label") ? item.label : null,
            required: false,
            dataType: "CHARACTER",
            capturable: true,
            querable: false,
            exportable: false,
            allowEmpty: null,
            visibility: getVisibility(section.visibility, ...(relItems || []).map(e => e.visibility).filter(e => !!e), item.visibility),
            writability: getWritability(section.writability, ...(relItems || []).map(e => e.writability).filter(e => !!e), item.writability),
            availability: getAvailability(section, [item, ...(relItems || [])], false),
            disability: getDisability(section, [item, ...(relItems || [])], false),
            version: getVersion(section.version, item.version),
            comment: item.comment,
            unmodifiable: item.unmodifiable,
            inclusiveCapture: item.inclusiveCapture,
            onDemand: undefined,
            appendable: false,
            confirmMessage: undefined,
            throwExceptionIfEmpty: false,
            containerItem: containerTableItem,
            groupUuid: itemTableGroupUuid,
        });
        // Appendable Table 삭제했을 때 Flagging 하기 위한 Item
        items.push({
            original: item,
            type: "SYS_VAL",
            folderId: hasOwnProperty(section, "folderId") ? section.folderId : null,
            visitId: hasOwnProperty(section, "visitId") ? section.visitId : null,
            crfPageId: hasOwnProperty(section, "crfPageId") ? section.crfPageId : null,
            sectionId: section.id,
            id: `${item.id}${_1.EdcAttrKeySuffixDelimiter}${item.type === "APPENDABLE_TABLE" ? _1.EdcAppendableTableRowStrikeAttrKeySuffix : _1.EdcFoldableTableRowStrikeAttrKeySuffix}`,
            domain: null,
            label: hasOwnProperty(item, "label") ? item.label : null,
            required: false,
            dataType: "CHARACTER",
            capturable: true,
            querable: false,
            exportable: false,
            allowEmpty: null,
            visibility: getVisibility(section.visibility, ...(relItems || []).map(e => e.visibility).filter(e => !!e), item.visibility),
            writability: getWritability(section.writability, ...(relItems || []).map(e => e.writability).filter(e => !!e), item.writability),
            availability: getAvailability(section, [item, ...(relItems || [])], false),
            disability: getDisability(section, [item, ...(relItems || [])], false),
            version: getVersion(section.version, item.version),
            comment: item.comment,
            unmodifiable: item.unmodifiable,
            inclusiveCapture: item.inclusiveCapture,
            onDemand: undefined,
            appendable: true,
            confirmMessage: undefined,
            throwExceptionIfEmpty: false,
            containerItem: containerTableItem,
            groupUuid: itemTableGroupUuid,
        });
        item.cols.forEach(col => {
            var _a, _b;
            if (col.type === "TEXT" ||
                col.type === "DOUBLE_TEXT" || // @deprecated
                col.type === "AUTO_TEXT" ||
                col.type === "SEQUENCE" ||
                col.type === "SYS_VAL" ||
                col.type === "DATE" ||
                col.type === "TIME" ||
                col.type === "FORMATTED_TIME" ||
                col.type === "HIDDEN_VAL" ||
                col.type === "SYS_HIDDEN_VAL") {
                items.push({
                    original: col,
                    type: col.type,
                    folderId: hasOwnProperty(section, "folderId") ? section.folderId : null,
                    visitId: hasOwnProperty(section, "visitId") ? section.visitId : null,
                    crfPageId: hasOwnProperty(section, "crfPageId") ? section.crfPageId : null,
                    sectionId: section.id,
                    id: col.id,
                    domain: col.domain,
                    label: hasOwnProperty(col, "label") ? col.label : null,
                    required: col.required,
                    dataType: col.dataType || "CHARACTER",
                    capturable: col.type !== "SYS_VAL" && col.type !== "SYS_HIDDEN_VAL" && col.type !== "HIDDEN_VAL",
                    querable: col.type !== "SEQUENCE" && col.type !== "SYS_HIDDEN_VAL" && col.type !== "HIDDEN_VAL",
                    exportable: true,
                    allowEmpty: col.type !== "SYS_HIDDEN_VAL" ? col.allowEmpty : null,
                    visibility: getVisibility(section.visibility, ...(relItems || []).map(e => e.visibility).filter(e => !!e), item.visibility, col.visibility),
                    writability: getWritability(section.writability, ...(relItems || []).map(e => e.writability).filter(e => !!e), item.writability, col.writability),
                    availability: getAvailability(section, [item, ...(relItems || []), col], true),
                    disability: getDisability(section, [item, ...(relItems || [])], true),
                    version: getVersion(section.version, item.version, col.version),
                    comment: col.comment,
                    unmodifiable: col.unmodifiable,
                    inclusiveCapture: col.inclusiveCapture,
                    onDemand: col.onDemand,
                    appendable: true,
                    confirmMessage: col.confirmMessage,
                    throwExceptionIfEmpty: false,
                    containerItem: containerTableItem,
                    groupUuid: itemTableGroupUuid,
                });
                if (((_b = (_a = col.children) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                    items.push(...Array.prototype.concat(...col.children.items.map(childrenItem => flattenManageableItemsByItem(section, childrenItem, relItems.concat(item), containerTableItem, itemTableGroupUuid))));
                }
            }
            else if (col.type === "DICTIONARY") {
                items.push(...flattenManageableItemsByDictionary(section, col, relItems.concat(item), true, containerTableItem, itemTableGroupUuid));
            }
            else if (col.type === "ATTACHMENT") {
                items.push(...flattenManageableItemsByAttachment(section, col, relItems.concat(item), true, containerTableItem, itemTableGroupUuid));
            }
            else if (col.type === "CHECK") {
                items.push(...flattenManageableItemsByCheckItem(section, col, relItems.concat(item), true, containerTableItem, itemTableGroupUuid));
            }
            else if (col.type === "SINGLE_SELECT") {
                items.push(...flattenManageableItemsBySingleSelectItem(section, col, relItems.concat(item), true, containerTableItem, itemTableGroupUuid));
            }
            else if (col.type === "CONSTANT") {
                items.push(...flattenManageableItemsByConstantItem(section, col, relItems.concat(item), true, containerTableItem, itemTableGroupUuid));
            }
            else if (col.type === "SLIDER") {
                items.push(...flattenManageableItemsBySliderItem(section, col, relItems.concat(item), true, containerTableItem, itemTableGroupUuid));
            }
            else if (col.type === "HORIZONTAL_GROUP") {
                col.items.forEach(elem => {
                    var _a, _b;
                    if (elem.type === "TEXT" ||
                        elem.type === "DOUBLE_TEXT" || // @deprecated
                        elem.type === "AUTO_TEXT" ||
                        elem.type === "SYS_VAL" ||
                        elem.type === "DATE" ||
                        elem.type === "TIME" ||
                        elem.type === "FORMATTED_TIME" ||
                        elem.type === "HIDDEN_VAL" ||
                        elem.type === "SYS_HIDDEN_VAL") {
                        items.push({
                            original: elem,
                            type: elem.type,
                            folderId: hasOwnProperty(section, "folderId") ? section.folderId : null,
                            visitId: hasOwnProperty(section, "visitId") ? section.visitId : null,
                            crfPageId: hasOwnProperty(section, "crfPageId") ? section.crfPageId : null,
                            sectionId: section.id,
                            id: elem.id,
                            domain: elem.domain,
                            label: elem.label || item.label,
                            required: elem.required,
                            dataType: elem.dataType || "CHARACTER",
                            capturable: elem.type !== "SYS_VAL" && elem.type !== "SYS_HIDDEN_VAL" && elem.type !== "HIDDEN_VAL",
                            querable: elem.type !== "SYS_HIDDEN_VAL" && elem.type !== "HIDDEN_VAL",
                            exportable: true,
                            allowEmpty: elem.type !== "SYS_HIDDEN_VAL" ? elem.allowEmpty : null,
                            visibility: getVisibility(section.visibility, ...(relItems || []).map(e => e.visibility).filter(e => !!e), item.visibility, elem.visibility),
                            writability: getWritability(section.writability, ...(relItems || []).map(e => e.writability).filter(e => !!e), item.writability, elem.writability),
                            availability: getAvailability(section, [item, ...(relItems || []), elem], true),
                            disability: getDisability(section, [item, ...(relItems || [])], true),
                            version: getVersion(section.version, item.version, elem.version),
                            comment: elem.comment,
                            unmodifiable: elem.unmodifiable,
                            inclusiveCapture: elem.inclusiveCapture,
                            onDemand: elem.onDemand,
                            appendable: true,
                            confirmMessage: elem.confirmMessage,
                            throwExceptionIfEmpty: false,
                            containerItem: containerTableItem,
                            groupUuid: itemTableGroupUuid,
                        });
                        if (((_b = (_a = elem.children) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                            items.push(...Array.prototype.concat(...elem.children.items.map(childrenItem => flattenManageableItemsByItem(section, childrenItem, relItems.concat(item), containerTableItem, itemTableGroupUuid))));
                        }
                    }
                    else if (elem.type === "DICTIONARY") {
                        items.push(...flattenManageableItemsByDictionary(section, elem, relItems.concat(item), true, containerTableItem, itemTableGroupUuid));
                    }
                    else if (elem.type === "CHECK") {
                        items.push(...flattenManageableItemsByCheckItem(section, { ...elem, label: elem.label || item.label }, relItems.concat(item), true, containerTableItem, itemTableGroupUuid));
                    }
                    else if (elem.type === "SINGLE_SELECT") {
                        items.push(...flattenManageableItemsBySingleSelectItem(section, elem, relItems.concat(item), true, containerTableItem, itemTableGroupUuid));
                    }
                    else if (elem.type === "CONSTANT") {
                        items.push(...flattenManageableItemsByConstantItem(section, { ...elem, label: elem.label || "" }, relItems.concat(item), true, containerTableItem, itemTableGroupUuid));
                    }
                    else if (elem.type === "SLIDER") {
                        items.push(...flattenManageableItemsBySliderItem(section, elem, relItems.concat(item), true, containerTableItem, itemTableGroupUuid));
                    }
                });
            }
        });
    }
    else if (item.type === "TABLE") {
        const containerTableItem = item; // Note. Table 종류의 아이템은 다른 아이템의 하위가 되지 않음
        const itemTableGroupUuid = (0, uuid_1.v4)(); // Note. Table 종류의 아이템일 때 groupUuid를 새로 생성
        item.rows.forEach(row => {
            row.forEach((elem, colIdx) => {
                var _a, _b, _c;
                if (elem.type === "TEXT" ||
                    elem.type === "DOUBLE_TEXT" || // @deprecated
                    elem.type === "AUTO_TEXT" ||
                    elem.type === "SYS_VAL" ||
                    elem.type === "DATE" ||
                    elem.type === "TIME" ||
                    elem.type === "FORMATTED_TIME" ||
                    elem.type === "HIDDEN_VAL" ||
                    elem.type === "SYS_HIDDEN_VAL") {
                    items.push({
                        original: elem,
                        type: elem.type,
                        folderId: hasOwnProperty(section, "folderId") ? section.folderId : null,
                        visitId: hasOwnProperty(section, "visitId") ? section.visitId : null,
                        crfPageId: hasOwnProperty(section, "crfPageId") ? section.crfPageId : null,
                        sectionId: section.id,
                        id: elem.id,
                        domain: elem.domain,
                        label: elem.label || item.label,
                        header: ((_a = item.headers[colIdx]) === null || _a === void 0 ? void 0 : _a.label) || null,
                        required: elem.required,
                        dataType: elem.dataType || "CHARACTER",
                        capturable: elem.type !== "SYS_VAL" && elem.type !== "SYS_HIDDEN_VAL" && elem.type !== "HIDDEN_VAL",
                        querable: elem.type !== "SYS_HIDDEN_VAL" && elem.type !== "HIDDEN_VAL",
                        exportable: true,
                        allowEmpty: elem.type !== "SYS_HIDDEN_VAL" ? elem.allowEmpty : null,
                        visibility: getVisibility(section.visibility, ...(relItems || []).map(e => e.visibility).filter(e => !!e), item.visibility, item.headers[colIdx].visibility, elem.visibility),
                        writability: getWritability(section.writability, ...(relItems || []).map(e => e.writability).filter(e => !!e), item.writability, // TODO: 20230926 table header에는 writability 스펙이 없으므로 구현 필요
                        elem.writability),
                        availability: getAvailability(section, [item, ...(relItems || []), elem], false),
                        disability: getDisability(section, [item, ...(relItems || []), elem], false),
                        version: getVersion(section.version, item.version, elem.version),
                        comment: elem.comment,
                        unmodifiable: elem.unmodifiable,
                        inclusiveCapture: elem.inclusiveCapture,
                        onDemand: elem.onDemand,
                        appendable: false,
                        confirmMessage: elem.confirmMessage,
                        throwExceptionIfEmpty: false,
                        containerItem: containerTableItem,
                        groupUuid: itemTableGroupUuid,
                    });
                    if (((_c = (_b = elem.children) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                        items.push(...Array.prototype.concat(...elem.children.items.map(childrenItem => flattenManageableItemsByItem(section, childrenItem, relItems.concat(item), containerTableItem, itemTableGroupUuid))));
                    }
                }
                else if (elem.type === "DICTIONARY") {
                    items.push(...flattenManageableItemsByDictionary(section, elem, relItems.concat(item), false, containerTableItem, itemTableGroupUuid));
                }
                else if (elem.type === "ATTACHMENT") {
                    items.push(...flattenManageableItemsByAttachment(section, elem, relItems.concat(item), false, containerTableItem, itemTableGroupUuid));
                }
                else if (elem.type === "CHECK") {
                    items.push(...flattenManageableItemsByCheckItem(section, { ...elem, label: elem.label || item.label }, relItems.concat(item), false, containerTableItem, itemTableGroupUuid));
                }
                else if (elem.type === "SINGLE_SELECT") {
                    items.push(...flattenManageableItemsBySingleSelectItem(section, elem, relItems.concat(item), false, containerTableItem, itemTableGroupUuid));
                }
                else if (elem.type === "CONSTANT") {
                    items.push(...flattenManageableItemsByConstantItem(section, { ...elem, label: elem.label || "" }, relItems.concat(item), false, containerTableItem, itemTableGroupUuid));
                }
                else if (elem.type === "SLIDER") {
                    items.push(...flattenManageableItemsBySliderItem(section, elem, relItems.concat(item), false, containerTableItem, itemTableGroupUuid));
                }
            });
        });
    }
    else if (item.type === "HORIZONTAL_GROUP") {
        item.items.forEach(elem => {
            var _a, _b;
            if (elem.type === "TEXT" ||
                elem.type === "DOUBLE_TEXT" || // @deprecated
                elem.type === "AUTO_TEXT" ||
                elem.type === "SYS_VAL" ||
                elem.type === "DATE" ||
                elem.type === "TIME" ||
                elem.type === "FORMATTED_TIME" ||
                elem.type === "HIDDEN_VAL" ||
                elem.type === "SYS_HIDDEN_VAL") {
                items.push({
                    original: elem,
                    type: elem.type,
                    folderId: hasOwnProperty(section, "folderId") ? section.folderId : null,
                    visitId: hasOwnProperty(section, "visitId") ? section.visitId : null,
                    crfPageId: hasOwnProperty(section, "crfPageId") ? section.crfPageId : null,
                    sectionId: section.id,
                    id: elem.id,
                    domain: elem.domain,
                    label: elem.label || item.label,
                    required: elem.required,
                    dataType: elem.dataType || "CHARACTER",
                    capturable: elem.type !== "SYS_VAL" && elem.type !== "SYS_HIDDEN_VAL" && elem.type !== "HIDDEN_VAL",
                    querable: elem.type !== "SYS_HIDDEN_VAL" && elem.type !== "HIDDEN_VAL",
                    exportable: true,
                    allowEmpty: elem.type !== "SYS_HIDDEN_VAL" ? elem.allowEmpty : null,
                    visibility: getVisibility(section.visibility, ...(relItems || []).map(e => e.visibility).filter(e => !!e), item.visibility, elem.visibility),
                    writability: getWritability(section.writability, ...(relItems || []).map(e => e.writability).filter(e => !!e), item.writability, elem.writability),
                    availability: getAvailability(section, [item, ...(relItems || []), elem], false),
                    disability: getDisability(section, [item, ...(relItems || []), elem], false),
                    version: getVersion(section.version, item.version, elem.version),
                    comment: elem.comment,
                    unmodifiable: elem.unmodifiable,
                    inclusiveCapture: elem.inclusiveCapture,
                    onDemand: elem.onDemand,
                    appendable: isAppendable,
                    confirmMessage: elem.confirmMessage,
                    throwExceptionIfEmpty: false,
                    containerItem: containerItem,
                    groupUuid: itemGroupUuid,
                });
                if (((_b = (_a = elem.children) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                    items.push(...Array.prototype.concat(...elem.children.items.map(childrenItem => flattenManageableItemsByItem(section, childrenItem, relItems.concat(item), containerItem, itemGroupUuid))));
                }
            }
            else if (elem.type === "DICTIONARY") {
                items.push(...flattenManageableItemsByDictionary(section, elem, relItems.concat(item), false, containerItem, itemGroupUuid));
            }
            else if (elem.type === "ATTACHMENT") {
                items.push(...flattenManageableItemsByAttachment(section, elem, relItems.concat(item), false, containerItem, itemGroupUuid));
            }
            else if (elem.type === "CHECK") {
                items.push(...flattenManageableItemsByCheckItem(section, { ...elem, label: elem.label || item.label }, relItems.concat(item), false, containerItem, itemGroupUuid));
            }
            else if (elem.type === "SINGLE_SELECT") {
                items.push(...flattenManageableItemsBySingleSelectItem(section, elem, relItems.concat(item), false, containerItem, itemGroupUuid));
            }
            else if (elem.type === "CONSTANT") {
                items.push(...flattenManageableItemsByConstantItem(section, { ...elem, label: elem.label || "" }, relItems.concat(item), false, containerItem, itemGroupUuid));
            }
            else if (elem.type === "SLIDER") {
                items.push(...flattenManageableItemsBySliderItem(section, elem, relItems.concat(item), false, containerItem, itemGroupUuid));
            }
        });
    }
    return items;
}
exports.flattenManageableItemsByItem = flattenManageableItemsByItem;
// SingleSelectItem 전용
function flattenManageableItemsBySingleSelectItem(section, singleSelectItem, relItems, inheritItemSeq, containerItem, groupUuid) {
    var _a, _b;
    const items = [];
    const itemGroupUuid = groupUuid || (0, uuid_1.v4)();
    const isAppendable = (containerItem === null || containerItem === void 0 ? void 0 : containerItem.type) === "APPENDABLE_TABLE" || (containerItem === null || containerItem === void 0 ? void 0 : containerItem.type) === "FOLDABLE_TABLE" ? true : false;
    items.push({
        original: singleSelectItem,
        type: singleSelectItem.type,
        folderId: hasOwnProperty(section, "folderId") ? section.folderId : null,
        visitId: hasOwnProperty(section, "visitId") ? section.visitId : null,
        crfPageId: hasOwnProperty(section, "crfPageId") ? section.crfPageId : null,
        sectionId: section.id,
        id: singleSelectItem.id,
        domain: singleSelectItem.domain,
        label: hasOwnProperty(singleSelectItem, "label") ? singleSelectItem.label : null,
        required: singleSelectItem.required,
        dataType: singleSelectItem.dataType || "CHARACTER",
        capturable: true,
        querable: true,
        exportable: true,
        allowEmpty: singleSelectItem.allowEmpty ? singleSelectItem.allowEmpty : null,
        visibility: getVisibility(section.visibility, ...(relItems || []).map(e => e.visibility).filter(e => !!e), singleSelectItem.visibility),
        writability: getWritability(section.writability, ...(relItems || []).map(e => e.writability).filter(e => !!e), singleSelectItem.writability),
        availability: getAvailability(section, [singleSelectItem, ...(relItems || [])], inheritItemSeq),
        disability: getDisability(section, [singleSelectItem, ...(relItems || [])], inheritItemSeq),
        version: getVersion(section.version, singleSelectItem.version),
        comment: singleSelectItem.comment,
        unmodifiable: singleSelectItem.unmodifiable,
        inclusiveCapture: singleSelectItem.inclusiveCapture,
        onDemand: singleSelectItem.onDemand,
        appendable: isAppendable,
        confirmMessage: singleSelectItem.confirmMessage,
        throwExceptionIfEmpty: false,
        containerItem: containerItem,
        groupUuid: itemGroupUuid,
    });
    singleSelectItem.itemCode.codes.forEach(itemCode => {
        if (itemCode.typeText) {
            items.push({
                original: { ...singleSelectItem, inherit: true },
                type: "TEXT",
                folderId: hasOwnProperty(section, "folderId") ? section.folderId : null,
                visitId: hasOwnProperty(section, "visitId") ? section.visitId : null,
                crfPageId: hasOwnProperty(section, "crfPageId") ? section.crfPageId : null,
                sectionId: section.id,
                id: itemCode.typeText.id,
                domain: itemCode.typeText.domain,
                label: itemCode.typeText.label || itemCode.uiVal,
                required: false,
                allowEmpty: itemCode.typeText.allowEmpty ? itemCode.typeText.allowEmpty : null,
                dataType: itemCode.dataType || "CHARACTER",
                capturable: true,
                querable: true,
                exportable: true,
                visibility: getVisibility(section.visibility, ...(relItems || []).map(e => e.visibility).filter(e => !!e), singleSelectItem.visibility),
                writability: getWritability(section.writability, ...(relItems || []).map(e => e.writability).filter(e => !!e), singleSelectItem.writability),
                availability: getAvailability(section, [
                    singleSelectItem,
                    {
                        id: itemCode.typeText.id,
                        availability: {
                            ref: "ITEM",
                            id: singleSelectItem.id,
                            seq: singleSelectItem.itemSeq || null,
                            condition: "=",
                            operand: itemCode.dbVal,
                        },
                    },
                    ...(relItems || []),
                ], inheritItemSeq),
                disability: getDisability(section, [singleSelectItem, ...(relItems || [])], inheritItemSeq),
                version: getVersion(section.version, singleSelectItem.version),
                comment: null,
                inclusiveCapture: itemCode.typeText.inclusiveCapture,
                onDemand: itemCode.typeText.onDemand,
                appendable: isAppendable,
                confirmMessage: undefined,
                throwExceptionIfEmpty: itemCode.typeText.throwExceptionIfEmpty || false,
                containerItem: containerItem,
                groupUuid: itemGroupUuid,
            });
        }
        if (itemCode.relatedText) {
            items.push({
                original: { ...singleSelectItem, inherit: true },
                type: "TEXT",
                folderId: hasOwnProperty(section, "folderId") ? section.folderId : null,
                visitId: hasOwnProperty(section, "visitId") ? section.visitId : null,
                crfPageId: hasOwnProperty(section, "crfPageId") ? section.crfPageId : null,
                sectionId: section.id,
                id: itemCode.relatedText.id,
                domain: itemCode.relatedText.domain,
                label: itemCode.relatedText.label || itemCode.uiVal,
                required: false,
                allowEmpty: itemCode.relatedText.allowEmpty ? itemCode.relatedText.allowEmpty : null,
                dataType: itemCode.dataType || "CHARACTER",
                capturable: true,
                querable: true,
                exportable: true,
                visibility: getVisibility(section.visibility, ...(relItems || []).map(e => e.visibility).filter(e => !!e), singleSelectItem.visibility),
                writability: getWritability(section.writability, ...(relItems || []).map(e => e.writability).filter(e => !!e), singleSelectItem.writability),
                availability: getAvailability(section, [
                    singleSelectItem,
                    {
                        id: itemCode.relatedText.id,
                        availability: {
                            ref: "ITEM",
                            id: singleSelectItem.id,
                            seq: singleSelectItem.itemSeq || null,
                            condition: "=",
                            operand: itemCode.dbVal,
                        },
                    },
                    ...(relItems || []),
                ], inheritItemSeq),
                disability: getDisability(section, [singleSelectItem, ...(relItems || [])], inheritItemSeq),
                version: getVersion(section.version, singleSelectItem.version),
                comment: null,
                inclusiveCapture: itemCode.relatedText.inclusiveCapture,
                onDemand: itemCode.relatedText.onDemand,
                appendable: isAppendable,
                confirmMessage: undefined,
                throwExceptionIfEmpty: itemCode.relatedText.throwExceptionIfEmpty || false,
                containerItem: containerItem,
                groupUuid: itemGroupUuid,
            });
        }
    });
    if (((_b = (_a = singleSelectItem.children) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length) > 0) {
        items.push(...Array.prototype.concat(...singleSelectItem.children.items.map(childrenItem => flattenManageableItemsByItem(section, childrenItem, relItems, containerItem, itemGroupUuid))));
    }
    return items;
}
exports.flattenManageableItemsBySingleSelectItem = flattenManageableItemsBySingleSelectItem;
// ConstantItem 전용
function flattenManageableItemsByConstantItem(section, constantItem, relItems, inheritItemSeq, containerItem, groupUuid) {
    var _a, _b;
    const items = [];
    const itemGroupUuid = groupUuid || (0, uuid_1.v4)();
    const isAppendable = (containerItem === null || containerItem === void 0 ? void 0 : containerItem.type) === "APPENDABLE_TABLE" || (containerItem === null || containerItem === void 0 ? void 0 : containerItem.type) === "FOLDABLE_TABLE" ? true : false;
    if (constantItem.id && constantItem.domain && constantItem.capturable) {
        items.push({
            original: { ...constantItem, inherit: true },
            type: "CONSTANT",
            folderId: hasOwnProperty(section, "folderId") ? section.folderId : null,
            visitId: hasOwnProperty(section, "visitId") ? section.visitId : null,
            crfPageId: hasOwnProperty(section, "crfPageId") ? section.crfPageId : null,
            sectionId: section.id,
            id: constantItem.id,
            value: constantItem.value,
            itemSeq: constantItem.itemSeq,
            domain: constantItem.domain,
            label: hasOwnProperty(constantItem, "label") ? constantItem.label : null,
            required: false,
            capturable: constantItem.capturable || false,
            querable: false,
            exportable: true,
            visibility: getVisibility(section.visibility, ...(relItems || []).map(e => e.visibility).filter(e => !!e), constantItem.visibility),
            writability: getWritability(section.writability, ...(relItems || []).map(e => e.writability).filter(e => !!e), constantItem.writability),
            availability: getAvailability(section, [constantItem, ...(relItems || [])], inheritItemSeq),
            disability: getDisability(section, [constantItem, ...(relItems || [])], inheritItemSeq),
            version: getVersion(section.version, constantItem.version),
            comment: null,
            appendable: isAppendable,
            confirmMessage: undefined,
            throwExceptionIfEmpty: false,
            containerItem: containerItem,
            dataType: constantItem.dataType || null,
            groupUuid: itemGroupUuid,
        });
    }
    if (constantItem.subItem && constantItem.subItem.id && constantItem.subItem.domain && constantItem.subItem.dataType) {
        items.push({
            original: { ...constantItem, inherit: true },
            type: constantItem.subItem.type,
            folderId: hasOwnProperty(section, "folderId") ? section.folderId : null,
            visitId: hasOwnProperty(section, "visitId") ? section.visitId : null,
            crfPageId: hasOwnProperty(section, "crfPageId") ? section.crfPageId : null,
            sectionId: section.id,
            id: constantItem.subItem.id,
            domain: constantItem.subItem.domain,
            label: hasOwnProperty(constantItem.subItem, "label") ? constantItem.subItem.label : null,
            required: constantItem.subItem.required,
            dataType: constantItem.subItem.dataType,
            capturable: constantItem.capturable || false,
            querable: false,
            exportable: true,
            visibility: getVisibility(section.visibility, ...(relItems || []).map(e => e.visibility).filter(e => !!e), constantItem.visibility, constantItem.subItem.visibility),
            writability: getWritability(section.writability, ...(relItems || []).map(e => e.writability).filter(e => !!e), constantItem.writability, constantItem.subItem.writability),
            availability: getAvailability(section, [constantItem, ...(relItems || []), constantItem.subItem], inheritItemSeq),
            disability: getDisability(section, [constantItem, ...(relItems || []), constantItem.subItem], inheritItemSeq),
            version: getVersion(section.version, constantItem.version),
            comment: null,
            appendable: isAppendable,
            confirmMessage: constantItem.subItem.confirmMessage,
            throwExceptionIfEmpty: false,
            containerItem: containerItem,
            groupUuid: itemGroupUuid,
        });
    }
    if (((_b = (_a = constantItem.children) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length) > 0) {
        items.push(...Array.prototype.concat(...constantItem.children.items.map(childrenItem => flattenManageableItemsByItem(section, childrenItem, relItems, containerItem, itemGroupUuid))));
    }
    return items;
}
exports.flattenManageableItemsByConstantItem = flattenManageableItemsByConstantItem;
// Slider Item 전용
function flattenManageableItemsBySliderItem(section, sliderItem, relItems, inheritItemSeq, containerItem, groupUuid) {
    var _a, _b;
    const items = [];
    const itemGroupUuid = groupUuid || (0, uuid_1.v4)();
    const isAppendable = (containerItem === null || containerItem === void 0 ? void 0 : containerItem.type) === "APPENDABLE_TABLE" || (containerItem === null || containerItem === void 0 ? void 0 : containerItem.type) === "FOLDABLE_TABLE" ? true : false;
    items.push({
        original: sliderItem,
        type: sliderItem.type,
        folderId: "folderId" in section ? section.folderId : null,
        visitId: "visitId" in section ? section.visitId : null,
        crfPageId: "crfPageId" in section ? section.crfPageId : null,
        sectionId: section.id,
        id: sliderItem.id,
        domain: sliderItem.domain,
        label: "label" in sliderItem ? sliderItem.label : null,
        required: sliderItem.required,
        dataType: sliderItem.dataType || "CHARACTER",
        capturable: true,
        querable: true,
        exportable: true,
        allowEmpty: sliderItem.allowEmpty,
        visibility: getVisibility(section.visibility, ...(relItems || []).map(e => e.visibility).filter(e => !!e), sliderItem.visibility),
        writability: getWritability(section.writability, ...(relItems || []).map(e => e.writability).filter(e => !!e), sliderItem.writability),
        availability: getAvailability(section, [sliderItem, ...(relItems || [])], inheritItemSeq),
        disability: getDisability(section, [sliderItem, ...(relItems || [])], inheritItemSeq),
        version: getVersion(section.version, sliderItem.version),
        unmodifiable: sliderItem.unmodifiable,
        inclusiveCapture: sliderItem.inclusiveCapture,
        onDemand: sliderItem.onDemand,
        appendable: isAppendable,
        confirmMessage: sliderItem.confirmMessage,
        throwExceptionIfEmpty: false,
        containerItem: containerItem,
        groupUuid: itemGroupUuid,
    });
    if (((_b = (_a = sliderItem.children) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length) > 0) {
        items.push(...Array.prototype.concat(...sliderItem.children.items.map(childrenItem => flattenManageableItemsByItem(section, childrenItem, relItems, containerItem, itemGroupUuid))));
    }
    return items;
}
exports.flattenManageableItemsBySliderItem = flattenManageableItemsBySliderItem;
// CheckItem 전용
function flattenManageableItemsByCheckItem(section, checkItem, relItems, inheritItemSeq, containerItem, groupUuid) {
    var _a, _b;
    const items = [];
    const itemGroupUuid = groupUuid || (0, uuid_1.v4)();
    const isAppendable = (containerItem === null || containerItem === void 0 ? void 0 : containerItem.type) === "APPENDABLE_TABLE" || (containerItem === null || containerItem === void 0 ? void 0 : containerItem.type) === "FOLDABLE_TABLE" ? true : false;
    if (checkItem.id) {
        items.push({
            original: checkItem,
            type: "CHECK_GROUP",
            folderId: hasOwnProperty(section, "folderId") ? section.folderId : null,
            visitId: hasOwnProperty(section, "visitId") ? section.visitId : null,
            crfPageId: hasOwnProperty(section, "crfPageId") ? section.crfPageId : null,
            sectionId: section.id,
            id: checkItem.id,
            domain: checkItem.domain,
            label: hasOwnProperty(checkItem, "label") ? checkItem.label : null,
            required: false,
            dataType: checkItem.dataType || "CHARACTER",
            capturable: false,
            querable: true,
            exportable: true,
            allowEmpty: null,
            visibility: getVisibility(section.visibility, ...(relItems || []).map(e => e.visibility).filter(e => !!e), checkItem.visibility),
            writability: getWritability(section.writability, ...(relItems || []).map(e => e.writability).filter(e => !!e), checkItem.writability),
            availability: getAvailability(section, [
                checkItem,
                ...(relItems || []),
                {
                    id: checkItem.id,
                    availability: checkItem.availability,
                },
            ], inheritItemSeq),
            disability: getDisability(section, [
                checkItem,
                ...(relItems || []),
                {
                    id: checkItem.id,
                    disability: checkItem.disability,
                },
            ], inheritItemSeq),
            version: getVersion(section.version, checkItem.version),
            comment: checkItem.comment,
            unmodifiable: checkItem.unmodifiable,
            inclusiveCapture: false,
            onDemand: undefined,
            appendable: isAppendable,
            confirmMessage: undefined,
            throwExceptionIfEmpty: false,
            containerItem: containerItem,
            groupUuid: itemGroupUuid,
        });
    }
    checkItem.itemCode.codes.forEach(itemCode => {
        items.push({
            original: checkItem,
            type: checkItem.type,
            folderId: hasOwnProperty(section, "folderId") ? section.folderId : null,
            visitId: hasOwnProperty(section, "visitId") ? section.visitId : null,
            crfPageId: hasOwnProperty(section, "crfPageId") ? section.crfPageId : null,
            sectionId: section.id,
            id: itemCode.id,
            domain: itemCode.domain,
            label: hasOwnProperty(checkItem, "label") ? checkItem.label : null,
            required: false,
            dataType: itemCode.dataType || "CHARACTER",
            capturable: true,
            querable: true,
            exportable: true,
            visibility: getVisibility(section.visibility, ...(relItems || []).map(e => e.visibility).filter(e => !!e), checkItem.visibility),
            writability: getWritability(section.writability, ...(relItems || []).map(e => e.writability).filter(e => !!e), checkItem.writability),
            availability: getAvailability(section, [
                checkItem,
                ...(relItems || []),
                {
                    id: itemCode.id,
                    availability: itemCode.availability,
                },
            ], inheritItemSeq),
            disability: getDisability(section, [checkItem, ...(relItems || [])], inheritItemSeq),
            version: getVersion(section.version, checkItem.version),
            comment: checkItem.comment,
            unmodifiable: checkItem.unmodifiable,
            inclusiveCapture: itemCode.inclusiveCapture,
            onDemand: itemCode.onDemand,
            appendable: isAppendable,
            confirmMessage: itemCode.confirmMessage,
            throwExceptionIfEmpty: false,
            containerItem: containerItem,
            groupUuid: itemGroupUuid,
        });
        if (itemCode.typeText) {
            items.push({
                original: { ...checkItem, inherit: true },
                type: "TEXT",
                folderId: hasOwnProperty(section, "folderId") ? section.folderId : null,
                visitId: hasOwnProperty(section, "visitId") ? section.visitId : null,
                crfPageId: hasOwnProperty(section, "crfPageId") ? section.crfPageId : null,
                sectionId: section.id,
                id: itemCode.typeText.id,
                domain: itemCode.typeText.domain,
                label: itemCode.typeText.label || itemCode.uiVal,
                required: false,
                allowEmpty: itemCode.typeText.allowEmpty ? itemCode.typeText.allowEmpty : null,
                dataType: itemCode.dataType || "CHARACTER",
                capturable: true,
                querable: true,
                exportable: true,
                visibility: getVisibility(section.visibility, ...(relItems || []).map(e => e.visibility).filter(e => !!e), checkItem.visibility),
                writability: getWritability(section.writability, ...(relItems || []).map(e => e.writability).filter(e => !!e), checkItem.writability),
                availability: getAvailability(section, [
                    checkItem,
                    {
                        id: itemCode.id,
                        availability: itemCode.availability,
                    },
                    {
                        id: itemCode.typeText.id,
                        availability: {
                            ref: "ITEM",
                            id: itemCode.id,
                            seq: checkItem.itemSeq || null,
                            condition: "=",
                            operand: itemCode.dbVal,
                        },
                    },
                    ...(relItems || []),
                ], inheritItemSeq),
                disability: getDisability(section, [checkItem, ...(relItems || [])], inheritItemSeq),
                version: getVersion(section.version, checkItem.version),
                comment: null,
                inclusiveCapture: itemCode.typeText.inclusiveCapture,
                onDemand: itemCode.typeText.onDemand,
                appendable: isAppendable,
                confirmMessage: undefined,
                throwExceptionIfEmpty: false,
                containerItem: containerItem,
                groupUuid: itemGroupUuid,
            });
        }
        if (itemCode.relatedText) {
            items.push({
                original: { ...checkItem, inherit: true },
                type: "TEXT",
                folderId: hasOwnProperty(section, "folderId") ? section.folderId : null,
                visitId: hasOwnProperty(section, "visitId") ? section.visitId : null,
                crfPageId: hasOwnProperty(section, "crfPageId") ? section.crfPageId : null,
                sectionId: section.id,
                id: itemCode.relatedText.id,
                domain: itemCode.relatedText.domain,
                label: itemCode.relatedText.label || itemCode.uiVal,
                required: false,
                allowEmpty: itemCode.relatedText.allowEmpty ? itemCode.relatedText.allowEmpty : null,
                dataType: itemCode.dataType || "CHARACTER",
                capturable: true,
                querable: true,
                exportable: true,
                visibility: getVisibility(section.visibility, ...(relItems || []).map(e => e.visibility).filter(e => !!e), checkItem.visibility),
                writability: getWritability(section.writability, ...(relItems || []).map(e => e.writability).filter(e => !!e), checkItem.writability),
                availability: getAvailability(section, [
                    checkItem,
                    {
                        id: itemCode.id,
                        availability: itemCode.availability,
                    },
                    {
                        id: itemCode.relatedText.id,
                        availability: {
                            ref: "ITEM",
                            id: itemCode.id,
                            seq: checkItem.itemSeq || null,
                            condition: "=",
                            operand: itemCode.dbVal,
                        },
                    },
                    ...(relItems || []),
                ], inheritItemSeq),
                disability: getDisability(section, [checkItem, ...(relItems || [])], inheritItemSeq),
                version: getVersion(section.version, checkItem.version),
                comment: null,
                inclusiveCapture: itemCode.relatedText.inclusiveCapture,
                onDemand: itemCode.relatedText.onDemand,
                appendable: isAppendable,
                confirmMessage: undefined,
                throwExceptionIfEmpty: false,
                containerItem: containerItem,
                groupUuid: itemGroupUuid,
            });
        }
    });
    if (((_b = (_a = checkItem.children) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length) > 0) {
        items.push(...Array.prototype.concat(...checkItem.children.items.map(childrenItem => flattenManageableItemsByItem(section, childrenItem, relItems, containerItem, itemGroupUuid))));
    }
    return items;
}
exports.flattenManageableItemsByCheckItem = flattenManageableItemsByCheckItem;
// Dictionary 전용
function flattenManageableItemsByDictionary(section, dictItem, relItems, inheritItemSeq, containerItem, groupUuid) {
    var _a, _b;
    const items = [];
    const itemGroupUuid = groupUuid || (0, uuid_1.v4)();
    const isAppendable = (containerItem === null || containerItem === void 0 ? void 0 : containerItem.type) === "APPENDABLE_TABLE" || (containerItem === null || containerItem === void 0 ? void 0 : containerItem.type) === "FOLDABLE_TABLE" ? true : false;
    items.push({
        original: dictItem,
        type: dictItem.type,
        folderId: hasOwnProperty(section, "folderId") ? section.folderId : null,
        visitId: hasOwnProperty(section, "visitId") ? section.visitId : null,
        crfPageId: hasOwnProperty(section, "crfPageId") ? section.crfPageId : null,
        sectionId: section.id,
        id: dictItem.id,
        domain: dictItem.domain,
        label: dictItem.label,
        required: dictItem.required,
        dataType: dictItem.dataType || "CHARACTER",
        capturable: true,
        querable: true,
        exportable: true,
        allowEmpty: dictItem.allowEmpty ? dictItem.allowEmpty : null,
        visibility: getVisibility(section.visibility, ...(relItems || []).map(e => e.visibility).filter(e => !!e), dictItem.visibility),
        writability: getWritability(section.writability, ...(relItems || []).map(e => e.writability).filter(e => !!e), dictItem.writability),
        availability: getAvailability(section, [dictItem, ...(relItems || [])], inheritItemSeq),
        disability: getDisability(section, [dictItem, ...(relItems || [])], inheritItemSeq),
        version: getVersion(section.version, dictItem.version),
        comment: dictItem.comment,
        unmodifiable: dictItem.unmodifiable,
        inclusiveCapture: dictItem.inclusiveCapture,
        onDemand: dictItem.onDemand,
        appendable: isAppendable,
        confirmMessage: dictItem.confirmMessage,
        throwExceptionIfEmpty: false,
        containerItem: containerItem,
        groupUuid: itemGroupUuid,
    });
    dictItem.related.forEach(related => {
        items.push({
            original: { ...dictItem, inherit: true },
            type: "SYS_VAL",
            folderId: hasOwnProperty(section, "folderId") ? section.folderId : null,
            visitId: hasOwnProperty(section, "visitId") ? section.visitId : null,
            crfPageId: hasOwnProperty(section, "crfPageId") ? section.crfPageId : null,
            sectionId: section.id,
            id: related.id,
            domain: related.domain,
            label: related.label || dictItem.label,
            required: false,
            dataType: related.dataType || "CHARACTER",
            capturable: true,
            querable: false,
            exportable: true,
            visibility: getVisibility(section.visibility, ...(relItems || []).map(e => e.visibility).filter(e => !!e), dictItem.visibility),
            writability: getWritability(section.writability, ...(relItems || []).map(e => e.writability).filter(e => !!e), dictItem.writability),
            availability: getAvailability(section, [dictItem, ...(relItems || [])], inheritItemSeq),
            disability: getDisability(section, [dictItem, ...(relItems || [])], inheritItemSeq),
            version: getVersion(section.version, dictItem.version),
            comment: null,
            appendable: isAppendable,
            confirmMessage: undefined,
            throwExceptionIfEmpty: false,
            containerItem: containerItem,
            groupUuid: itemGroupUuid,
        });
    });
    if (((_b = (_a = dictItem.children) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length) > 0) {
        items.push(...(0, lodash_1.flatten)(dictItem.children.items.map(childrenItem => flattenManageableItemsByItem(section, childrenItem, relItems, containerItem, itemGroupUuid))));
    }
    return items;
}
exports.flattenManageableItemsByDictionary = flattenManageableItemsByDictionary;
// Attachment 전용
function flattenManageableItemsByAttachment(section, attachmentItem, relItems, inheritItemSeq, containerItem, groupUuid) {
    const items = [];
    const itemGroupUuid = groupUuid || (0, uuid_1.v4)();
    const isAppendable = (containerItem === null || containerItem === void 0 ? void 0 : containerItem.type) === "APPENDABLE_TABLE" || (containerItem === null || containerItem === void 0 ? void 0 : containerItem.type) === "FOLDABLE_TABLE" ? true : false;
    items.push({
        original: attachmentItem,
        type: attachmentItem.type,
        folderId: hasOwnProperty(section, "folderId") ? section.folderId : null,
        visitId: hasOwnProperty(section, "visitId") ? section.visitId : null,
        crfPageId: hasOwnProperty(section, "crfPageId") ? section.crfPageId : null,
        sectionId: section.id,
        id: attachmentItem.id,
        domain: attachmentItem.domain,
        label: attachmentItem.label,
        required: attachmentItem.required,
        dataType: attachmentItem.dataType || "CHARACTER",
        capturable: true,
        querable: true,
        exportable: true,
        allowEmpty: attachmentItem.allowEmpty ? attachmentItem.allowEmpty : null,
        visibility: getVisibility(section.visibility, ...(relItems || []).map(e => e.visibility).filter(e => !!e), attachmentItem.visibility),
        writability: getWritability(section.writability, ...(relItems || []).map(e => e.writability).filter(e => !!e), attachmentItem.writability),
        availability: getAvailability(section, [attachmentItem, ...(relItems || [])], inheritItemSeq),
        disability: getDisability(section, [attachmentItem, ...(relItems || [])], inheritItemSeq),
        version: getVersion(section.version, attachmentItem.version),
        comment: attachmentItem.comment,
        unmodifiable: attachmentItem.unmodifiable,
        inclusiveCapture: attachmentItem.inclusiveCapture,
        onDemand: attachmentItem.onDemand,
        appendable: isAppendable,
        confirmMessage: attachmentItem.confirmMessage,
        throwExceptionIfEmpty: false,
        containerItem: containerItem,
        groupUuid: itemGroupUuid,
    });
    attachmentItem.related.forEach(related => {
        items.push({
            original: { ...attachmentItem, inherit: true },
            type: "SYS_VAL",
            folderId: hasOwnProperty(section, "folderId") ? section.folderId : null,
            visitId: hasOwnProperty(section, "visitId") ? section.visitId : null,
            crfPageId: hasOwnProperty(section, "crfPageId") ? section.crfPageId : null,
            sectionId: section.id,
            id: related.id,
            domain: related.domain,
            label: related.label || attachmentItem.label,
            required: false,
            dataType: related.dataType || "CHARACTER",
            capturable: true,
            querable: false,
            exportable: true,
            visibility: getVisibility(section.visibility, ...(relItems || []).map(e => e.visibility).filter(e => !!e), attachmentItem.visibility),
            writability: getWritability(section.writability, ...(relItems || []).map(e => e.writability).filter(e => !!e), attachmentItem.writability),
            availability: getAvailability(section, [attachmentItem, ...(relItems || [])], inheritItemSeq),
            disability: getDisability(section, [attachmentItem, ...(relItems || [])], inheritItemSeq),
            version: getVersion(section.version, attachmentItem.version),
            comment: null,
            appendable: isAppendable,
            confirmMessage: undefined,
            throwExceptionIfEmpty: false,
            containerItem: containerItem,
            groupUuid: itemGroupUuid,
        });
    });
    return items;
}
exports.flattenManageableItemsByAttachment = flattenManageableItemsByAttachment;
function retrieveItemLabelByPath(studySpec, path) {
    var _a;
    const { folderId, visitId, crfPageId, itemId, itemSeq } = path;
    const crfPage = retrieveCrfPageByPath(studySpec, { folderId, visitId, crfPageId });
    if (!crfPage)
        return null;
    const item = (_a = flattenManageableItems(studySpec, crfPage)) === null || _a === void 0 ? void 0 : _a.find(e => { var _a, _b; return e.id === itemId && (itemSeq ? ((_a = e.original) === null || _a === void 0 ? void 0 : _a.itemSeq) === itemSeq || !((_b = e.original) === null || _b === void 0 ? void 0 : _b.itemSeq) : true); });
    return (item === null || item === void 0 ? void 0 : item.label) || null;
}
exports.retrieveItemLabelByPath = retrieveItemLabelByPath;
function retrieveParentItemLabelByPath(spec, path) {
    const { folderId, visitId, visitSeq, crfPageId, itemId } = path;
    const folder = spec.folders.find(folder => folder.id === folderId);
    const crfPage = retrieveCrfPageByPath(spec, { folderId, visitId, crfPageId });
    let parentItemLabel = null;
    if (!(crfPage === null || crfPage === void 0 ? void 0 : crfPage.sections))
        return null;
    // NOTE. 저장 가능한 새로운 유형의 CrfItem이 추가될 경우 아래 코드에 정의해야 함
    crfPage.sections.forEach(section => {
        section.items.forEach(item => {
            if ((item.type === "CONSTANT" ||
                item.type === "TEXT" ||
                item.type === "DOUBLE_TEXT" || // @deprecated
                item.type === "AUTO_TEXT" ||
                item.type === "SEQUENCE_TEXT" ||
                item.type === "SYS_VAL" ||
                item.type === "DATE" ||
                item.type === "TIME" ||
                item.type === "FORMATTED_TIME" ||
                item.type === "SINGLE_SELECT" ||
                item.type === "DICTIONARY" ||
                item.type === "ATTACHMENT" ||
                item.type === "HIDDEN_VAL" ||
                item.type === "SYS_HIDDEN_VAL" ||
                item.type === "SLIDER") &&
                item.id === itemId) {
                parentItemLabel = getConditionalLabel(section.label, {
                    folderType: folder.type,
                    visitCode: getCrfVisitCode(folderId, visitId, visitSeq, spec),
                });
            }
            else if (item.type === "APPENDABLE_TABLE" || item.type === "FOLDABLE_TABLE") {
                item.cols.forEach(col => {
                    if ((col.type === "CONSTANT" ||
                        col.type === "TEXT" ||
                        col.type === "DOUBLE_TEXT" || // @deprecated
                        col.type === "AUTO_TEXT" ||
                        col.type === "SEQUENCE_TEXT" ||
                        col.type === "SYS_VAL" ||
                        col.type === "DATE" ||
                        col.type === "TIME" ||
                        col.type === "FORMATTED_TIME" ||
                        col.type === "SINGLE_SELECT" ||
                        col.type === "DICTIONARY" ||
                        col.type === "ATTACHMENT" ||
                        col.type === "SLIDER") &&
                        col.id === itemId) {
                        parentItemLabel = col.label;
                    }
                    else if (col.type === "CHECK" && (col.id === itemId || col.itemCode.codes.find(e => e.id === itemId))) {
                        parentItemLabel = col.label;
                    }
                });
            }
            else if (item.type === "TABLE") {
                item.rows.forEach(row => row.forEach(col => {
                    if ((col.type === "CONSTANT" ||
                        col.type === "TEXT" ||
                        col.type === "DOUBLE_TEXT" || // @deprecated
                        col.type === "AUTO_TEXT" ||
                        col.type === "SEQUENCE_TEXT" ||
                        col.type === "SYS_VAL" ||
                        col.type === "DATE" ||
                        col.type === "TIME" ||
                        col.type === "FORMATTED_TIME" ||
                        col.type === "SINGLE_SELECT" ||
                        col.type === "DICTIONARY" ||
                        col.type === "ATTACHMENT" ||
                        col.type === "SLIDER") &&
                        col.id === itemId) {
                        parentItemLabel = item.label;
                    }
                    else if (col.type === "CHECK" && (col.id === itemId || col.itemCode.codes.find(e => e.id === itemId))) {
                        parentItemLabel = item.label;
                    }
                }));
            }
            else if (item.type === "HORIZONTAL_GROUP") {
                item.items.forEach(item => {
                    if ((item.type === "CONSTANT" ||
                        item.type === "TEXT" ||
                        item.type === "DOUBLE_TEXT" || // @deprecated
                        item.type === "AUTO_TEXT" ||
                        item.type === "SEQUENCE_TEXT" ||
                        item.type === "SYS_VAL" ||
                        item.type === "DATE" ||
                        item.type === "TIME" ||
                        item.type === "FORMATTED_TIME" ||
                        item.type === "SINGLE_SELECT" ||
                        item.type === "DICTIONARY" ||
                        item.type === "ATTACHMENT" ||
                        item.type === "SLIDER") &&
                        item.id === itemId) {
                        parentItemLabel = item.label;
                    }
                    else if (item.type === "CHECK" && (item.id === itemId || item.itemCode.codes.find(e => e.id === itemId))) {
                        parentItemLabel = item.label;
                    }
                });
            }
        });
    });
    return parentItemLabel;
}
exports.retrieveParentItemLabelByPath = retrieveParentItemLabelByPath;
function getItemCodesByFlattenItem(item, itemTypes = ["SINGLE_SELECT"]) {
    var _a, _b;
    if (itemTypes.find(type => type === item.type)) {
        if (item.type === "SINGLE_SELECT" && ((_a = item.original) === null || _a === void 0 ? void 0 : _a.type) === "SINGLE_SELECT") {
            return item.original.itemCode.codes.map(x => ({ dbVal: x.dbVal, uiVal: x.uiVal }));
        }
        else if (item.type === "CHECK" && ((_b = item.original) === null || _b === void 0 ? void 0 : _b.type) === "CHECK" && "itemCode" in item.original) {
            const code = item.original.itemCode.codes.find(code => "id" in code && code.id && code.id === item.id);
            if (!code)
                return [];
            return [
                {
                    dbVal: code.dbVal,
                    uiVal: code.uiVal,
                },
            ];
        }
    }
    return [];
}
exports.getItemCodesByFlattenItem = getItemCodesByFlattenItem;
function isRequiredByFlattenItem(item) {
    if (item.required) {
        return true;
    }
    else {
        return false;
    }
}
exports.isRequiredByFlattenItem = isRequiredByFlattenItem;
function getItemLayoutByFlattenItem(item) {
    if (item.type === "TEXT") {
        return "TEXT";
    }
    // DOUBLE_TEXT type is deprecated
    else if (item.type === "DOUBLE_TEXT") {
        return "DOUBLE_TEXT";
    }
    else if (item.type === "DATE") {
        return "DATE";
    }
    else if (item.type === "TIME") {
        return "TIME";
    }
    else if (item.type === "FORMATTED_TIME") {
        return "TIME";
    }
    else if (item.type === "SINGLE_SELECT" && item.original.type === "SINGLE_SELECT") {
        if (item.original.layout === "RADIO") {
            return "RADIO";
        }
        else if (item.original.layout === "DROPDOWN") {
            return "DROPDOWN";
        }
    }
    else if (item.type === "SYS_VAL") {
        return "SYS_VAL";
    }
    else if (item.type === "HIDDEN_VAL") {
        if (item.original.type === "CONSTANT") {
            return "CONSTANT";
        }
        return "HIDDEN_VAL";
    }
    else if (item.type === "SYS_HIDDEN_VAL") {
        return "SYS_HIDDEN_VAL";
    }
    else if (item.type === "DICTIONARY") {
        return "DICTIONARY";
    }
    else if (item.type === "ATTACHMENT") {
        return "ATTACHMENT";
    }
    else if (item.type === "AUTO_TEXT") {
        return "AUTO_TEXT";
    }
    else if (item.type === "SEQUENCE") {
        return "SEQUENCE";
    }
    else if (item.type === "CHECK") {
        return "CHECK";
    }
    else if (item.type === "SIGNATURE") {
        return "SIGNATURE";
    }
    else if (item.type === "CHECK_GROUP") {
        return "CHECK_GROUP";
    }
    else if (item.type === "CONSTANT") {
        return "CONSTANT";
    }
    else if (item.type === "SLIDER") {
        return "SLIDER";
    }
    throw new Error(`Not Supported(getItemLayoutByFlattenItem), item.type (${item.type})`);
}
exports.getItemLayoutByFlattenItem = getItemLayoutByFlattenItem;
function crfTextItemPrefixReplacement(prefixReplace, targetValue) {
    var _a, _b;
    if (typeof prefixReplace === "string") {
        return prefixReplace;
    }
    else if (typeof prefixReplace === "object" && hasOwnProperty(prefixReplace, "replace")) {
        if (targetValue.siteCode && prefixReplace.replace.reserved === "SITE_CODE") {
            return (_a = prefixReplace.val) === null || _a === void 0 ? void 0 : _a.replace(prefixReplace.replace.find, targetValue.siteCode);
        }
        else if (prefixReplace.replace.reserved === "ITEM_REF") {
            return (_b = prefixReplace.val) === null || _b === void 0 ? void 0 : _b.replace(prefixReplace.replace.find, targetValue.itemValue || "");
        }
        else {
            throw new Error(`Not Supported (crfTextItemPrefixReplacement), {prefixReplace.replace.reserved}(${prefixReplace.replace.reserved})`);
        }
    }
    else {
        throw new Error(`Not Supported, {prefixReplace}(${prefixReplace})`);
    }
}
exports.crfTextItemPrefixReplacement = crfTextItemPrefixReplacement;
function getCharTypeForDbSpec(maxlen, minlen, dbPrefix, dbSuffix) {
    const converter = (maxlen, minlen, prefixLength, suffixLength) => {
        return maxlen === minlen
            ? `NCHAR(${maxlen + (prefixLength || 0) + (suffixLength || 0)})`
            : `NVARCHAR(${maxlen + (prefixLength || 0) + (suffixLength || 0)})`;
    };
    if (!dbPrefix) {
        return converter(maxlen, minlen, undefined, dbSuffix === null || dbSuffix === void 0 ? void 0 : dbSuffix.length);
    }
    else if (typeof dbPrefix === "string") {
        return converter(maxlen, minlen, dbPrefix.length, dbSuffix === null || dbSuffix === void 0 ? void 0 : dbSuffix.length);
    }
    else if (typeof dbPrefix === "object" && hasOwnProperty(dbPrefix, "maxlen")) {
        return converter(maxlen, minlen, dbPrefix.maxlen, dbSuffix === null || dbSuffix === void 0 ? void 0 : dbSuffix.length);
    }
    else {
        throw new Error(`Not Supported (getCharTypeForDbSpec), {dbPrefix}(${dbPrefix})`);
    }
}
function getItemVariableTypeByFlattenItem(item) {
    if (item.type === "TEXT") {
        if (item.original.type !== item.type) {
            if (item.original.type === "SINGLE_SELECT" || item.original.type === "CHECK") {
                const found = item.original.itemCode.codes.find(x => { var _a, _b; return ((_a = x.typeText) === null || _a === void 0 ? void 0 : _a.id) === item.id || ((_b = x.relatedText) === null || _b === void 0 ? void 0 : _b.id) === item.id; });
                if (found.relatedText) {
                    return { type: "TEXT", minlen: 0, maxlen: common_1.TextDefaultMaxLen, minval: null, maxval: null };
                }
                else {
                    if (hasOwnProperty(found.typeText, "maxlen")) {
                        return { type: "TEXT", minlen: 0, maxlen: found.typeText.maxlen || common_1.TextDefaultMaxLen, minval: null, maxval: null };
                    }
                    else {
                        return { type: "TEXT", minlen: 0, maxlen: common_1.TextDefaultMaxLen, minval: null, maxval: null };
                    }
                }
            }
        }
        else if (item.original.type === "TEXT" && item.original.format) {
            if (item.original.format.type === "TEXT") {
                return { type: "TEXT", minlen: item.original.format.minlen, maxlen: item.original.format.maxlen, minval: null, maxval: null };
            }
            else if (item.original.format.type === "CHAR") {
                return {
                    type: getCharTypeForDbSpec(item.original.format.maxlen, item.original.format.minlen, item.original.dbPrefix, item.original.dbSuffix),
                    minlen: null,
                    maxlen: null,
                    minval: null,
                    maxval: null,
                };
            }
            else if (item.original.format.type === "DECIMAL") {
                return {
                    type: `DECIMAL(${typeof item.original.format.precision === "number" ? item.original.format.precision : common_1.DecimalMaxLen},${typeof item.original.format.scale === "number" ? item.original.format.scale : 0})`,
                    minlen: null,
                    maxlen: null,
                    minval: item.original.format.minval,
                    maxval: item.original.format.maxval,
                };
            }
            else if (item.original.format.type === "NATURAL_NUMBER") {
                return { type: "NUMBER", minlen: null, maxlen: null, minval: item.original.format.minval, maxval: item.original.format.maxval };
            }
        }
        else {
            return { type: "TEXT", minlen: 0, maxlen: common_1.TextDefaultMaxLen, minval: null, maxval: null };
        }
    }
    else if (item.type === "SINGLE_SELECT" && item.original.type === "SINGLE_SELECT") {
        const minNum = (0, lodash_1.min)(item.original.itemCode.codes.filter(x => typeof x.dbVal === "number").map(x => x.dbVal));
        const maxNum = (0, lodash_1.max)(item.original.itemCode.codes.filter(x => typeof x.dbVal === "number").map(x => x.dbVal));
        const minLen = (0, lodash_1.min)(item.original.itemCode.codes.filter(x => typeof x.dbVal === "string").map(x => String(x.dbVal).length));
        const maxLen = (0, lodash_1.max)(item.original.itemCode.codes.filter(x => typeof x.dbVal === "string").map(x => String(x.dbVal).length));
        if (minNum !== undefined && maxNum !== undefined && minLen !== undefined && maxLen !== undefined) {
            return {
                type: "MIXED",
                minlen: Math.min(String(minNum).length, minLen),
                maxlen: Math.max(String(maxNum).length, maxLen),
                minval: null,
                maxval: null,
            };
        }
        else if (minLen !== undefined && maxLen !== undefined) {
            return {
                type: getCharTypeForDbSpec(maxLen, minLen),
                minlen: null,
                maxlen: null,
                minval: null,
                maxval: null,
            };
        }
        else if (minNum !== undefined && maxNum !== undefined) {
            return { type: "INT", minlen: null, maxlen: null, minval: minNum, maxval: maxNum };
        }
    }
    else if (item.type === "CHECK" && item.original.type === "CHECK") {
        const minNum = (0, lodash_1.min)(item.original.itemCode.codes.filter(x => typeof x.dbVal === "number").map(x => x.dbVal));
        const maxNum = (0, lodash_1.max)(item.original.itemCode.codes.filter(x => typeof x.dbVal === "number").map(x => x.dbVal));
        const minLen = (0, lodash_1.min)(item.original.itemCode.codes.filter(x => typeof x.dbVal === "string").map(x => String(x.dbVal).length));
        const maxLen = (0, lodash_1.max)(item.original.itemCode.codes.filter(x => typeof x.dbVal === "string").map(x => String(x.dbVal).length));
        if (minNum !== undefined && maxNum !== undefined && minLen !== undefined && maxLen !== undefined) {
            return {
                type: "MIXED",
                minlen: Math.min(String(minNum).length, minLen),
                maxlen: Math.max(String(maxNum).length, maxLen),
                minval: null,
                maxval: null,
            };
        }
        else if (minLen !== undefined && maxLen !== undefined) {
            return {
                type: getCharTypeForDbSpec(maxLen, minLen),
                minlen: null,
                maxlen: null,
                minval: null,
                maxval: null,
            };
        }
        else if (minNum !== undefined && maxNum !== undefined) {
            return { type: "INT", minlen: null, maxlen: null, minval: minNum, maxval: maxNum };
        }
    }
    else if (item.type === "DICTIONARY") {
        return { type: "TEXT_DICTIONARY", minlen: null, maxlen: null, minval: null, maxval: null };
    }
    else if (item.type === "ATTACHMENT") {
        return { type: "ATTACHMENT", minlen: null, maxlen: null, minval: null, maxval: null };
    }
    else if (item.type === "SEQUENCE") {
        return { type: "SEQUENCE", minlen: null, maxlen: null, minval: null, maxval: null };
    }
    else if (item.type === "CHECK_GROUP") {
        return { type: "CHECK_GROUP", minlen: null, maxlen: null, minval: null, maxval: null };
    }
    else if (item.type === "SLIDER" && item.original.type === "SLIDER") {
        return {
            type: "SLIDER",
            minlen: null,
            maxlen: null,
            minval: item.original.min,
            maxval: item.original.max,
        };
    }
    return { type: item.type, minlen: null, maxlen: null, minval: null, maxval: null };
}
exports.getItemVariableTypeByFlattenItem = getItemVariableTypeByFlattenItem;
function getItemDataDbTypeByFlattenItem(studySpec, item) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (item.type === "TEXT") {
        if (item.original.type !== item.type) {
            if (item.original.type === "SINGLE_SELECT" || item.original.type === "CHECK") {
                const found = item.original.itemCode.codes.find(x => { var _a, _b; return ((_a = x.typeText) === null || _a === void 0 ? void 0 : _a.id) === item.id || ((_b = x.relatedText) === null || _b === void 0 ? void 0 : _b.id) === item.id; });
                if (found.relatedText) {
                    if (found.relatedText.maxlen) {
                        return {
                            type: getCharTypeForDbSpec(found.relatedText.maxlen),
                            minlen: null,
                            maxlen: found.relatedText.maxlen,
                            minval: null,
                            maxval: null,
                        };
                    }
                    const relatedTextMaxlen = (0, lodash_1.reduce)(found.relatedText.value, (len, v) => {
                        if (v.type === "SEQUENCE")
                            return len + common_1.IntegerMaxLen;
                        else if (v.type === "CONSTANT")
                            return len + String(v.value || "").length;
                        else if (v.type === "ITEM") {
                            const refId = found.relatedText.ref.id;
                            const relatedItem = flattenExportableItems(studySpec, studySpec.pages[refId.crfPageId]).find(e => e.sectionId === refId.sectionId && e.id === v.id);
                            if (!relatedItem) {
                                throw new Error(`Not Found Related Item, {relatedText.value}(${v})`);
                            }
                            return len + getItemDataDbTypeByFlattenItem(studySpec, relatedItem).maxlen;
                        }
                        throw new Error(`Not Supported, {relatedText.value}(${v})`);
                    }, 0);
                    return {
                        type: getCharTypeForDbSpec(relatedTextMaxlen),
                        minlen: null,
                        maxlen: relatedTextMaxlen,
                        minval: null,
                        maxval: null,
                    };
                }
                else {
                    if (hasOwnProperty(found.typeText, "maxlen")) {
                        return {
                            type: getCharTypeForDbSpec(found.typeText.maxlen || common_1.TextDefaultMaxLen),
                            minlen: null,
                            maxlen: found.typeText.maxlen || common_1.TextDefaultMaxLen,
                            minval: null,
                            maxval: null,
                        };
                    }
                    else {
                        return getItemDataDbTypeByCrfTextItemFormat(found.typeText.format);
                    }
                }
            }
        }
        else if (item.original.type === "TEXT") {
            return getItemDataDbTypeByCrfItemSpec(item.original);
        }
        else {
            throw new Error(`Not Supported, item.original (${item.original})`);
        }
    }
    else if (item.type === "SINGLE_SELECT" && item.original.type === "SINGLE_SELECT") {
        return getItemDataDbTypeByCrfItemSpec(item.original);
    }
    else if (item.type === "CHECK" && item.original.type === "CHECK") {
        return getItemDataDbTypeByCrfItemSpec(item.original, item.id);
    }
    else if (item.type === "DICTIONARY" && item.original.type === "DICTIONARY") {
        return getItemDataDbTypeByCrfItemSpec(item.original);
    }
    else if (item.type === "ATTACHMENT" && item.original.type === "ATTACHMENT") {
        return getItemDataDbTypeByCrfItemSpec(item.original);
    }
    else if (item.type === "SEQUENCE" && item.original.type === "SEQUENCE") {
        return getItemDataDbTypeByCrfItemSpec(item.original);
    }
    else if (item.type === "DATE" && item.original.type === "DATE") {
        return getItemDataDbTypeByCrfItemSpec(item.original);
    }
    else if (item.type === "SYS_VAL") {
        if (item.original.type === "DICTIONARY" || item.original.type === "ATTACHMENT") {
            const relatedItem = item.original.type === "DICTIONARY"
                ? item.original.related.find(e => e.id === item.id)
                : item.original.type === "ATTACHMENT"
                    ? item.original.related.find(e => e.id === item.id)
                    : null;
            if (relatedItem) {
                if (relatedItem.dataType === "NUMERIC") {
                    return { type: "INTEGER", minlen: 0, maxlen: relatedItem.maxlen || common_1.IntegerMaxLen, minval: null, maxval: null };
                }
                else if (relatedItem.dataType === "CHARACTER") {
                    return {
                        type: getCharTypeForDbSpec(relatedItem.maxlen || common_1.TextDefaultMaxLen),
                        minlen: 0,
                        maxlen: relatedItem.maxlen || common_1.TextDefaultMaxLen,
                        minval: null,
                        maxval: null,
                    };
                }
                else if (relatedItem.dataType === "DATE") {
                    return {
                        type: getCharTypeForDbSpec(relatedItem.maxlen || "YYYY/MM/DD".length),
                        minlen: 0,
                        maxlen: relatedItem.maxlen || "YYYY/MM/DD".length,
                        minval: null,
                        maxval: null,
                    };
                }
                else if (relatedItem.dataType === "DATETIME") {
                    return {
                        type: getCharTypeForDbSpec(relatedItem.maxlen || "YYYY/MM/DD HH:mm:ss".length),
                        minlen: 0,
                        maxlen: relatedItem.maxlen || "YYYY/MM/DD HH:mm:ss".length,
                        minval: null,
                        maxval: null,
                    };
                }
                return {
                    type: getCharTypeForDbSpec(relatedItem.maxlen),
                    minlen: null,
                    maxlen: relatedItem.maxlen,
                    minval: null,
                    maxval: null,
                };
            }
        }
        return getItemDataDbTypeByCrfItemSpec(item.original);
    }
    else if (item.type === "AUTO_TEXT" && item.original.type === "AUTO_TEXT") {
        return getItemDataDbTypeByCrfItemSpec(item.original);
    }
    else if (item.type === "SIGNATURE" && item.original.type === "SIGNATURE") {
        return getItemDataDbTypeByCrfItemSpec(item.original);
    }
    // DOUBLE_TEXT type is deprecated
    else if (item.type === "DOUBLE_TEXT" && item.original.type === "DOUBLE_TEXT") {
        return getItemDataDbTypeByCrfItemSpec(item.original);
    }
    else if (item.type === "TIME" && item.original.type === "TIME") {
        return getItemDataDbTypeByCrfItemSpec(item.original);
    }
    else if (item.type === "FORMATTED_TIME" && item.original.type === "FORMATTED_TIME") {
        return getItemDataDbTypeByCrfItemSpec(item.original);
    }
    else if (item.type === "CHECK_GROUP") {
        return { type: getCharTypeForDbSpec(0), minlen: null, maxlen: 0, minval: null, maxval: null };
    }
    else if (item.type === "HIDDEN_VAL") {
        if (item.original.type === "CONSTANT" && item.original.subItem) {
            const subItem = item.original.subItem;
            if (item.dataType === "NUMERIC") {
                return { type: "INTEGER", minlen: 0, maxlen: subItem.maxlen || common_1.IntegerMaxLen, minval: null, maxval: null };
            }
            else if (item.dataType === "CHARACTER") {
                return {
                    type: getCharTypeForDbSpec(subItem.maxlen || common_1.TextDefaultMaxLen),
                    minlen: 0,
                    maxlen: subItem.maxlen || common_1.TextDefaultMaxLen,
                    minval: null,
                    maxval: null,
                };
            }
            else if (subItem.dataType === "DATE") {
                return {
                    type: getCharTypeForDbSpec(subItem.maxlen || "YYYY/MM/DD".length),
                    minlen: 0,
                    maxlen: subItem.maxlen || "YYYY/MM/DD".length,
                    minval: null,
                    maxval: null,
                };
            }
            else if (subItem.dataType === "DATETIME") {
                return {
                    type: getCharTypeForDbSpec(subItem.maxlen || "YYYY/MM/DD HH:mm:ss".length),
                    minlen: 0,
                    maxlen: subItem.maxlen || "YYYY/MM/DD HH:mm:ss".length,
                    minval: null,
                    maxval: null,
                };
            }
            return {
                type: getCharTypeForDbSpec(subItem.maxlen),
                minlen: subItem.minlen,
                maxlen: subItem.maxlen,
                minval: null,
                maxval: null,
            };
        }
        return getItemDataDbTypeByCrfItemSpec(item.original);
    }
    else if (item.original.type === "CONSTANT") {
        return getItemDataDbTypeByCrfItemSpec(item.original);
    }
    else if (item.original.type === "SLIDER") {
        if (((_a = item.original.format) === null || _a === void 0 ? void 0 : _a.type) === "NUMBER") {
            return {
                type: "INTEGER",
                minlen: (_b = item.original.format.minlen) !== null && _b !== void 0 ? _b : 0,
                maxlen: (_c = item.original.format.maxlen) !== null && _c !== void 0 ? _c : common_1.IntegerMaxLen,
                minval: item.original.min,
                maxval: item.original.max,
            };
        }
        else {
            return {
                type: `DECIMAL(${typeof ((_d = item.original.format) === null || _d === void 0 ? void 0 : _d.precision) === "number" ? (_e = item.original.format) === null || _e === void 0 ? void 0 : _e.precision : common_1.DecimalMaxLen},${typeof ((_f = item.original.format) === null || _f === void 0 ? void 0 : _f.scale) === "number" ? (_g = item.original.format) === null || _g === void 0 ? void 0 : _g.scale : 0})`,
                minlen: 0,
                maxlen: common_1.DecimalMaxLen,
                minval: item.original.min,
                maxval: item.original.max,
            };
        }
    }
    throw new Error(`Not Supported, item.type (${item.type})`);
}
exports.getItemDataDbTypeByFlattenItem = getItemDataDbTypeByFlattenItem;
function getItemDataDbTypeByCrfItemSpec(item, itemId) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    if (item.type === "TEXT") {
        if (item.format) {
            return getItemDataDbTypeByCrfTextItemFormat({
                ...item.format,
                dbPrefix: item.dbPrefix || undefined,
                dbSuffix: item.dbSuffix || undefined,
            });
        }
        else {
            return {
                type: getCharTypeForDbSpec(common_1.TextDefaultMaxLen),
                minlen: null,
                maxlen: common_1.TextDefaultMaxLen,
                minval: null,
                maxval: null,
            };
        }
    }
    // DOUBLE_TEXT type is deprecated
    else if (item.type === "DOUBLE_TEXT") {
        if (((_a = item.format) === null || _a === void 0 ? void 0 : _a.type) === "DECIMAL") {
            const decimalPointLen = item.format.scale ? 1 : 0;
            const maxlen = ((typeof item.format.precision === "number" ? item.format.precision : common_1.DecimalMaxLen) + decimalPointLen) * 2 +
                String(item.delimiter || "").length;
            return {
                type: getCharTypeForDbSpec(maxlen),
                minlen: null,
                maxlen: maxlen,
                minval: null,
                maxval: null,
            };
        }
        else if (((_b = item.format) === null || _b === void 0 ? void 0 : _b.type) === "NATURAL_NUMBER") {
            if (item.format.interface === "NUMBER") {
                const format = item.format;
                const maxlen = (Math.max(Math.max(String(typeof format.maxval === "number" ? format.maxval : "").length, String(typeof format.minval === "number" ? format.minval : "").length), format.maxlen) || common_1.IntegerMaxLen) *
                    2 +
                    String(item.delimiter || "").length;
                return {
                    type: getCharTypeForDbSpec(maxlen),
                    minlen: null,
                    maxlen: maxlen,
                    minval: null,
                    maxval: null,
                };
            }
            else if (item.format.interface === "TEXT") {
                const maxlen = (typeof item.format.maxlen === "number" ? item.format.maxlen * 2 : common_1.IntegerMaxLen * 2) + String(item.delimiter || "").length;
                return {
                    type: getCharTypeForDbSpec(maxlen),
                    minlen: null,
                    maxlen: maxlen,
                    minval: null,
                    maxval: null,
                };
            }
            else {
                throw new Error(`Not Supported, item.format.interface (${item.format.interface})`);
            }
        }
        else {
            const len = common_1.TextDefaultMaxLen * 2 + String(item.delimiter || "").length;
            return {
                type: getCharTypeForDbSpec(len),
                minlen: null,
                maxlen: len,
                minval: null,
                maxval: null,
            };
        }
    }
    else if (item.type === "DATE") {
        return {
            type: getCharTypeForDbSpec(String(item.format || "YYYY/MM/DD").length),
            minlen: null,
            maxlen: String(item.format || "YYYY/MM/DD").length,
            minval: null,
            maxval: null,
        };
    }
    else if (item.type === "TIME") {
        const len = "hhmm".length + String(item.delimiter || "").length + String(item.dbPrefix || "").length + String(item.dbSuffix || "").length;
        return {
            type: getCharTypeForDbSpec(len, len),
            minlen: len,
            maxlen: len,
            minval: null,
            maxval: null,
        };
    }
    else if (item.type === "FORMATTED_TIME") {
        const tempUiVal = getFormattedTimeUiVal(item, "000000");
        const len = tempUiVal.length;
        return {
            type: getCharTypeForDbSpec(len, len),
            minlen: len,
            maxlen: len,
            minval: null,
            maxval: null,
        };
    }
    else if (item.type === "SINGLE_SELECT") {
        const minNum = (0, lodash_1.min)(item.itemCode.codes.filter(x => typeof x.dbVal === "number").map(x => x.dbVal));
        const maxNum = (0, lodash_1.max)(item.itemCode.codes.filter(x => typeof x.dbVal === "number").map(x => x.dbVal));
        const minLen = (0, lodash_1.min)(item.itemCode.codes.filter(x => typeof x.dbVal === "string").map(x => String(x.dbVal).length));
        const maxLen = (0, lodash_1.max)(item.itemCode.codes.filter(x => typeof x.dbVal === "string").map(x => String(x.dbVal).length));
        if (minNum !== undefined && maxNum !== undefined && minLen !== undefined && maxLen !== undefined) {
            const mixedMinlen = Math.min(Math.min(String(typeof maxNum === "number" ? maxNum : "").length, String(typeof minNum === "number" ? minNum : "").length), minLen);
            const mixedMaxlen = Math.max(Math.max(String(typeof maxNum === "number" ? maxNum : "").length, String(typeof minNum === "number" ? minNum : "").length), maxLen);
            return {
                type: getCharTypeForDbSpec(mixedMaxlen, mixedMinlen),
                minlen: mixedMinlen,
                maxlen: mixedMaxlen,
                minval: null,
                maxval: null,
            };
        }
        else if (minLen !== undefined && maxLen !== undefined) {
            return {
                type: getCharTypeForDbSpec(maxLen, minLen),
                minlen: minLen,
                maxlen: maxLen,
                minval: null,
                maxval: null,
            };
        }
        else if (minNum !== undefined && maxNum !== undefined) {
            const maxlen = Math.max(String(typeof maxNum === "number" ? maxNum : "").length, String(typeof minNum === "number" ? minNum : "").length);
            return { type: "INTEGER", minlen: null, maxlen: maxlen || common_1.IntegerMaxLen, minval: minNum, maxval: maxNum };
        }
        else {
            throw new Error(`Not Supported, item.type(SINGLE_SELECT) (minNum: ${minNum}, maxNum: ${maxNum}, minLen: ${minLen}, maxLen: ${maxLen})`);
        }
    }
    else if (item.type === "SYS_VAL" || item.type === "HIDDEN_VAL") {
        if (item.type === "HIDDEN_VAL" && item.format) {
            if (item.format === "YYYY/MM/DD" ||
                item.format === "YYYY-MM-DD" ||
                item.format === "DD-MMM-YYYY" ||
                item.format === "DD/MMM/YYYY" ||
                item.format === "YYYY-MM" ||
                item.format === "YYYY/MM" ||
                item.format === "YYYY" ||
                item.format === "MMM/YYYY") {
                return {
                    type: getCharTypeForDbSpec(item.format.length, item.format.length),
                    minlen: item.format.length,
                    maxlen: item.format.length,
                    minval: null,
                    maxval: null,
                };
            }
            else {
                return getItemDataDbTypeByCrfTextItemFormat(item.format);
            }
        }
        if (item.dataType === "NUMERIC") {
            return { type: "INTEGER", minlen: item.minlen, maxlen: item.maxlen || common_1.IntegerMaxLen, minval: null, maxval: null };
        }
        else if (item.dataType === "CHARACTER") {
            return {
                type: getCharTypeForDbSpec(item.maxlen || common_1.TextDefaultMaxLen),
                minlen: item.minlen,
                maxlen: item.maxlen || common_1.TextDefaultMaxLen,
                minval: null,
                maxval: null,
            };
        }
        else if (item.dataType === "DATE") {
            return {
                type: getCharTypeForDbSpec(item.maxlen || "YYYY/MM/DD".length),
                minlen: item.minlen,
                maxlen: item.maxlen || "YYYY/MM/DD".length,
                minval: null,
                maxval: null,
            };
        }
        else if (item.dataType === "DATETIME") {
            return {
                type: getCharTypeForDbSpec(item.maxlen || "YYYY/MM/DD HH:mm:ss".length),
                minlen: item.minlen,
                maxlen: item.maxlen || "YYYY/MM/DD HH:mm:ss".length,
                minval: null,
                maxval: null,
            };
        }
        return {
            type: getCharTypeForDbSpec(item.maxlen || common_1.TextDefaultMaxLen),
            minlen: item.minlen,
            maxlen: item.maxlen || common_1.TextDefaultMaxLen,
            minval: null,
            maxval: null,
        };
    }
    else if (item.type === "CHECK") {
        if (!itemId) {
            throw new Error(`Not Supported, item.type(CHECK) has no itemId value on itemCode: ${item.itemCode.codes}}`);
        }
        const minNum = (0, lodash_1.min)(item.itemCode.codes.filter(x => typeof x.dbVal === "number" && x.id === itemId).map(x => x.dbVal));
        const maxNum = (0, lodash_1.max)(item.itemCode.codes.filter(x => typeof x.dbVal === "number" && x.id === itemId).map(x => x.dbVal));
        const minLen = (0, lodash_1.min)(item.itemCode.codes.filter(x => typeof x.dbVal === "string" && x.id === itemId).map(x => String(x.dbVal).length));
        const maxLen = (0, lodash_1.max)(item.itemCode.codes.filter(x => typeof x.dbVal === "string" && x.id === itemId).map(x => String(x.dbVal).length));
        if (minNum !== undefined && maxNum !== undefined && minLen !== undefined && maxLen !== undefined) {
            const mixedMinlen = Math.min(Math.min(String(typeof maxNum === "number" ? maxNum : "").length, String(typeof minNum === "number" ? minNum : "").length), minLen);
            const mixedMaxlen = Math.max(Math.max(String(typeof maxNum === "number" ? maxNum : "").length, String(typeof minNum === "number" ? minNum : "").length), maxLen);
            return {
                type: getCharTypeForDbSpec(mixedMaxlen, mixedMinlen),
                minlen: mixedMinlen,
                maxlen: mixedMaxlen,
                minval: null,
                maxval: null,
            };
        }
        else if (minLen !== undefined && maxLen !== undefined) {
            return {
                type: getCharTypeForDbSpec(maxLen, minLen),
                minlen: minLen,
                maxlen: maxLen,
                minval: null,
                maxval: null,
            };
        }
        else if (minNum !== undefined && maxNum !== undefined) {
            const maxlen = Math.max(String(typeof maxNum === "number" ? maxNum : "").length, String(typeof minNum === "number" ? minNum : "").length);
            return { type: "INTEGER", minlen: null, maxlen: maxlen || common_1.IntegerMaxLen, minval: minNum, maxval: maxNum };
        }
        else {
            throw new Error(`Not Supported, item.type(CHECK) (minNum: ${minNum}, maxNum: ${maxNum}, minLen: ${minLen}, maxLen: ${maxLen})`);
        }
    }
    else if (item.type === "AUTO_TEXT") {
        if (item.format) {
            if (item.format === "YYYY/MM/DD" ||
                item.format === "YYYY-MM-DD" ||
                item.format === "DD-MMM-YYYY" ||
                item.format === "DD/MMM/YYYY" ||
                item.format === "YYYY-MM" ||
                item.format === "YYYY/MM" ||
                item.format === "YYYY" ||
                item.format === "MMM/YYYY") {
                return {
                    type: getCharTypeForDbSpec(item.format.length, item.format.length),
                    minlen: item.format.length,
                    maxlen: item.format.length,
                    minval: null,
                    maxval: null,
                };
            }
            else {
                return getItemDataDbTypeByCrfTextItemFormat(item.format);
            }
        }
        return {
            type: getCharTypeForDbSpec(item.maxlen, item.minlen),
            minlen: item.minlen,
            maxlen: item.maxlen,
            minval: null,
            maxval: null,
        };
    }
    else if (item.type === "SEQUENCE") {
        return { type: "INTEGER", minlen: null, maxlen: common_1.IntegerMaxLen, minval: null, maxval: null };
    }
    else if (item.type === "DICTIONARY") {
        return {
            type: getCharTypeForDbSpec(item.maxlen || common_1.TextDefaultMaxLen),
            minlen: null,
            maxlen: item.maxlen || common_1.TextDefaultMaxLen,
            minval: null,
            maxval: null,
        };
    }
    else if (item.type === "ATTACHMENT") {
        return {
            type: getCharTypeForDbSpec(common_1.AttachmentMaxLen),
            minlen: null,
            maxlen: common_1.AttachmentMaxLen,
            minval: null,
            maxval: null,
        };
    }
    else if (item.type === "SIGNATURE") {
        return {
            type: getCharTypeForDbSpec(common_1.SignatureMaxLen),
            minlen: null,
            maxlen: common_1.SignatureMaxLen,
            minval: null,
            maxval: null,
        };
    }
    else if (item.type === "CONSTANT") {
        if (item.dataType === "NUMERIC") {
            return { type: "INTEGER", minlen: null, maxlen: common_1.IntegerMaxLen, minval: null, maxval: null };
        }
        const maxlen = (item.value || "").length;
        return {
            type: getCharTypeForDbSpec(maxlen),
            minlen: null,
            maxlen: maxlen,
            minval: null,
            maxval: null,
        };
    }
    else if (item.type === "SLIDER") {
        if (((_c = item.format) === null || _c === void 0 ? void 0 : _c.type) === "NUMBER") {
            return {
                type: "INTEGER",
                minlen: (_e = (_d = item.format) === null || _d === void 0 ? void 0 : _d.minlen) !== null && _e !== void 0 ? _e : 0,
                maxlen: (_g = (_f = item.format) === null || _f === void 0 ? void 0 : _f.maxlen) !== null && _g !== void 0 ? _g : common_1.IntegerMaxLen,
                minval: item.min,
                maxval: item.max,
            };
        }
        else {
            return {
                type: `DECIMAL(${typeof ((_h = item.format) === null || _h === void 0 ? void 0 : _h.precision) === "number" ? (_j = item.format) === null || _j === void 0 ? void 0 : _j.precision : common_1.DecimalMaxLen},${typeof ((_k = item.format) === null || _k === void 0 ? void 0 : _k.scale) === "number" ? (_l = item.format) === null || _l === void 0 ? void 0 : _l.scale : 0})`,
                minlen: 0,
                maxlen: common_1.DecimalMaxLen,
                minval: item.min,
                maxval: item.max,
            };
        }
    }
    throw new Error(`Not Supported(getItemDataDbTypeByCrfItemSpec), item.type (${item.type})`);
}
function getItemDataDbTypeByCrfTextItemFormat(format) {
    var _a, _b, _c;
    if (format.type === "TEXT") {
        return {
            type: getCharTypeForDbSpec(format.maxlen),
            minlen: format.minlen,
            maxlen: format.maxlen,
            minval: null,
            maxval: null,
        };
    }
    else if (format.type === "CHAR") {
        return {
            type: getCharTypeForDbSpec(format.maxlen, undefined, format.dbPrefix, format.dbSuffix),
            minlen: format.minlen,
            maxlen: format.maxlen +
                (typeof format.dbPrefix === "string" ? (_a = format.dbPrefix) === null || _a === void 0 ? void 0 : _a.length : ((_b = format.dbPrefix) === null || _b === void 0 ? void 0 : _b.maxlen) || 0) +
                (((_c = format.dbSuffix) === null || _c === void 0 ? void 0 : _c.length) || 0),
            minval: null,
            maxval: null,
        };
    }
    else if (format.type === "DECIMAL") {
        return {
            type: `DECIMAL(${typeof format.precision === "number" ? format.precision : common_1.DecimalMaxLen},${typeof format.scale === "number" ? format.scale : 0})`,
            minlen: null,
            maxlen: null,
            minval: format.minval,
            maxval: format.maxval,
        };
    }
    else if (format.type === "NATURAL_NUMBER") {
        if (format.interface === "NUMBER") {
            const maxlen = Math.max(String(typeof format.maxval === "number" ? format.maxval : "").length, String(typeof format.minval === "number" ? format.minval : "").length, format.maxlen);
            return {
                type: "INTEGER",
                minlen: null,
                maxlen: maxlen || common_1.IntegerMaxLen,
                minval: format.minval,
                maxval: format.maxval,
            };
        }
        else if (format.interface === "TEXT") {
            return {
                type: getCharTypeForDbSpec(format.maxlen),
                minlen: format.minlen,
                maxlen: format.maxlen,
                minval: null,
                maxval: null,
            };
        }
        else {
            throw new Error(`Not Supported(getItemDataDbTypeByCrfTextItemFormat), format.interface (${format.interface})`);
        }
    }
    // TODO: Log 확인 시 Format이 [Object, object]로 확인됨.
    throw new Error(`Not Supported(getItemDataDbTypeByCrfTextItemFormat), format (${format})`);
}
function retrieveParentItemLabel(spec, target) {
    // TODO.
    // Target: APPENDABLE_TABLE에 포함된 Item일 경우 -> APPENDABLE_TABLE의 Label
    // Target: TABLE에 포함된 Item일 경우 -> TABLE의 Label
    // Target: Item일 경우 -> Section의 Label
    return spec && target ? "PARENT_ITEM_LABEL" : null;
}
exports.retrieveParentItemLabel = retrieveParentItemLabel;
function getVersion(...args) {
    return (0, lodash_1.uniqWith)((0, lodash_1.flatten)([].concat(...args).filter(x => x)));
}
function getVisibility(...args) {
    return [].concat(...args.filter(x => x).map(x => (Array.isArray(x) ? x : [x]))).filter(x => x);
}
function getWritability(...args) {
    return [].concat(...args.filter(x => x).map(x => (Array.isArray(x) ? x : [x]))).filter(x => x);
}
function getAvailability(section, items, inheritItemSeq) {
    const result = [];
    if (section.availability) {
        const availabilities = arrayify(section.availability);
        const convertedSectionAvailabilities = availabilities.map(x => {
            if (hasOwnProperty(x, "operator")) {
                return x;
            }
            else {
                if (x.ref === "ITEM")
                    return {
                        id: {
                            folderId: hasOwnProperty(section, "folderId") ? section.folderId : null,
                            visitId: hasOwnProperty(section, "visitId") ? section.visitId : null,
                            crfPageId: hasOwnProperty(section, "crfPageId") ? section.crfPageId : null,
                            sectionId: section.id,
                            itemId: x.id,
                            itemSeq: x.seq || common_1.InitialItemSequence,
                        },
                        operand: x.operand,
                        condition: x.condition,
                    };
                else
                    throw new Error(`Not Supported, {section.availability.ref}(${x.ref})`);
            }
        });
        result.push(...convertedSectionAvailabilities);
    }
    if (items.length > 0) {
        items.forEach(item => {
            if (!!item && !!item.availability) {
                const itemAvailabilities = arrayify(item.availability);
                if (itemAvailabilities.length > 0) {
                    itemAvailabilities.forEach(x => {
                        if (hasOwnProperty(x, "operator")) {
                            result.push(x);
                        }
                        else {
                            if (x.ref === "ITEM")
                                result.push({
                                    id: {
                                        folderId: hasOwnProperty(section, "folderId") ? section.folderId : null,
                                        visitId: hasOwnProperty(section, "visitId") ? section.visitId : null,
                                        crfPageId: hasOwnProperty(section, "crfPageId") ? section.crfPageId : null,
                                        sectionId: section.id,
                                        itemId: x.id,
                                        itemSeq: hasOwnProperty(x, "seq") && typeof x.seq === "number" ? x.seq : inheritItemSeq ? null : common_1.InitialItemSequence,
                                    },
                                    operand: x.operand,
                                    condition: x.condition,
                                });
                            else
                                throw new Error(`Not Supported, {section.availability.ref}(${x.ref})`);
                        }
                    });
                }
            }
        });
    }
    return result.length > 0 ? result : undefined;
}
function getDisability(section, items, inheritItemSeq) {
    const result = [];
    if (items.length > 0) {
        items.forEach(item => {
            if (!!item && !!item.disability) {
                const itemDisabilities = arrayify(item.disability);
                if (itemDisabilities.length > 0) {
                    itemDisabilities.forEach(x => {
                        if (hasOwnProperty(x, "operator")) {
                            result.push(x);
                        }
                        else {
                            if (x.ref === "ITEM")
                                result.push({
                                    id: {
                                        folderId: hasOwnProperty(section, "folderId") ? section.folderId : null,
                                        visitId: hasOwnProperty(section, "visitId") ? section.visitId : null,
                                        crfPageId: hasOwnProperty(section, "crfPageId") ? section.crfPageId : null,
                                        sectionId: section.id,
                                        itemId: x.id,
                                        itemSeq: hasOwnProperty(x, "seq") && typeof x.seq === "number" ? x.seq : inheritItemSeq ? null : common_1.InitialItemSequence,
                                    },
                                    operand: x.operand,
                                    condition: x.condition,
                                });
                            else
                                throw new Error(`Not Supported, {section.disability.ref}(${x.ref})`);
                        }
                    });
                }
            }
        });
    }
    return result.length > 0 ? result : undefined;
}
function arrayify(e) {
    return Array.isArray(e) ? e : [e];
}
exports.arrayify = arrayify;
function checkVisibility(visibilitiesOr, on) {
    if (!on || !visibilitiesOr || (Array.isArray(visibilitiesOr) && visibilitiesOr.length === 0))
        return true;
    const visibilities = arrayify(visibilitiesOr);
    for (const visibility of visibilities) {
        if (!isVisitVisibility(visibility, on)) {
            return false;
        }
    }
    return true;
}
exports.checkVisibility = checkVisibility;
function checkCrfWritability(writability, on) {
    if (!on || !writability || (Array.isArray(writability) && writability.length === 0))
        return true;
    const writabilities = arrayify(writability);
    for (const w of writabilities) {
        if (!isVisitVisibility(w, on)) {
            return false;
        }
    }
    return true;
}
exports.checkCrfWritability = checkCrfWritability;
function checkUnblindReqPreAvailability(preAvailability, crfStatuses) {
    if (!preAvailability || (Array.isArray(preAvailability) && preAvailability.length === 0))
        return true;
    const visibilities = arrayify(preAvailability);
    for (const visibility of visibilities) {
        if (!isUnblindReqPreAvailability(visibility, crfStatuses)) {
            return false;
        }
    }
    return true;
}
exports.checkUnblindReqPreAvailability = checkUnblindReqPreAvailability;
function isUnblindReqPreAvailability(preAvailability, crfStatuses) {
    if (!preAvailability)
        return true;
    if (hasOwnProperty(preAvailability, "operator")) {
        if (preAvailability.operator === "AND") {
            for (const exp of preAvailability.expr) {
                if (!isUnblindReqPreAvailability(exp, crfStatuses)) {
                    return false;
                }
            }
            return true;
        }
        else if (preAvailability.operator === "OR") {
            for (const exp of preAvailability.expr) {
                if (isUnblindReqPreAvailability(exp, crfStatuses)) {
                    return true;
                }
            }
            return false;
        }
    }
    else {
        if (preAvailability.type === "CRF_STATUS") {
            const crf = crfStatuses.find(e => e.groupId === preAvailability.groupId &&
                e.folderId === preAvailability.folderId &&
                e.visitId === preAvailability.visitId &&
                e.visitSeq === preAvailability.visitSeq &&
                e.crfPageId === preAvailability.crfPageId &&
                ("crfPageSeq" in preAvailability && preAvailability.crfPageSeq ? e.crfPageSeq === preAvailability.crfPageSeq : true));
            if (!crf)
                return false;
            if (preAvailability.condition === "=") {
                if (preAvailability.operand !== "SAVED" && preAvailability.operand !== "FREEZED")
                    throw new Error(`Not Supprted! (isUnblindReqVisibility), visibility.operand === ${preAvailability.operand}`);
                else if (preAvailability.operand === "SAVED" && !crf.isSaved)
                    return false;
                else if (preAvailability.operand === "FREEZED" && !crf.isFreezed)
                    return false;
            }
            if (preAvailability.condition === "!=") {
                if (preAvailability.operand !== "SAVED" && preAvailability.operand !== "FREEZED")
                    throw new Error(`Not Supprted! (isUnblindReqVisibility), visibility.operand === ${preAvailability.operand}`);
                else if (preAvailability.operand === "SAVED" && !!crf.isSaved)
                    return false;
                else if (preAvailability.operand === "FREEZED" && !!crf.isFreezed)
                    return false;
            }
        }
        else {
            throw new Error(`Not Supprted! (isUnblindReqVisibility), type === ${preAvailability.type}`);
        }
    }
    return true;
}
function isVisitVisibility(visibility, on) {
    var _a, _b;
    if (!on || !visibility)
        return true;
    if (typeof visibility === "object" && "operator" in visibility && "expr" in visibility) {
        const expr = visibility.expr;
        if (visibility.operator === "AND") {
            for (const exp of expr) {
                if (!isVisitVisibility(exp, on)) {
                    return false;
                }
            }
            return true;
        }
        else if (visibility.operator === "OR") {
            for (const exp of expr) {
                if (isVisitVisibility(exp, on)) {
                    return true;
                }
            }
            return false;
        }
    }
    else {
        if (visibility.type === "NORMAL_VISIT" || visibility.type === "UNSCHEDULED_VISIT" || visibility.type === "ALL_VISIT") {
            if (!on.visit)
                return true;
            if (visibility.type !== on.visit.folderType)
                return false;
            if (visibility.condition === "!=" && on.visit.visitCode === visibility.operand)
                return false;
            if (visibility.condition === "<" && on.visit.visitCode >= visibility.operand)
                return false;
            if (visibility.condition === "<=" && on.visit.visitCode > visibility.operand)
                return false;
            if (visibility.condition === ">" && on.visit.visitCode <= visibility.operand)
                return false;
            if (visibility.condition === ">=" && on.visit.visitCode < visibility.operand)
                return false;
            if (visibility.condition === "=" && on.visit.visitCode !== visibility.operand)
                return false;
        }
        else if (visibility.type === "ROLE") {
            if (!on.role)
                return true;
            if (visibility.condition === "=" && !visibility.operand.includes(on.role.studyRoleName))
                return false;
            if (visibility.condition === "!=" && visibility.operand.includes(on.role.studyRoleName))
                return false;
        }
        else if (visibility.type === "SITE_CODE") {
            if (!on.site)
                return true;
            if (visibility.condition === "=" && !visibility.operand.includes(on.site.siteCode))
                return false;
            if (visibility.condition === "!=" && visibility.operand.includes(on.site.siteCode))
                return false;
        }
        else if (visibility.type === "VISIT_SEQ") {
            return visitSeqCodeValidate(visibility, on.visitSeq);
        }
        else if (visibility.type === "VISIT_CODE") {
            return visitSeqCodeValidate(visibility, (_a = on.visitCode) !== null && _a !== void 0 ? _a : (_b = on.visit) === null || _b === void 0 ? void 0 : _b.visitCode);
        }
        else {
            throw new Error(`Not Supprted! (isVisitVisibility), type === ${visibility.type}`);
        }
    }
    return true;
    function visitSeqCodeValidate(visibility, visitCodeSeq) {
        if (!visitCodeSeq)
            return true;
        if ("value" in visibility) {
            const { operator, value } = visibility;
            if (operator === "<" && visitCodeSeq >= value)
                return false;
            if (operator === "<=" && visitCodeSeq > value)
                return false;
            if (operator === ">" && visitCodeSeq <= value)
                return false;
            if (operator === ">=" && visitCodeSeq < value)
                return false;
        }
        else if ("step" in visibility) {
            const { operator, step, initial } = visibility;
            if (operator === "=" && !new bignumber_js_1.default(visitCodeSeq).minus(initial).mod(step).isZero())
                return false;
            if (operator === "!=" && new bignumber_js_1.default(visitCodeSeq).minus(initial).mod(step).isZero())
                return false;
        }
        else if ("operand" in visibility) {
            const { operator, operand } = visibility;
            if (operator === "=" && !operand.includes(visitCodeSeq))
                return false;
            if (operator === "!=" && operand.includes(visitCodeSeq))
                return false;
        }
        return true;
    }
}
exports.CRF_VALUE_MAPPER_DATA_UNDEFINED = Symbol("AUDIT_TRAIL_DATA_UNDEFINED");
exports.CRF_VALUE_MAPPER_DATA_NULL = Symbol("AUDIT_TRAIL_DATA_NULL");
function getCrfValueByCrfCapturableItemSpec(value, itemSpec, opts) {
    var _a, _b;
    if (value === undefined) {
        return {
            data: exports.CRF_VALUE_MAPPER_DATA_UNDEFINED,
            text: "[Empty]",
        };
    }
    else if (value === null) {
        return {
            data: exports.CRF_VALUE_MAPPER_DATA_NULL,
            text: "[Null]",
        };
    }
    let uiVal;
    if (itemSpec && hasOwnProperty(itemSpec, "type")) {
        const itemOriginalSpec = itemSpec.original;
        if (itemOriginalSpec.type === "DATE" && typeof value === "string") {
            uiVal = edcDateFormat(value, itemOriginalSpec.format || "YYYY/MM/DD");
        }
        else if (itemOriginalSpec.type === "SINGLE_SELECT") {
            uiVal = ((_a = itemOriginalSpec.itemCode.codes.find(x => x.dbVal === value)) === null || _a === void 0 ? void 0 : _a.uiVal) || value;
        }
        else if (itemOriginalSpec.type === "CHECK") {
            const code = itemOriginalSpec.itemCode.codes.find(x => x.id === itemSpec.id && x.dbVal === value);
            uiVal = code && code.uiVal ? `${code.uiVal}(${value})` : value;
        }
        else if (itemOriginalSpec.type === "SYS_VAL") {
            const v = (0, dayjs_1.default)(value).utcOffset((opts === null || opts === void 0 ? void 0 : opts.timezoneOffset) || 0);
            if ((_b = itemOriginalSpec.format) === null || _b === void 0 ? void 0 : _b.reserved) {
                switch (itemOriginalSpec.format.reserved) {
                    case "TIMESTAMP":
                        uiVal = v.format("YYYY-MM-DD HH:mm:ss Z");
                        break;
                    case "YYYY/MM/DD":
                        uiVal = v.format("YYYY/MM/DD");
                        break;
                    case "YYYY-MM-DD":
                        uiVal = v.format("YYYY-MM-DD");
                        break;
                    case "YYYY-MM-DD:HH:mm:ss":
                        uiVal = v.format("YYYY-MM-DD:HH:mm:ss");
                        break;
                    default:
                        throw new Error(`Not Supported, {itemOriginalSpec.format?.reserved}(${itemOriginalSpec.format.reserved})`);
                }
            }
        }
        else if (itemOriginalSpec.type === "FORMATTED_TIME") {
            uiVal = getFormattedTimeUiVal(itemOriginalSpec, String(value || ""));
        }
        else if (itemOriginalSpec.type === "HIDDEN_VAL" && typeof value === "string" && isCrfDateItemFormat(itemOriginalSpec === null || itemOriginalSpec === void 0 ? void 0 : itemOriginalSpec.format)) {
            uiVal = edcDateFormat(value, itemOriginalSpec.format);
        }
        else if (itemOriginalSpec.type === "AUTO_TEXT" && typeof value === "string" && isCrfDateItemFormat(itemOriginalSpec === null || itemOriginalSpec === void 0 ? void 0 : itemOriginalSpec.format)) {
            uiVal = edcDateFormat(value, itemOriginalSpec.format);
        }
        else if (itemOriginalSpec.type === "SLIDER") {
            uiVal = `${value}`;
        }
    }
    return {
        data: value,
        text: uiVal || value,
    };
}
exports.getCrfValueByCrfCapturableItemSpec = getCrfValueByCrfCapturableItemSpec;
function crfValueMapper(itemId, value, studySpec, crfPage, opts) {
    return getCrfValueByCrfCapturableItemSpec(value, retrieveManageableItemSpec(studySpec, crfPage, itemId), opts);
}
exports.crfValueMapper = crfValueMapper;
function auditTrailReasonConverter(studySpec, type, key, typeText, lang) {
    const keyConverter = (key) => {
        var _a, _b;
        if (lang === "EN") {
            switch (key) {
                case __1.RefAuditReasonKey.StudySubjectInit:
                    return "Subject Initialization";
                case __1.RefAuditReasonKey.StudySubjectMigrate:
                    return "Subject Migrate";
                case __1.RefAuditReasonKey.StudySubjectCodingMigrated:
                    return "Subject Coding Migrate";
                case __1.RefAuditReasonKey.StudySubjectVisitInit:
                    return "Visit Initialization";
                case __1.RefAuditReasonKey.StudySubjectCrfInit:
                    return "CRF Initialization";
                case __1.RefAuditReasonKey.StudySubjectEdcDataCaptured:
                    return "Data save";
                case __1.RefAuditReasonKey.StudySubjectEdcDataStriked:
                    return "Strikethrough";
                case __1.RefAuditReasonKey.StudySubjectEdcDataUnStriked:
                    return "Off strikethrough";
                case __1.RefAuditReasonKey.StudySubjectEdcSdvAutoRelease:
                    return "SDV Auto release";
                case __1.RefAuditReasonKey.StudySubjectEdcEsignAutoRelease:
                    return "E-Sign Auto release";
                case __1.RefAuditReasonKey.StudySubjectCrfEsignOn:
                    return "Approved";
                case __1.RefAuditReasonKey.StudySubjectCrfEsignOff:
                    return "Canceled";
                case __1.RefAuditReasonKey.StudySubjectEdcSecondEsignAutoRelease: {
                    const audit = studySpec.criteria.audit;
                    return getCrfLabel((_a = audit.reasons.find(reason => { var _a; return reason.key === ((_a = studySpec.criteria.audit.crf.secondEsign) === null || _a === void 0 ? void 0 : _a.autoReleaseReason); })) === null || _a === void 0 ? void 0 : _a.text, "en");
                }
                case __1.RefAuditReasonKey.StudySubjectQueryAllowEmpty:
                    return "Allow Empty";
            }
        }
        else {
            switch (key) {
                case __1.RefAuditReasonKey.StudySubjectInit:
                    return "Subject 초기화";
                case __1.RefAuditReasonKey.StudySubjectMigrate:
                    return "Subject Migrate";
                case __1.RefAuditReasonKey.StudySubjectCodingMigrated:
                    return "Subject Coding Migrate";
                case __1.RefAuditReasonKey.StudySubjectVisitInit:
                    return "Visit 초기화";
                case __1.RefAuditReasonKey.StudySubjectCrfInit:
                    return "CRF 초기화";
                case __1.RefAuditReasonKey.StudySubjectEdcDataCaptured:
                    return "데이터 저장";
                case __1.RefAuditReasonKey.StudySubjectEdcDataStriked:
                    return "취소선";
                case __1.RefAuditReasonKey.StudySubjectEdcDataUnStriked:
                    return "취소선 해제";
                case __1.RefAuditReasonKey.StudySubjectEdcSdvAutoRelease:
                    return "SDV Auto release";
                case __1.RefAuditReasonKey.StudySubjectEdcEsignAutoRelease:
                    return "E-Sign Auto release";
                case __1.RefAuditReasonKey.StudySubjectCrfEsignOn:
                    return "승인";
                case __1.RefAuditReasonKey.StudySubjectCrfEsignOff:
                    return "승인 취소";
                case __1.RefAuditReasonKey.StudySubjectEdcSecondEsignAutoRelease: {
                    const audit = studySpec.criteria.audit;
                    return getCrfLabel((_b = audit.reasons.find(reason => { var _a; return reason.key === ((_a = studySpec.criteria.audit.crf.secondEsign) === null || _a === void 0 ? void 0 : _a.autoReleaseReason); })) === null || _b === void 0 ? void 0 : _b.text, "ko");
                }
                case __1.RefAuditReasonKey.StudySubjectQueryAllowEmpty:
                    return "입력 누락 허용";
            }
        }
        return false;
    };
    const dataReasonConverter = (key, typeText) => {
        if (!key)
            return "[Empty]";
        const reason = (() => {
            const defaultReason = keyConverter(key);
            if (defaultReason)
                return defaultReason;
            const found = studySpec.criteria.audit.reasons.find(r => r.key === key);
            if (!found)
                return `[${key || "Null"}]`;
            return getCrfLabel(found.text);
        })();
        const desc = typeText || null;
        return desc && String(reason).trim() !== String(desc).trim() ? `${reason} (${desc})` : reason;
    };
    const queryReasonConverter = (key, typeText) => {
        if (!key)
            return "[Empty]";
        const reason = (() => {
            const defaultReason = keyConverter(key);
            if (defaultReason)
                return defaultReason;
            const found = studySpec.criteria.query.reasons.find(r => r.key === key);
            if (!found)
                return `[${key || "Null"}]`;
            return getCrfLabel(found.text);
        })();
        const desc = typeText || null;
        return desc && String(reason).trim() !== String(desc).trim() ? `${reason} (${desc})` : reason;
    };
    const crfStatusReasonConverter = (key, typeText) => {
        if (!key)
            return "[Empty]";
        const reason = (() => {
            const defaultReason = keyConverter(key);
            if (defaultReason)
                return defaultReason;
            const found = studySpec.criteria.audit.reasons.find(r => r.key === key);
            if (!found)
                return `[${key || "Null"}]`;
            return getCrfLabel(found.text);
        })();
        const desc = (() => {
            const defaultReason = keyConverter(typeText);
            if (defaultReason)
                return defaultReason;
            const found = studySpec.criteria.audit.reasons.find(r => r.key === typeText);
            if (!found)
                return typeText;
            return getCrfLabel(found.text);
        })();
        return desc && String(reason).trim() !== String(desc).trim() ? `${reason} (${desc})` : reason;
    };
    const esignReasonConverter = (key, typeText) => {
        if (typeText)
            return typeText;
        return crfStatusReasonConverter(key, null);
    };
    if (type === entity_1.CrfAuditTrailType.Data) {
        return dataReasonConverter(key, typeText);
    }
    else if (type === entity_1.CrfAuditTrailType.Query) {
        return queryReasonConverter(key, typeText);
    }
    else if (type === entity_1.CrfAuditTrailType.SDV || type === entity_1.CrfAuditTrailType.Freezing || type === entity_1.CrfAuditTrailType.Locking) {
        return crfStatusReasonConverter(key, typeText);
    }
    else if (type === entity_1.CrfAuditTrailType.Esign || type === entity_1.CrfAuditTrailType.SecondEsign) {
        return esignReasonConverter(key, typeText);
    }
    else {
        throw new Error(`Not Expected CrfAuditTrailType! ${type}`);
    }
}
exports.auditTrailReasonConverter = auditTrailReasonConverter;
function auditTrailAuditMapper(crfAuditTrail, studySpec, path, opts) {
    if (crfAuditTrail.type === entity_1.CrfAuditTrailType.Data) {
        const crfPage = retrieveCrfPageByPath(studySpec, path);
        return crfValueMapper(crfAuditTrail.itemId, crfAuditTrail.audit.dbVal, studySpec, crfPage, opts).text;
    }
    else if (crfAuditTrail.type === entity_1.CrfAuditTrailType.Query) {
        const queryCapture = crfAuditTrail.audit;
        return `${(0, utils_1.readableStudyQueryStatus)(queryCapture.status)}: [${(0, utils_1.readableStudyQueryType)(queryCapture.type)}] ${queryCapture.message}`;
    }
    else if (crfAuditTrail.type === entity_1.CrfAuditTrailType.SDV) {
        return crfAuditTrail.audit;
    }
    else if (crfAuditTrail.type === entity_1.CrfAuditTrailType.Freezing) {
        return crfAuditTrail.audit;
    }
    else if (crfAuditTrail.type === entity_1.CrfAuditTrailType.Esign) {
        return crfAuditTrail.audit;
    }
    else if (crfAuditTrail.type === entity_1.CrfAuditTrailType.Locking) {
        return crfAuditTrail.audit;
    }
    else if (crfAuditTrail.type === entity_1.CrfAuditTrailType.SecondEsign) {
        return crfAuditTrail.audit;
    }
    else {
        throw new Error("Unexpected crfAuditTrail Type");
    }
}
exports.auditTrailAuditMapper = auditTrailAuditMapper;
function getItemDbVal(item, value) {
    if (item.type === "SINGLE_SELECT" && hasOwnProperty(item.original, "itemCode") && item.original.itemCode) {
        const found = item.original.itemCode.codes.find(code => {
            if (typeof code.dbVal === "number") {
                if (typeof value === "string") {
                    return value.replace(/[0-9]/g, "") !== "" ? false : code.dbVal === parseInt(value, 10);
                }
                else {
                    return code.dbVal === value;
                }
            }
            else if (typeof code.dbVal === "string") {
                return code.dbVal === String(value);
            }
            else {
                throw new Error("Not Supported!");
            }
        });
        if (found && found.dbVal !== undefined) {
            return found.dbVal;
        }
        else {
            return null;
        }
    }
    return value;
}
exports.getItemDbVal = getItemDbVal;
function getItemCalcVal(item, value) {
    if (item.type === "SINGLE_SELECT" && hasOwnProperty(item.original, "itemCode") && item.original.itemCode) {
        const found = item.original.itemCode.codes.find(code => code.dbVal === value);
        if (found && found.calcVal !== undefined) {
            return found.calcVal;
        }
        else {
            return null;
        }
    }
    return null;
}
exports.getItemCalcVal = getItemCalcVal;
function getItemVal(studySpec, folderId, visitId, crfPageId, itemId, value) {
    const crfPage = retrieveCrfPageByPath(studySpec, { folderId, visitId, crfPageId });
    const item = retrieveCapturableItemSpec(studySpec, crfPage, itemId);
    const dbVal = getItemDbVal(item, value);
    const calcVal = getItemCalcVal(item, dbVal);
    return { dbVal, calcVal };
}
exports.getItemVal = getItemVal;
function getCaptureItemReplaceConfirmMessage(confirm, dbVal) {
    let text = confirm.message;
    if (confirm.replace) {
        for (const replace of confirm.replace) {
            const toBe = (val => {
                if (val.reserved === "CAPTURED") {
                    return String(typeof dbVal === "number" || dbVal ? dbVal : "") || "Unknown";
                }
                else {
                    throw new Error(`Not supported, {unknownRef}(${JSON.stringify(val)})`);
                }
            })(replace.replace);
            const formatted = ((val, fmt) => {
                if (typeof val !== "number" && !val)
                    return val;
                else if (String(val).toUpperCase() === "UNKNOWN")
                    return val;
                else if (typeof val === "string" &&
                    (fmt === "YYYY/MM/DD" || fmt === "YYYY-MM-DD" || fmt === "YYYY/MM" || fmt === "YYYY-MM" || fmt === "YYYY" || fmt === "MMM/YYYY")) {
                    return edcDateFormat(val, fmt);
                }
                else {
                    return val;
                }
            })(toBe, replace.format);
            text = text.split(replace.find).join(formatted);
        }
    }
    return text;
}
exports.getCaptureItemReplaceConfirmMessage = getCaptureItemReplaceConfirmMessage;
function getCalculateRelatedIds(cals, on) {
    const relatedIds = [];
    getCalculateRelatedIdsInternal(cals, on, relatedIds);
    return (0, lodash_1.uniqWith)(relatedIds, (a, b) => a.groupId === b.groupId &&
        a.folderId === b.folderId &&
        a.visitId === b.visitId &&
        a.visitSeq === b.visitSeq &&
        a.crfPageId === b.crfPageId &&
        a.crfPageSeq === b.crfPageSeq &&
        a.sectionId === b.sectionId &&
        a.itemId === b.itemId &&
        a.itemSeq === b.itemSeq);
}
exports.getCalculateRelatedIds = getCalculateRelatedIds;
function getCalculateRelatedIdsInternal(cals, on, relatedIds) {
    if (!cals)
        return;
    for (const cal of arrayify(cals)) {
        if (!cal || typeof cal === "number" || typeof cal === "string")
            continue;
        if (hasOwnProperty(cal, "function")) {
            if (hasOwnProperty(cal, "operand")) {
                getCalculateRelatedIdsInternal(cal.operand, on, relatedIds);
            }
            else if (hasOwnProperty(cal, "operands")) {
                cal.operands.forEach(e => getCalculateRelatedIdsInternal(e, on, relatedIds));
            }
        }
        else {
            if (hasOwnProperty(cal, "operator") && !hasOwnProperty(cal, "expr")) {
                if (cal.left) {
                    arrayify(cal.left).forEach(e => getCalculateRelatedIdsInternal(e, on, relatedIds));
                }
                if (cal.right) {
                    arrayify(cal.right).forEach(e => getCalculateRelatedIdsInternal(e, on, relatedIds));
                }
            }
            if (hasOwnProperty(cal, "expr")) {
                cal.expr.forEach(e => getCalculateRelatedIdsInternal(e, on, relatedIds));
            }
            if (hasOwnProperty(cal, "condition")) {
                getCalculateRelatedIdsInternal(cal.left, on, relatedIds);
                getCalculateRelatedIdsInternal(cal.right, on, relatedIds);
            }
            if (hasOwnProperty(cal, "operand")) {
                const conditional = cal.conditional;
                if (conditional && hasOwnProperty(conditional, "condition")) {
                    getCalculateRelatedIdsInternal(conditional.left, on, relatedIds);
                    getCalculateRelatedIdsInternal(conditional.right, on, relatedIds);
                }
                if (conditional && hasOwnProperty(conditional, "operator")) {
                    conditional.expr.forEach(e => getCalculateRelatedIdsInternal(e, on, relatedIds));
                }
                if (typeof cal.operand === "object" && cal.operand) {
                    if (hasOwnProperty(cal.operand, "function") || hasOwnProperty(cal.operand, "operator")) {
                        return getCalculateRelatedIdsInternal(cal.operand, on, relatedIds);
                    }
                    if (hasOwnProperty(cal.operand, "folderId")) {
                        relatedIds.push({
                            groupId: on.groupId,
                            folderId: (() => {
                                if (typeof cal.operand.folderId === "string")
                                    return cal.operand.folderId;
                                else if (cal.operand.folderId.reserved === "CURRENT")
                                    return on.folderId;
                                throw new Error(`Not Supprted cal.operand.folderId(${cal.operand.folderId}), "getCalculateRelatedIdsInternal"`);
                            })(),
                            visitId: (() => {
                                if (typeof cal.operand.visitId === "string")
                                    return cal.operand.visitId;
                                else if (cal.operand.visitId.reserved === "CURRENT")
                                    return on.visitId;
                                throw new Error(`Not Supprted cal.operand.visitId(${cal.operand.visitId}), "getCalculateRelatedIdsInternal"`);
                            })(),
                            visitSeq: (() => {
                                if (typeof cal.operand.visitSeq === "number")
                                    return cal.operand.visitSeq;
                                else if (cal.operand.visitSeq.reserved === "CURRENT")
                                    return on.visitSeq;
                                throw new Error(`Not Supprted cal.operand.visitSeq(${cal.operand.visitSeq}), "getCalculateRelatedIdsInternal"`);
                            })(),
                            crfPageId: (() => {
                                if (typeof cal.operand.crfPageId === "string")
                                    return cal.operand.crfPageId;
                                throw new Error(`Not Supprted cal.operand.crfPageId(${cal.operand.crfPageId}), "getCalculateRelatedIdsInternal"`);
                            })(),
                            crfPageSeq: (() => {
                                if (!cal.operand.crfPageSeq)
                                    return common_1.InitialCrfPageSequence;
                                else if (typeof cal.operand.crfPageSeq === "number")
                                    return cal.operand.crfPageSeq;
                                else if (cal.operand.crfPageSeq.reserved === "CURRENT")
                                    return on.crfPageSeq;
                                throw new Error(`Not Supprted cal.operand.crfPageSeq(${cal.operand.crfPageSeq}), "getCalculateRelatedIdsInternal"`);
                            })(),
                            sectionId: cal.operand.sectionId,
                            itemId: cal.operand.itemId,
                            itemSeq: (() => {
                                if (typeof cal.operand.itemSeq === "number")
                                    return cal.operand.itemSeq;
                                else if (cal.operand.itemSeq.reserved === "CURRENT")
                                    return on.itemSeq;
                                throw new Error(`Not Supprted op.operand.itemSeq(${cal.operand.itemSeq}), "getOpVal"`);
                            })(),
                        });
                    }
                    else {
                        relatedIds.push({
                            groupId: on.groupId,
                            folderId: on.folderId,
                            visitId: on.visitId,
                            visitSeq: on.visitSeq,
                            crfPageId: on.crfPageId,
                            crfPageSeq: on.crfPageSeq,
                            sectionId: on.sectionId,
                            itemId: cal.operand.id,
                            itemSeq: cal.operand.sameSeq === true ? on.itemSeq : common_1.InitialItemSequence, // TODO: CrfSectionItemReference에 itemSeq 지정할 수 있도록 수정 필요
                        });
                    }
                }
            }
        }
    }
}
function getAuthorizedStudySites(studySites, privs, studyUserRole) {
    if (!studySites || !Array.isArray(studySites) || studySites.length === 0)
        return [];
    if ((0, utils_1.isAuthorized)(privs.allSiteAuthorized, studyUserRole)) {
        return studySites;
    }
    else if ((0, utils_1.isAuthorized)(privs.belongsSiteAuthorized, studyUserRole)) {
        return studySites.filter(studySite => studySite.isAuthorized);
    }
    else {
        return [];
    }
}
exports.getAuthorizedStudySites = getAuthorizedStudySites;
function getMedicalCodingColumnSpec(studySpec, medicalCodingSpec, columnName) {
    var _a, _b;
    const crfPageId = (_a = medicalCodingSpec.bind) === null || _a === void 0 ? void 0 : _a.id;
    const crfPage = crfPageId ? studySpec.pages[crfPageId] : null;
    const columnSpec = medicalCodingSpec.columns.find(e => e.column === columnName);
    const bindingItemId = (_b = columnSpec === null || columnSpec === void 0 ? void 0 : columnSpec.bind) === null || _b === void 0 ? void 0 : _b.id;
    const label = columnSpec === null || columnSpec === void 0 ? void 0 : columnSpec.label;
    const bindingItem = bindingItemId && crfPage ? retrieveCapturableItemSpec(studySpec, crfPage, bindingItemId) : null;
    return { label, bindingItem };
}
exports.getMedicalCodingColumnSpec = getMedicalCodingColumnSpec;
function getFormattedTimeUiVal(item, val) {
    const { hour, minute, second } = {
        hour: String(val || "").slice(0, 2) || "",
        minute: String(val || "").slice(2, 4) || "",
        second: String(val || "").slice(4, 6) || "",
    };
    const { separator, formatType } = item;
    return formatType === "HHmmss"
        ? `${hour}${(separator === null || separator === void 0 ? void 0 : separator.hourUiSuffix) || ""}${minute}${(separator === null || separator === void 0 ? void 0 : separator.minuteUiSuffix) || ""}${second}${(separator === null || separator === void 0 ? void 0 : separator.secondUiSuffix) || ""}`
        : formatType === "HHmm"
            ? `${hour}${(separator === null || separator === void 0 ? void 0 : separator.hourUiSuffix) || ""}${minute}${(separator === null || separator === void 0 ? void 0 : separator.minuteUiSuffix) || ""}`
            : formatType === "mmss"
                ? `${minute}${(separator === null || separator === void 0 ? void 0 : separator.minuteUiSuffix) || ""}${second}${(separator === null || separator === void 0 ? void 0 : separator.secondUiSuffix) || ""}`
                : "not-supported-format";
}
exports.getFormattedTimeUiVal = getFormattedTimeUiVal;
function isMatchedPostCaptureConditional(conditional, capturesItems, on) {
    if (conditional.operator === "AND") {
        for (const exp of conditional.expr) {
            const isOk = isMatchedPostCaptureConditional(exp, capturesItems, on);
            if (!isOk) {
                return false;
            }
        }
    }
    else if (conditional.operator === "OR") {
        for (const exp of conditional.expr) {
            if (isMatchedPostCaptureConditional(exp, capturesItems, on)) {
                return true;
            }
        }
        return false;
    }
    else if (conditional.operator === "!=" ||
        conditional.operator === "<" ||
        conditional.operator === "<=" ||
        conditional.operator === ">" ||
        conditional.operator === ">=" ||
        conditional.operator === "=") {
        const leftItem = ((left, on) => {
            if (!on.folderId || !on.visitId || !on.visitSeq || !on.crfPageId || !on.crfPageSeq)
                return null;
            if (typeof left === "string" || typeof left === "number")
                return left;
            else {
                return {
                    folderId: (() => {
                        if (typeof left.folderId === "string")
                            return left.folderId;
                        else if (left.folderId.reserved === "CURRENT")
                            return on.folderId;
                        throw new Error(`Not Supported left.folderId(${left.folderId}), "isMatchedPostCaptureConditional"`);
                    })(),
                    visitId: (() => {
                        if (typeof left.visitId === "string")
                            return left.visitId;
                        else if (left.visitId.reserved === "CURRENT")
                            return on.visitId;
                        throw new Error(`Not Supported left.visitId(${left.visitId}), "isMatchedPostCaptureConditional"`);
                    })(),
                    visitSeq: (() => {
                        if (left.visitSeq) {
                            if (typeof left.visitSeq === "number")
                                return left.visitSeq;
                            else if (left.visitSeq.reserved === "CURRENT")
                                return on.visitSeq;
                        }
                        return _1.InitialVisitSequence;
                    })(),
                    crfPageId: (() => {
                        if (typeof left.crfPageId === "string")
                            return left.crfPageId;
                        else if (left.crfPageId.reserved === "CURRENT")
                            return on.crfPageId;
                        throw new Error(`Not Supported left.crfPageId(${left.crfPageId}), "isMatchedPostCaptureConditional"`);
                    })(),
                    crfPageSeq: (() => {
                        if (left.crfPageSeq) {
                            if (typeof left.crfPageSeq === "number")
                                return left.crfPageSeq;
                            else if (left.crfPageSeq.reserved === "CURRENT")
                                return on.crfPageSeq;
                        }
                        return common_1.InitialCrfPageSequence;
                    })(),
                    sectionId: left.sectionId,
                    itemId: left.itemId,
                    itemSeq: left.itemSeq,
                };
            }
        })(conditional.left, on);
        const leftDbVal = ((leftItem, items) => {
            if (!leftItem)
                return null;
            else if (typeof leftItem === "string" || typeof leftItem === "number")
                return leftItem;
            else if ("folderId" in leftItem) {
                if (!leftItem.folderId || !leftItem.visitId || !leftItem.visitSeq || !leftItem.crfPageId || !leftItem.crfPageSeq)
                    return null;
                const found = items.find(item => item.folderId === leftItem.folderId &&
                    item.visitId === leftItem.visitId &&
                    item.visitSeq === leftItem.visitSeq &&
                    item.crfPageId === leftItem.crfPageId &&
                    item.crfPageSeq === leftItem.crfPageSeq &&
                    item.sectionId === leftItem.sectionId &&
                    item.itemId === leftItem.itemId &&
                    item.itemSeq === leftItem.itemSeq);
                return found ? found.dbVal : null;
            }
            return null;
        })(leftItem, capturesItems);
        const rightDbVal = conditional.right;
        if (!leftDbVal || !rightDbVal)
            return false;
        const comp = (() => {
            const op = conditional.operator;
            if (op === "=") {
                const l = typeof leftDbVal === "number" ? String(leftDbVal) : leftDbVal;
                const r = typeof rightDbVal === "number" ? String(rightDbVal) : rightDbVal;
                if (l === r)
                    return true;
            }
            else if (op === "!=") {
                const l = typeof leftDbVal === "number" ? String(leftDbVal) : leftDbVal;
                const r = typeof rightDbVal === "number" ? String(rightDbVal) : rightDbVal;
                if (l !== r)
                    return true;
            }
            else {
                if (typeof leftDbVal !== "number" || typeof rightDbVal !== "number") {
                    throw new Error(`leftDbVal: ${leftDbVal} or rightDbVal: ${rightDbVal} is not a number.`);
                }
                if (op === "<") {
                    if (new bignumber_js_1.default(leftDbVal).lt(rightDbVal))
                        return true;
                }
                else if (op === "<=") {
                    if (new bignumber_js_1.default(leftDbVal).lte(rightDbVal))
                        return true;
                }
                else if (op === ">") {
                    if (new bignumber_js_1.default(leftDbVal).gt(rightDbVal))
                        return true;
                }
                else if (op === ">=") {
                    if (new bignumber_js_1.default(leftDbVal).gte(rightDbVal))
                        return true;
                }
            }
            return false;
        })();
        return comp;
    }
    else {
        throw new Error(`Not Supported Error, conditional operator(${conditional.operator}), "isMatchedPostCaptureConditional"`);
    }
    return true;
}
exports.isMatchedPostCaptureConditional = isMatchedPostCaptureConditional;
//# sourceMappingURL=lib.js.map